webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(324);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(323);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueLocalstorage = __webpack_require__(321);
	
	var _vueLocalstorage2 = _interopRequireDefault(_vueLocalstorage);
	
	var _vueMaterial = __webpack_require__(322);
	
	var _vueMaterial2 = _interopRequireDefault(_vueMaterial);
	
	var _vuelidate = __webpack_require__(328);
	
	var _vuelidate2 = _interopRequireDefault(_vuelidate);
	
	__webpack_require__(259);
	
	var _vueScrollto = __webpack_require__(325);
	
	var _vueScrollto2 = _interopRequireDefault(_vueScrollto);
	
	var _store = __webpack_require__(20);
	
	var _App = __webpack_require__(275);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Login = __webpack_require__(289);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _PasswordChange = __webpack_require__(291);
	
	var _PasswordChange2 = _interopRequireDefault(_PasswordChange);
	
	var _Activate = __webpack_require__(276);
	
	var _Activate2 = _interopRequireDefault(_Activate);
	
	var _Portal = __webpack_require__(292);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _QuinyxLogInRedirect = __webpack_require__(293);
	
	var _QuinyxLogInRedirect2 = _interopRequireDefault(_QuinyxLogInRedirect);
	
	var _Admin = __webpack_require__(277);
	
	var _Admin2 = _interopRequireDefault(_Admin);
	
	var _MyAccount = __webpack_require__(290);
	
	var _MyAccount2 = _interopRequireDefault(_MyAccount);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _Auth = __webpack_require__(288);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _AdminUsers = __webpack_require__(285);
	
	var _AdminUsers2 = _interopRequireDefault(_AdminUsers);
	
	var _AdminApps = __webpack_require__(279);
	
	var _AdminApps2 = _interopRequireDefault(_AdminApps);
	
	var _AdminAppGroups = __webpack_require__(278);
	
	var _AdminAppGroups2 = _interopRequireDefault(_AdminAppGroups);
	
	var _AdminRoles = __webpack_require__(283);
	
	var _AdminRoles2 = _interopRequireDefault(_AdminRoles);
	
	var _AdminOrganizations = __webpack_require__(282);
	
	var _AdminOrganizations2 = _interopRequireDefault(_AdminOrganizations);
	
	var _AdminOrganizationAssignments = __webpack_require__(281);
	
	var _AdminOrganizationAssignments2 = _interopRequireDefault(_AdminOrganizationAssignments);
	
	var _AdminUsersTeam = __webpack_require__(286);
	
	var _AdminUsersTeam2 = _interopRequireDefault(_AdminUsersTeam);
	
	var _AdminTeams = __webpack_require__(284);
	
	var _AdminTeams2 = _interopRequireDefault(_AdminTeams);
	
	var _AuthorizationConfigurations = __webpack_require__(287);
	
	var _AuthorizationConfigurations2 = _interopRequireDefault(_AuthorizationConfigurations);
	
	var _AdminDocumentations = __webpack_require__(280);
	
	var _AdminDocumentations2 = _interopRequireDefault(_AdminDocumentations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = __webpack_require__(1);
	
	
	_vue2.default.use(_vueMaterial2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueLocalstorage2.default);
	_vue2.default.use(_vuelidate2.default);
	_vue2.default.use(_vueScrollto2.default);
	
	if (_utils2.default.isQuinyx()) {
	  _vue2.default.http.interceptors.push(function (request, next) {
	    request.withCredentials = true;
	    next();
	  });
	}
	
	_vue2.default.material.registerTheme({
	  default: {
	    primary: "blue",
	    accent: "blue",
	    warn: "blue",
	    background: "white"
	  }
	});
	
	_vue2.default.material.setCurrentTheme("default");
	
	function checkAdminRole(next) {
	  if (!_store.store.state.userId) {
	    _store.store.dispatch("getValidateToken");
	  }
	
	  if (!_store.store.state.user) {
	    _store.store.dispatch("getUser").then(function () {
	      if (_store.store.state.isAdmin) {
	        console.log("Pass");
	        next();
	      } else {
	        console.log("Not Pass");
	        next(false);
	      }
	    }).catch(function () {
	      console.log("ERROR");
	      next(false);
	    });
	  } else {
	    if (_store.store.state.isAdmin) {
	      console.log("PASS");
	      next();
	    } else {
	      console.log("Not Pass");
	      next(false);
	    }
	  }
	}
	
	var routes = [{ path: "/portal", name: "portal", component: _Portal2.default }, {
	  path: "/admin",
	  name: "admin",
	  component: _Admin2.default,
	  beforeEnter: function beforeEnter(to, from, next) {
	    checkAdminRole(next);
	  },
	  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
	    checkAdminRole(next);
	  },
	  children: [{ path: "users", name: "users", component: _AdminUsers2.default }, { path: "apps", name: "apps", component: _AdminApps2.default }, { path: "app-groups", name: "app-groups", component: _AdminAppGroups2.default }, { path: "roles", name: "roles", component: _AdminRoles2.default }, {
	    path: "organizations",
	    name: "organizations",
	    component: _AdminOrganizations2.default
	  }, {
	    path: "organizations-assignments",
	    name: "organizations-assignments",
	    component: _AdminOrganizationAssignments2.default
	  }, {
	    path: "team-assignments",
	    name: "team-assignments",
	    component: _AdminUsersTeam2.default
	  }, { path: "teams", name: "teams", component: _AdminTeams2.default }, {
	    path: "auth-configs",
	    name: "auth-configs",
	    component: _AuthorizationConfigurations2.default
	  }],
	  redirect: { name: "users" }
	}, { path: "/login", name: "login", component: _Login2.default }, {
	  path: "/quinyx-sign-in",
	  name: "quinyx-sign-in",
	  component: _QuinyxLogInRedirect2.default
	}, { path: "/my-account", name: "my-account", component: _MyAccount2.default }, { path: "/externallogin", name: "externallogin", component: _Login2.default }, {
	  path: "/passwordchange",
	  name: "passwordchange",
	  component: _PasswordChange2.default
	}, { path: "/activate", name: "activate", component: _Activate2.default }, { path: "/auth", name: "auth", component: _Auth2.default }, { path: "*", redirect: { name: "portal" } }];
	
	var router = new _vueRouter2.default({ routes: routes });
	
	var loginRoute = window === window.top ? "/login" : "/externallogin";
	var checkWhiteList = function checkWhiteList(path) {
	  var list = ["/login", "/activate", "/passwordchange", "/auth", "/externallogin"];
	  return list.indexOf(path) !== -1;
	};
	var setCurrentNav = function setCurrentNav(path) {
	  var currentItem = _store.store.state.navbarItems.find(function (item) {
	    return item.url === path;
	  });
	  if (!currentItem) {
	    currentItem = _store.store.state.forecastItems.find(function (item) {
	      return item.url === path;
	    });
	  }
	  _store.store.commit({
	    type: "SET_ACTIVE_LINK",
	    currentItem: currentItem
	  });
	};
	var routeChecks = function routeChecks() {
	  if (!_store.store.state.user) _store.store.dispatch("getUser");
	  if (new URL(window.location.href).searchParams.get("access_token")) window.history.replaceState({}, "", "/");
	};
	
	// Router Guard
	if (_utils2.default.isQuinyx()) {
	  router.beforeEach(function (to, from, next) {
	    var isWhiteListed = checkWhiteList(to.path);
	    _store.store.dispatch("getValidateToken").then(function () {
	      routeChecks();
	      if (to.path === "/login") {
	        next("/portal");
	      } else {
	        setCurrentNav(to.path);
	        next();
	      }
	    }).catch(function () {
	      if (isWhiteListed) {
	        next();
	      } else {
	        next(loginRoute);
	      }
	    });
	  });
	} else {
	  router.beforeEach(function (to, from, next) {
	    var token = _store.store.state.WBToken || localStorage.getItem("WBToken");
	    var isWhiteListed = checkWhiteList(to.path);
	    if (token) {
	      _store.store.dispatch("getValidateToken").then(function () {
	        routeChecks();
	        if (to.path === "/login") {
	          next("/portal");
	        } else {
	          setCurrentNav(to.path);
	          next();
	        }
	      }).catch(function () {
	        _store.store.dispatch("logout");
	        next(loginRoute);
	      });
	    } else {
	      if (isWhiteListed) {
	        next();
	      } else {
	        next(loginRoute);
	      }
	    }
	  });
	}
	
	_vue2.default.filter("dateFormat", function (value) {
	  if (moment(value).isValid()) return moment(value).format("DD/MM/YYYY HH:mm");else return null;
	});
	
	/* eslint-disable no-new */
	new _vue2.default({
	  el: "#app",
	  store: _store.store,
	  router: router,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _params = __webpack_require__(10);
	
	var _params2 = _interopRequireDefault(_params);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = _params2.default.getParameterValue("API_URL");
	var loginUrl = _params2.default.getParameterValue("API_URL");
	var loggerUrl = _params2.default.getParameterValue("LOGGER_URL");
	var uiUrl = _params2.default.getParameterValue("UI_URL");
	
	exports.default = {
	  login: function login(user, customApiUrl) {
	    var url = loginUrl + "/api/WBUsers/login";
	    if (customApiUrl) {
	      url = customApiUrl + "WBUsers/login";
	    }
	    return _utils2.default.post(url, [], user);
	  },
	  logout: function logout(customApiUrl) {
	    var url = loginUrl + "/api/WBUsers/logoutUser";
	    if (customApiUrl) {
	      url = customApiUrl + "WBUsers/logoutUser";
	    } else {
	      _utils2.default.get(loginUrl + "/auth/openid/logout", []);
	    }
	    return _utils2.default.post(url, [], []);
	  },
	  forgotPassword: function forgotPassword(email, customApiUrl) {
	    var creds = {
	      email: email,
	      location: uiUrl
	    };
	    var url = apiUrl + "/api/WBUsers/reset";
	    if (customApiUrl) {
	      url = customApiUrl + "WBUsers/reset";
	    }
	    return _utils2.default.post(url, [], creds);
	  },
	  resetPassword: function resetPassword(password, token, customApiUrl) {
	    var urlString = apiUrl + "/api/WBUsers/passwordReset";
	    if (customApiUrl) {
	      urlString = customApiUrl + "WBUsers/passwordReset";
	    }
	    var params = [];
	    params.push({ key: "access_token", value: token });
	
	    for (var i = 0; i < params.length; i++) {
	      i === 0 ? urlString += "?" : urlString += "&";
	
	      urlString += params[i].key + "=" + params[i].value;
	    }
	
	    return new Promise(function (resolve, reject) {
	      _vue2.default.http.post(urlString, { password: password }).then(function (res) {
	        resolve(res);
	      }, function (err) {
	        reject(err);
	      });
	    });
	  },
	  changePassword: function changePassword(userId, oldPassword, newPassword, customApiUrl) {
	    var url = apiUrl + "/api/WBUsers/changePassword";
	    if (customApiUrl) {
	      urlString = customApiUrl + "WBUsers/changePassword";
	    }
	    return _utils2.default.post(url, [], { userId: userId, oldPassword: oldPassword, newPassword: newPassword });
	  },
	  validateOldPassword: function validateOldPassword(oldPassword) {
	    var url = apiUrl + "/api/WBUsers/validateOldPassword";
	    return _utils2.default.get(url, [{ key: "oldPassword", value: oldPassword }]);
	  },
	  validatePassword: function validatePassword(password) {
	    var url = apiUrl + "/api/WBUsers/validateNewPassword";
	    return _utils2.default.get(url, [{ key: "password", value: password }]);
	  },
	  validateUsername: function validateUsername(email, username) {
	    var url = apiUrl + "/api/WBUsers/validateNewUsername";
	    return _utils2.default.get(url, [{ key: "email", value: email }, { key: "username", value: username }]);
	  },
	  validateFullName: function validateFullName(fullName) {
	    var url = apiUrl + "/api/WBUsers/validateFullName";
	    return _utils2.default.get(url, [{ key: "fullName", value: fullName }]);
	  },
	  validateToken: function validateToken() {
	    var url = apiUrl + "/api/WBUsers/validateToken";
	    return _utils2.default.get(url, []);
	  },
	  checkActivateKeyEmail: function checkActivateKeyEmail(email, key) {
	    var url = apiUrl + "/api/WBUsers/validateParameters";
	    return _utils2.default.get(url, [{ key: "key", value: key }, { key: "email", value: email }]);
	  },
	  getDescriptionValues: function getDescriptionValues(email, key) {
	    var url = apiUrl + "/api/WBUsers/activationDetails";
	    return _utils2.default.get(url, [{ key: "key", value: key }, { key: "email", value: email }]);
	  },
	  activateUser: function activateUser(newUser) {
	    var url = apiUrl + "/api/WBUsers/activate";
	    return _utils2.default.post(url, [], newUser);
	  },
	  resendKey: function resendKey(email) {
	    var url = apiUrl + "/api/WBUsers/resendKey";
	    return _utils2.default.post(url, [], { email: email });
	  },
	  getUser: function getUser(id) {
	    var url = loginUrl + "/api/WBUsers/" + id;
	    return _utils2.default.get(url, [{ key: "filter[include]", value: "appAssignments" }, { key: "filter[include]", value: "team" }]);
	  },
	  getAssignments: function getAssignments() {
	    var url = apiUrl + "/api/WBApps/user/assignments";
	    return _utils2.default.get(url, []);
	  },
	  createUserTeamAssignments: function createUserTeamAssignments(data) {
	    var url = apiUrl + "/api/UserTeamAssignments";
	    return _utils2.default.post(url, [], data);
	  },
	  getUserTeamAssignments: function getUserTeamAssignments() {
	    var url = apiUrl + "/api/UserTeamAssignments";
	    return _utils2.default.get(url, []);
	  },
	  updateUserTeamAssignments: function updateUserTeamAssignments(data) {
	    var url = apiUrl + "/api/UserTeamAssignments";
	    return _utils2.default.put(url, [], data);
	  },
	  deleteUserTeamAssignments: function deleteUserTeamAssignments(id) {
	    var url = apiUrl + "/api/UserTeamAssignments";
	    return _utils2.default.delete(url, id);
	  },
	  getApps: function getApps() {
	    var url = apiUrl + "/api/WBApps/user/apps";
	    return _utils2.default.get(url, []);
	  },
	  getGroupedApps: function getGroupedApps() {
	    var url = apiUrl + "/api/WBApps/user/apps/grouped";
	    return _utils2.default.get(url, []);
	  },
	  getAppGroups: function getAppGroups() {
	    var url = apiUrl + "/api/WBAppGroups";
	    return _utils2.default.get(url, []);
	  },
	  createAppGroup: function createAppGroup(data) {
	    var url = apiUrl + "/api/WBAppGroups";
	    return _utils2.default.post(url, [], data);
	  },
	  updateAppGroup: function updateAppGroup(data) {
	    var url = apiUrl + "/api/WBAppGroups";
	    return _utils2.default.put(url, [], data);
	  },
	  deleteAppGroup: function deleteAppGroup(id) {
	    var url = apiUrl + "/api/WBAppGroups/" + id;
	    return _utils2.default.delete(url, []);
	  },
	  getUserStatuses: function getUserStatuses() {
	    var url = apiUrl + "/api/WBUsers/allStatuses";
	    return _utils2.default.get(url, []);
	  },
	  getUsers: function getUsers() {
	    var url = apiUrl + "/api/WBUsers/instance";
	    return _utils2.default.get(url, [{ key: "filter[include]", value: "team" }]);
	  },
	  getUserLogs: function getUserLogs() {
	    var url = loggerUrl + "api/eventsLogs/getPersonalLog";
	    return _utils2.default.get(url, []);
	  },
	  updateUser: function updateUser(user) {
	    var url = apiUrl + "/api/WBUsers/instance";
	    return _utils2.default.put(url, [], user);
	  },
	  updateUserTeams: function updateUserTeams(data) {
	    var url = apiUrl + "/api/Teams/user/assign";
	    return _utils2.default.post(url, [], data);
	  },
	  updateTeamsAssignment: function updateTeamsAssignment(data) {
	    var url = apiUrl + "/api/Teams/child/assign";
	    return _utils2.default.post(url, [], data);
	  },
	  deleteUser: function deleteUser(id) {
	    var url = apiUrl + "/api/WBUsers/instance";
	    return _utils2.default.delete(url, id);
	  },
	  deleteUserTeam: function deleteUserTeam(data) {
	    var url = apiUrl + "/api/Teams/user/unassign";
	    return _utils2.default.post(url, [], data);
	  },
	  deleteFromParentTeam: function deleteFromParentTeam(data) {
	    var url = apiUrl + "/api/Teams/child/unassign";
	    return _utils2.default.post(url, [], data);
	  },
	  getRoles: function getRoles(id) {
	    var url = "";
	    var params = [];
	    if (id) {
	      url = apiUrl + "/api/WBApps/roles";
	      params.push({ key: "appId", value: id });
	    } else {
	      url = apiUrl + "/api/UserAppAssignments";
	      params.push({
	        key: "filter",
	        value: "%7B%22include%22%3A[%22app%22,%22user%22]%7D"
	      });
	    }
	    return _utils2.default.get(url, params);
	  },
	  createUserFromApp: function createUserFromApp(user) {
	    var url = apiUrl + "/api/WBUsers/createFromApp";
	    return _utils2.default.post(url, [], user);
	  },
	  createUserFromQuinyxApp: function createUserFromQuinyxApp(user) {
	    var url = apiUrl + "/api/WBUsers/createActivatedUser";
	    return _utils2.default.post(url, [], user);
	  },
	  createApp: function createApp(app) {
	    var url = apiUrl + "/api/WBApps";
	    return _utils2.default.post(url, [], app);
	  },
	  updateApp: function updateApp(app) {
	    var url = apiUrl + "/api/WBApps";
	    return _utils2.default.put(url, [], app);
	  },
	  deleteApp: function deleteApp(app) {
	    var url = apiUrl + "/api/WBApps";
	    return _utils2.default.delete(url, app.id);
	  },
	  createRole: function createRole(role) {
	    var url = apiUrl + "/api/UserAppAssignments";
	    return _utils2.default.post(url, [], role);
	  },
	  updateRole: function updateRole(role) {
	    var url = apiUrl + "/api/UserAppAssignments";
	    return _utils2.default.put(url, [], role);
	  },
	  deleteRole: function deleteRole(role) {
	    var url = apiUrl + "/api/UserAppAssignments";
	    return _utils2.default.delete(url, role.id);
	  },
	  getOrganisationById: function getOrganisationById(id) {
	    var url = apiUrl + "/api/Organizations/" + id;
	    return _utils2.default.get(url, []);
	  },
	  getOrganizations: function getOrganizations() {
	    var url = apiUrl + "/api/Organizations";
	    return _utils2.default.get(url, []);
	  },
	  createOrganization: function createOrganization(organization) {
	    var url = apiUrl + "/api/Organizations";
	    return _utils2.default.post(url, [], organization);
	  },
	  updateOrganization: function updateOrganization(organization) {
	    var url = apiUrl + "/api/Organizations";
	    return _utils2.default.put(url, [], organization);
	  },
	  deleteOrganization: function deleteOrganization(organization) {
	    var url = apiUrl + "/api/Organizations";
	    return _utils2.default.delete(url, organization.id);
	  },
	  getOrganizationAssignments: function getOrganizationAssignments() {
	    var params = [];
	    var url = apiUrl + "/api/UserOrganizationAssignments";
	    params.push({
	      key: "filter",
	      value: "%7B%22include%22%3A[%22organization%22,%22user%22]%7D"
	    });
	    return _utils2.default.get(url, params);
	  },
	  createOrganizationAssignment: function createOrganizationAssignment(organizationAssignment) {
	    var url = apiUrl + "/api/UserOrganizationAssignments";
	    return _utils2.default.post(url, [], organizationAssignment);
	  },
	  updateOrganizationAssignment: function updateOrganizationAssignment(organizationAssignment) {
	    var url = apiUrl + "/api/UserOrganizationAssignments";
	    return _utils2.default.put(url, [], organizationAssignment);
	  },
	  deleteOrganizationAssignment: function deleteOrganizationAssignment(organizationAssignment) {
	    var url = apiUrl + "/api/UserOrganizationAssignments";
	    return _utils2.default.delete(url, organizationAssignment.id);
	  },
	
	  allowedOrganizationsAndAlgorithmUsers: function allowedOrganizationsAndAlgorithmUsers() {
	    var url = apiUrl + "/api/organizations/allowedOrganizationsAndAlgorithmUsers";
	    return _utils2.default.get(url, []);
	  },
	  getTeams: function getTeams() {
	    var url = apiUrl + "/api/Teams/getList";
	    return _utils2.default.get(url, []);
	  },
	  getTeamById: function getTeamById(teamId) {
	    var url = apiUrl + "/api/Teams/" + teamId;
	    return _utils2.default.get(url, []);
	  },
	  getAssignedTeams: function getAssignedTeams() {
	    var url = apiUrl + "/api/TeamChildAssignments";
	    return _utils2.default.get(url, []);
	  },
	
	  createAuth0Audience: function createAuth0Audience(data) {
	    var url = apiUrl + "/api/WBApps/createAuth0Audience";
	    return _utils2.default.post(url, [], data);
	  },
	  deleteAuth0Audience: function deleteAuth0Audience(data) {
	    var url = apiUrl + "/api/WBApps/deleteAuth0Audience";
	    return _utils2.default.delete(url, [], data);
	  },
	  getHighestUsedIdentifierInCategory: function getHighestUsedIdentifierInCategory(category) {
	    var url = loginUrl + "/api/WBApps/getHighestUsedIdentifierInCategory";
	    return _utils2.default.get(url, [{ key: "algorithmCategory", value: category }]);
	  },
	  getAppByAlgorithmKey: function getAppByAlgorithmKey(algorithmKey) {
	    var url = loginUrl + "/api/WBApps/getAppByAlgorithmKey";
	    return _utils2.default.get(url, [{ key: "algorithmKey", value: algorithmKey }]);
	  },
	  resetAuth0Credentials: function resetAuth0Credentials(userId) {
	    var url = apiUrl + "/api/WBUsers/resetAuth0Secret";
	    return _utils2.default.post(url, [], { userId: userId });
	  },
	  getAuthConfigs: function getAuthConfigs() {
	    var url = apiUrl + "/api/AuthConfigs";
	    return _utils2.default.get(url, []);
	  },
	  updateAuthConfig: function updateAuthConfig(data) {
	    var url = apiUrl + "/api/AuthConfigs";
	    return _utils2.default.put(url, [], data);
	  },
	  deleteAuthConfig: function deleteAuthConfig(id) {
	    var url = apiUrl + "/api/AuthConfigs/" + id;
	    return _utils2.default.delete(url, []);
	  },
	  saveAuthConfig: function saveAuthConfig(data) {
	    var url = apiUrl + "/api/AuthConfigs";
	    return _utils2.default.post(url, [], data);
	  },
	  registerAuthConfigs: function registerAuthConfigs(id) {
	    var url = apiUrl + "/api/AuthConfigs/register";
	    return _utils2.default.post(url, [], { id: id });
	  },
	  getSsoOptions: function getSsoOptions() {
	    var url = apiUrl + "/api/AuthConfigs/getList";
	    return _utils2.default.get(url, []);
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(245)
	__webpack_require__(246)
	
	/* script */
	__vue_exports__ = __webpack_require__(167)
	
	/* template */
	var __vue_template__ = __webpack_require__(312)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "dataTable"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-668012c0"
	
	module.exports = __vue_exports__


/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import utils from "../helpers/utils"
	
	exports.default = {
	  token: function token() {
	    return _store.store.state.WBToken || localStorage.getItem("WBToken");
	  },
	  isQuinyx: function isQuinyx() {
	    return ("public") === "quinyx";
	  },
	  get: function get(url, params) {
	    var urlString = url;
	    var token = this.token();
	
	    if (!this.isQuinyx() || this.isQuinyx() && token) {
	      params.push({ key: "access_token", value: token });
	    }
	
	    for (var i = 0; i < params.length; i++) {
	      i === 0 ? urlString += "?" : urlString += "&";
	
	      urlString += params[i].key + "=" + params[i].value;
	    }
	
	    return new Promise(function (resolve, reject) {
	      _vue2.default.http.get(urlString).then(function (res) {
	        resolve(res);
	      }, function (err) {
	        reject(err);
	      });
	    });
	  },
	  post: function post(url, params, data) {
	    var urlString = url;
	    var token = this.token();
	
	    if (!this.isQuinyx() || this.isQuinyx() && token) {
	      params.push({ key: "access_token", value: token });
	    }
	
	    for (var i = 0; i < params.length; i++) {
	      i === 0 ? urlString += "?" : urlString += "&";
	
	      urlString += params[i].key + "=" + params[i].value;
	    }
	    return new Promise(function (resolve, reject) {
	      _vue2.default.http.post(urlString, data).then(function (res) {
	        resolve(res);
	      }, function (err) {
	        reject(err);
	      });
	    });
	  },
	  put: function put(url, params, data) {
	    var urlString = url;
	    var token = this.token();
	
	    if (!this.isQuinyx() || this.isQuinyx() && token) {
	      params.push({ key: "access_token", value: token });
	    }
	
	    for (var i = 0; i < params.length; i++) {
	      i === 0 ? urlString += "?" : urlString += "&";
	
	      urlString += params[i].key + "=" + params[i].value;
	    }
	
	    return new Promise(function (resolve, reject) {
	      _vue2.default.http.put(urlString, data).then(function (res) {
	        resolve(res);
	      }, function (err) {
	        reject(err);
	      });
	    });
	  },
	  delete: function _delete(url, id, params) {
	    var urlString = "" + url;
	    if (id) {
	      urlString = url + "/" + id;
	    }
	    var token = this.token();
	
	    if (!this.isQuinyx() || this.isQuinyx() && token) {
	      urlString += "?access_token=" + token;
	    }
	
	    if (params) {
	      for (var i = 0; i < params.length; i++) {
	        var delimeter = urlString.includes("?") ? "&" : "?";
	        urlString += "" + delimeter + params[i].key + "=" + params[i].value;
	      }
	    }
	
	    return new Promise(function (resolve, reject) {
	      _vue2.default.http.delete(urlString).then(function (res) {
	        resolve(res);
	      }, function (err) {
	        reject(err);
	      });
	    });
	  },
	  formatDate: function formatDate(dates) {
	    if (dates && dates !== "-") {
	      var date = new Date(dates);
	      var hours = date.getHours();
	      var minutes = date.getMinutes();
	      var ampm = hours >= 12 ? "pm" : "am";
	      hours = hours % 12;
	      hours = hours ? hours : 12; // the hour '0' should be '12'
	      minutes = minutes < 10 ? "0" + minutes : minutes;
	      var strTime = hours + ":" + minutes + " " + ampm;
	      return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() + " " + strTime;
	    } else {
	      return "-";
	    }
	  }
	};

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var QUINYX_ALFA_ID = "quinyx";
	
	exports.default = {
	  getParameterValue: function getParameterValue(name) {
	    var value = void 0;
	    if (("public") === QUINYX_ALFA_ID) {
	      value = config[name];
	    } else {
	      value = ({"API_URL":'https://wb-core-u.widgetbrain.io',"UI_URL":'https://apps-u.widgetbrain.io',"LOGGER_URL":'https://wb-logger.widgetbrain.io/',"ENVIRONMENT_NAME":'production',"APP_ID":"10"})[name];
	    }
	    return value;
	  }
	};

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var mainWebsiteUrl = 'https://widgetbrain.com/';
	
	exports.default = {
	  systemStatusUrl: mainWebsiteUrl + 'status',
	  faqUrl: mainWebsiteUrl + 'support',
	  widgetBrainSupportEmail: 'support@widgetbrain.com',
	  auth0Config: {
	    "domain": "widgetbrain.eu.auth0.com",
	    "clientID": "DcoDtviEjVrrIWYYOy7pET97xWVGY4xx"
	  }
	};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = undefined;
	
	var _mutations;
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	var _params = __webpack_require__(10);
	
	var _params2 = _interopRequireDefault(_params);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _navbarPermissions = __webpack_require__(192);
	
	var _navbarPermissions2 = _interopRequireDefault(_navbarPermissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	_vue2.default.use(_vuex2.default);
	
	var START_REQUEST = "START_REQUEST";
	var FINISH_REQUEST = "FINISH_REQUEST";
	var LOGIN_SUCCESS = "LOGIN_SUCCESS";
	var LOGIN_ERROR = "LOGIN_ERROR";
	var LOGIN_FAILED = "LOGIN_FAILED";
	var LOGOUT = "LOGOUT";
	var SET_ROUTE = "SET_ROUTE";
	var SET_USER = "SET_USER";
	var SET_ROLE = "SET_ROLE";
	var CHANGE_ROUTE = "CHANGE_ROUTE";
	var CLEAR_MESSAGE = "CLEAR_MESSAGE";
	var CLEAR_ERROR_DIALOG_MESSAGE = "CLEAR_ERROR_DIALOG_MESSAGE";
	var SET_ACTIVE_LINK = "SET_ACTIVE_LINK";
	var SET_MESSAGE = "SET_MESSAGE";
	var SET_APPS = "SET_APPS";
	var SET_GROUPED_APPS = "SET_GROUPED_APPS";
	var SET_SELECTED_CATEGORIES = "SET_SELECTED_CATEGORIES";
	var SET_CATEGORIES = "SET_CATEGORIES";
	var SET_ASSIGNMENTS = "SET_ASSIGNMENTS";
	var SET_ALLOWED_ORG_AND_ALGORITHMS = "SET_ALLOWED_ORG_AND_ALGORITHMS";
	var SET_USER_STATUSES = "SET_USER_STATUSES";
	var SET_USERS = "SET_USERS";
	var SET_ROLES = "SET_ROLES";
	var SET_ORGANIZATIONS = "SET_ORGANIZATIONS";
	var SET_TEAMS = "SET_TEAMS";
	var SET_TEAMSASSIGNED = "SET_TEAMSASSIGNED";
	var SET_IS_ADMIN = "SET_IS_ADMIN";
	var SET_ORGANIZATION_ASSIGNMENT = "SET_ORGANIZATION_ASSIGNMENT";
	var LOGIN_FAILED_PERMISSION_DENIED = "LOGIN_FAILED_PERMISSION_DENIED";
	var SET_AUDIENCES = "SET_AUDIENCES";
	var SET_PROTOCOLS = "SET_PROTOCOLS";
	var SET_INVOCATION_TYPES = "SET_INVOCATION_TYPES";
	var SET_PLATFORMS = "SET_PLATFORMS";
	var SET_REGIONS_FOR_PLATFORMS = "SET_REGIONS_FOR_PLATFORMS";
	var SET_CUSTOM_API_URL = "SET_CUSTOM_API_URL";
	var SET_USERS_TEAM_ASSIGNMENTS = "SET_USERS_TEAM_ASSIGNMENTS";
	var SET_USERID = "SET_USERID";
	
	var strict = ("production") !== "production";
	
	var getters = {
	  WBToken: function WBToken(state) {
	    return state.WBToken;
	  },
	  userId: function userId(state) {
	    return state.userId;
	  },
	  user: function user(state) {
	    return state.user;
	  },
	  role: function role(state) {
	    return state.role;
	  },
	  message: function message(state) {
	    return state.message;
	  },
	  messageRandom: function messageRandom(state) {
	    return state.messageRandom;
	  },
	  dialogErrorMessage: function dialogErrorMessage(state) {
	    return state.dialogErrorMessage;
	  },
	  dialogErrorMessageRandom: function dialogErrorMessageRandom(state) {
	    return state.dialogErrorMessageRandom;
	  },
	  dialogErrorCode: function dialogErrorCode(state) {
	    return state.dialogErrorCode;
	  },
	  pending: function pending(state) {
	    return state.pending;
	  },
	  route: function route(state) {
	    return state.route;
	  },
	  isLoggedIn: function isLoggedIn(state) {
	    return state.isLoggedIn;
	  },
	  navbarItems: function navbarItems(state) {
	    return state.navbarItems.concat(state.forecastItems).filter(function (item) {
	      return _navbarPermissions2.default[item.access] ? _navbarPermissions2.default[item.access](state) : false;
	    });
	  },
	  profileMenuItems: function profileMenuItems(state) {
	    if (state.isAdmin) {
	      if (!_utils2.default.isQuinyx()) {
	        return state.profileMenuItems;
	      } else {
	        return state.profileMenuItems.filter(function (item) {
	          return item.url !== "/logout";
	        });
	      }
	    } else {
	      if (!_utils2.default.isQuinyx()) {
	        return state.profileMenuItems.filter(function (item) {
	          return item.url !== "/admin";
	        });
	      } else {
	        return state.profileMenuItems.filter(function (item) {
	          return item.url !== "/admin" && item.url !== "/logout";
	        });
	      }
	    }
	  },
	  apps: function apps(state) {
	    return state.apps;
	  },
	  groupedApps: function groupedApps(state) {
	    return state.groupedApps;
	  },
	  selectedCategories: function selectedCategories(state) {
	    return state.selectedCategories;
	  },
	  categories: function categories(state) {
	    return state.categories;
	  },
	  assignments: function assignments(state) {
	    return state.assignments;
	  },
	  userStatuses: function userStatuses(state) {
	    return state.userStatuses;
	  },
	  users: function users(state) {
	    return state.users;
	  },
	  roles: function roles(state) {
	    return state.roles;
	  },
	  organizations: function organizations(state) {
	    return state.organizations;
	  },
	  teams: function teams(state) {
	    return state.teams;
	  },
	  teamsAssigned: function teamsAssigned(state) {
	    return state.teamsAssigned;
	  },
	  organizationAssignments: function organizationAssignments(state) {
	    return state.organizationAssignments;
	  },
	  isAdmin: function isAdmin(state) {
	    return state.isAdmin;
	  },
	  audiences: function audiences(state) {
	    return state.audiences;
	  },
	  protocols: function protocols(state) {
	    return state.protocols;
	  },
	  invocationTypes: function invocationTypes(state) {
	    return state.invocationTypes;
	  },
	  platforms: function platforms(state) {
	    return state.platforms;
	  },
	  regionsForPlatforms: function regionsForPlatforms(state) {
	    return state.regionsForPlatforms;
	  },
	  userTeamAssignments: function userTeamAssignments(state) {
	    return state.userTeamAssignments;
	  }
	};
	
	var actions = {
	  setupToken: function setupToken(_ref, creds) {
	    var commit = _ref.commit;
	
	    commit(START_REQUEST);
	    var neededRoute = this.state.navbarItems.find(function (item) {
	      return item.url === "/portal";
	    });
	
	    commit({
	      type: LOGIN_SUCCESS,
	      response: creds.body,
	      remember: creds.remember
	    });
	
	    if (neededRoute && !creds.isExternal) {
	      commit({
	        type: CHANGE_ROUTE,
	        item: neededRoute
	      });
	    }
	
	    commit(FINISH_REQUEST);
	  },
	  setCustomApiUrl: function setCustomApiUrl(_ref2, customApiUrl) {
	    var commit = _ref2.commit;
	
	    commit({ type: SET_CUSTOM_API_URL, url: customApiUrl });
	  },
	  login: function login(_ref3, creds) {
	    var _this = this;
	
	    var commit = _ref3.commit;
	
	    commit(START_REQUEST);
	
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.login(creds.user, _this.state.customApiUrl).then(function (res) {
	        var neededRoute = _this.state.navbarItems.find(function (item) {
	          return item.url === "/portal";
	        });
	
	        commit({
	          type: LOGIN_SUCCESS,
	          response: res.body,
	          remember: creds.remember
	        });
	
	        if (neededRoute && !creds.isExternal) {
	          commit({
	            type: CHANGE_ROUTE,
	            item: neededRoute
	          });
	        }
	
	        commit(FINISH_REQUEST);
	        resolve();
	      }).catch(function (err) {
	        try {
	          var error = JSON.parse(err.bodyText);
	          if (error.error.statusCode === 403 && error.error.code === "LOGIN_FAILED_PERMISSION_DENIED") {
	            commit({
	              type: LOGIN_FAILED_PERMISSION_DENIED,
	              message: "Unfortunately, you are not authorised to access this application. Please contact application manager in your company or Widget Brain Support.",
	              errorCode: error.error.statusCode
	            });
	          } else if (error.error.statusCode === 401) {
	            commit({
	              type: LOGIN_FAILED,
	              message: "Incorrect username and/or password. Please check your credentials.",
	              errorCode: error.error.statusCode
	            });
	          } else {
	            commit({
	              type: LOGIN_ERROR,
	              response: err
	            });
	          }
	        } catch (e) {
	          commit({
	            type: LOGIN_ERROR,
	            response: err
	          });
	        }
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject(err);
	      });
	    });
	  },
	  logout: function logout(_ref4) {
	    var commit = _ref4.commit;
	
	    commit(LOGOUT);
	  },
	  forgotPassword: function forgotPassword(_ref5, email) {
	    var commit = _ref5.commit;
	
	    if (!email) {
	      commit({
	        type: SET_MESSAGE,
	        message: "Email not sent, fill the email field."
	      });
	      return false;
	    }
	    commit(START_REQUEST);
	    _managedata2.default.forgotPassword(email, this.state.customApiUrl).then(function (res) {
	      var message = "An email has been sent to " + email;
	      commit({
	        type: SET_MESSAGE,
	        message: message
	      });
	      commit(FINISH_REQUEST);
	    }).catch(function (err) {
	      console.log(err);
	      commit(FINISH_REQUEST);
	    });
	  },
	  resetPassword: function resetPassword(_ref6, payload) {
	    var commit = _ref6.commit;
	
	    commit(START_REQUEST);
	    _managedata2.default.resetPassword(payload.pw, payload.token, this.state.customApiUrl).then(function (res) {
	      var message = "Password has been changed";
	      commit({
	        type: SET_MESSAGE,
	        message: message
	      });
	      commit({
	        type: SET_ROUTE,
	        route: "login"
	      });
	      commit(FINISH_REQUEST);
	    }).catch(function (err) {
	      console.log(err);
	      commit(FINISH_REQUEST);
	    });
	  },
	  changePassword: function changePassword(_ref7, payload) {
	    var _this2 = this;
	
	    var commit = _ref7.commit;
	
	    // payload: { oldPassword, newPassword }
	    commit(START_REQUEST);
	    console.log("here");
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.changePassword(payload.userId, payload.oldPassword, payload.newPassword, _this2.state.customApiUrl).then(function (res) {
	        commit({
	          type: SET_MESSAGE,
	          message: "Password has been changed"
	        });
	        commit(LOGOUT);
	        commit({
	          type: SET_ROUTE,
	          route: "login"
	        });
	        commit(FINISH_REQUEST);
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject(err);
	      });
	    });
	  },
	  getUser: function getUser(_ref8) {
	    var commit = _ref8.commit,
	        state = _ref8.state;
	
	    var userId = state.userId || localStorage.getItem("userId");
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getUser(userId).then(function (res) {
	        var assignmentId = res.body.appAssignments.findIndex(function (assignment) {
	          return assignment.appId == _params2.default.getParameterValue("APP_ID");
	        });
	
	        if (assignmentId < 0) {
	          commit(LOGOUT);
	          console.log(res.body.appAssignments[assignmentId].role);
	        } else {
	          commit({
	            type: SET_ROLE,
	            role: res.body.appAssignments[assignmentId].role
	          });
	          console.log(res.body.appAssignments[assignmentId]);
	          if (res.body.appAssignments[assignmentId].role && res.body.appAssignments[assignmentId].role.toLowerCase() === "admin") {
	            commit({
	              type: SET_IS_ADMIN,
	              isAdmin: true
	            });
	          }
	        }
	        commit({
	          type: SET_USER,
	          user: res.body
	        });
	
	        commit(FINISH_REQUEST);
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject(err);
	      });
	    });
	  },
	  getValidateToken: function getValidateToken(_ref9) {
	    var commit = _ref9.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.validateToken().then(function (res) {
	        var data = res.body;
	        commit({
	          type: SET_USERID,
	          data: data
	        });
	        resolve(res.body);
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject(err);
	      });
	    });
	  },
	  changeRoute: function changeRoute(_ref10, item) {
	    var commit = _ref10.commit;
	
	    commit({
	      type: CHANGE_ROUTE,
	      item: item
	    });
	  },
	  getApps: function getApps(_ref11) {
	    var commit = _ref11.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getApps().then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_APPS,
	          apps: res.body
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  getGroupedApps: function getGroupedApps(_ref12) {
	    var commit = _ref12.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getGroupedApps().then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_GROUPED_APPS,
	          apps: res.body
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  getUserTeamAssignments: function getUserTeamAssignments(_ref13) {
	    var commit = _ref13.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getUserTeamAssignments().then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_USERS_TEAM_ASSIGNMENTS,
	          userTeam: res.body
	        });
	        resolve(res.body);
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  createUserTeamAssignments: function createUserTeamAssignments(_ref14, data) {
	    var commit = _ref14.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.createUserTeamAssignments(data).then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "User successfully created"
	        });
	        resolve(res.body);
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  updateUserTeamAssignments: function updateUserTeamAssignments(_ref15, data) {
	    var commit = _ref15.commit,
	        dispatch = _ref15.dispatch;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.updateUserTeamAssignments(data).then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "User team assignment updated"
	        });
	        dispatch("getAssignedTeams").then(function () {
	          return resolve();
	        }).catch(function (err) {
	          return reject(err);
	        });
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject(err);
	      });
	    });
	  },
	  deleteUserTeamAssignments: function deleteUserTeamAssignments(_ref16, id) {
	    var commit = _ref16.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.deleteUserTeamAssignments(id).then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "User deleted"
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  getAssignments: function getAssignments(_ref17) {
	    var commit = _ref17.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getAssignments().then(function (res) {
	        var s = store.state;
	        var assignments = res.body.result;
	        var filteredCategories = [];
	        var apps = s.groupedApps ? s.groupedApps.reduce(function (acc, cur) {
	          if (cur.apps && cur.apps.length) return acc.concat(cur.apps);
	          acc.push(cur);
	          return acc;
	        }, []) : s.apps;
	        assignments.forEach(function (assignment) {
	          var appIndex = apps.findIndex(function (app) {
	            return app.id == assignment.appId;
	          });
	          if (appIndex !== -1) {
	            var app = apps[appIndex];
	            if (filteredCategories.findIndex(function (cat) {
	              return cat == app.Category;
	            }) == -1 && app.Category && app.Category !== "Admin" && app.Category.length > 0 && app.url) {
	              filteredCategories.push(app.Category);
	            }
	            if (app.Name === "Admin" && assignment.role && assignment.role.toLowerCase() === "admin") {
	              commit({
	                type: SET_IS_ADMIN,
	                isAdmin: true
	              });
	            }
	          }
	        });
	        commit({
	          type: SET_SELECTED_CATEGORIES,
	          selectedCategories: filteredCategories
	        });
	        commit({
	          type: SET_CATEGORIES,
	          categories: filteredCategories
	        });
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_ASSIGNMENTS,
	          assignments: res.body.result
	        });
	
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  getUserStatuses: function getUserStatuses(_ref18) {
	    var commit = _ref18.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getUserStatuses().then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_USER_STATUSES,
	          userStatuses: res.body
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  getUsers: function getUsers(_ref19) {
	    var commit = _ref19.commit,
	        state = _ref19.state;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getUsers().then(function (res) {
	        var users = res.body;
	        var usersWithStatuses = users.map(function (user) {
	          var newUser = Object.assign({}, user);
	          if (state.userStatuses && state.userStatuses[newUser.id]) newUser.status = state.userStatuses[newUser.id];
	          return newUser;
	        });
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_USERS,
	          users: usersWithStatuses
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  createUserFromApp: function createUserFromApp(_ref20, payload) {
	    var commit = _ref20.commit,
	        state = _ref20.state;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      if (!_utils2.default.isQuinyx()) {
	        _managedata2.default.createUserFromApp(payload.user).then(function (res) {
	          if (!res.body.message) {
	            commit({
	              type: SET_MESSAGE,
	              message: "New user added"
	            });
	          }
	          commit(FINISH_REQUEST);
	          resolve(res);
	        }).catch(function (err) {
	          console.log(err);
	          commit(FINISH_REQUEST);
	          reject(err);
	        });
	      } else {
	        _managedata2.default.createUserFromQuinyxApp(payload.user).then(function (res) {
	          if (!res.body.message) {
	            commit({
	              type: SET_MESSAGE,
	              message: "New user added"
	            });
	          }
	          commit(FINISH_REQUEST);
	          resolve(res);
	        }).catch(function (err) {
	          console.log(err);
	          commit(FINISH_REQUEST);
	          reject(err);
	        });
	      }
	    });
	  },
	  updateUser: function updateUser(_ref21, user) {
	    var commit = _ref21.commit,
	        dispatch = _ref21.dispatch;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.updateUser(user).then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "User updated"
	        });
	        dispatch("getUser").then(function () {
	          return resolve();
	        }).catch(function (err) {
	          return reject(err);
	        });
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject(err);
	      });
	    });
	  },
	  updateUserTeams: function updateUserTeams(_ref22, data) {
	    var commit = _ref22.commit,
	        dispatch = _ref22.dispatch;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.updateUserTeams(data).then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "User team list updated"
	        });
	        dispatch("getUser").then(function () {
	          return resolve();
	        }).catch(function (err) {
	          return reject(err);
	        });
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject(err);
	      });
	    });
	  },
	  updateTeamsAssignment: function updateTeamsAssignment(_ref23, data) {
	    var commit = _ref23.commit,
	        dispatch = _ref23.dispatch;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.updateTeamsAssignment(data).then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "Team assignment updated"
	        });
	        dispatch("getAssignedTeams").then(function () {
	          return resolve();
	        }).catch(function (err) {
	          return reject(err);
	        });
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject(err);
	      });
	    });
	  },
	  deleteUser: function deleteUser(_ref24, user) {
	    var commit = _ref24.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.deleteUser(user.id).then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "User deleted"
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  deleteUserTeam: function deleteUserTeam(_ref25, data) {
	    var commit = _ref25.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.deleteUserTeam(data).then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "User unassigned"
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  deleteFromParentTeam: function deleteFromParentTeam(_ref26, data) {
	    var commit = _ref26.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.deleteFromParentTeam(data).then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "User team list updated"
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject(err);
	      });
	    });
	  },
	  getRolesById: function getRolesById(_ref27, payload) {
	    var commit = _ref27.commit;
	
	    commit(START_REQUEST);
	    var data = payload && payload.id || null;
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getRoles(data).then(function (res) {
	        commit({
	          type: SET_ROLES,
	          roles: res.body
	        });
	        commit(FINISH_REQUEST);
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  createApp: function createApp(_ref28, app) {
	    var commit = _ref28.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.createApp(app).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "App added"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  updateApp: function updateApp(_ref29, app) {
	    var commit = _ref29.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.updateApp(app).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "App updated"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  deleteApp: function deleteApp(_ref30, app) {
	    var commit = _ref30.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.deleteApp(app).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "App deleted"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  getRoles: function getRoles(_ref31) {
	    var commit = _ref31.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getRoles().then(function (res) {
	        commit({
	          type: SET_ROLES,
	          roles: res.body
	        });
	        commit(FINISH_REQUEST);
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  createRole: function createRole(_ref32, role) {
	    var commit = _ref32.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.createRole(role).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "Role added"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        resolve();
	      });
	    });
	  },
	  updateRole: function updateRole(_ref33, role) {
	    var commit = _ref33.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.updateRole(role).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "Role updated"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  deleteRole: function deleteRole(_ref34, role) {
	    var commit = _ref34.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.deleteRole(role).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "Role deleted"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  getOrganizations: function getOrganizations(_ref35) {
	    var commit = _ref35.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getOrganizations().then(function (res) {
	        commit({
	          type: SET_ORGANIZATIONS,
	          organizations: res.body
	        });
	        commit(FINISH_REQUEST);
	        resolve(res.body);
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject(err);
	      });
	    });
	  },
	  getTeams: function getTeams(_ref36) {
	    var commit = _ref36.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getTeams().then(function (res) {
	        commit({
	          type: SET_TEAMS,
	          teams: res.body
	        });
	        commit(FINISH_REQUEST);
	        resolve(res.body);
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject(err);
	      });
	    });
	  },
	  getTeamById: function getTeamById(_ref37, teamId) {
	    var commit = _ref37.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getTeamById(teamId).then(function (res) {
	        commit(FINISH_REQUEST);
	        resolve(res.body);
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject(err);
	      });
	    });
	  },
	  getAssignedTeams: function getAssignedTeams(_ref38) {
	    var commit = _ref38.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getAssignedTeams().then(function (res) {
	        commit({
	          type: SET_TEAMSASSIGNED,
	          teamsAssigned: res.body
	        });
	        commit(FINISH_REQUEST);
	        resolve(res.body);
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject(err);
	      });
	    });
	  },
	  createOrganization: function createOrganization(_ref39, organization) {
	    var commit = _ref39.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.createOrganization(organization).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "Organization added"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  updateOrganization: function updateOrganization(_ref40, organization) {
	    var commit = _ref40.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.updateOrganization(organization).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "Organization updated"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  deleteOrganization: function deleteOrganization(_ref41, organization) {
	    var commit = _ref41.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.deleteOrganization(organization).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "Organization deleted"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  getOrganizationAssignments: function getOrganizationAssignments(_ref42) {
	    var commit = _ref42.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getOrganizationAssignments().then(function (res) {
	        commit({
	          type: SET_ORGANIZATION_ASSIGNMENT,
	          organizationAssignments: res.body
	        });
	        commit(FINISH_REQUEST);
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  createOrganizationAssignment: function createOrganizationAssignment(_ref43, organizationAssignment) {
	    var commit = _ref43.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.createOrganizationAssignment(organizationAssignment).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "Organization assignment added"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  updateOrganizationAssignment: function updateOrganizationAssignment(_ref44, organizationAssignment) {
	    var commit = _ref44.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.updateOrganizationAssignment(organizationAssignment).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "Organization assignment updated"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  deleteOrganizationAssignment: function deleteOrganizationAssignment(_ref45, organizationAssignment) {
	    var commit = _ref45.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.deleteOrganizationAssignment(organizationAssignment).then(function () {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_MESSAGE,
	          message: "Organization assignment deleted"
	        });
	        resolve();
	      }).catch(function (err) {
	        console.log(err);
	        commit(FINISH_REQUEST);
	        reject();
	      });
	    });
	  },
	  getAudiences: function getAudiences(_ref46) {
	    var commit = _ref46.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getAudiences().then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_AUDIENCES,
	          audiences: res.body
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  getProtocols: function getProtocols(_ref47) {
	    var commit = _ref47.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getProtocols().then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_PROTOCOLS,
	          protocols: res.body
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  getInvocationTypes: function getInvocationTypes(_ref48) {
	    var commit = _ref48.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getInvocationTypes().then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_INVOCATION_TYPES,
	          invocationTypes: res.body
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  getPlatforms: function getPlatforms(_ref49) {
	    var commit = _ref49.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getPlatforms().then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_PLATFORMS,
	          platforms: res.body
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  getRegionsForPlatform: function getRegionsForPlatform(_ref50, platformTag) {
	    var commit = _ref50.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.getRegionsForPlatform(platformTag).then(function (res) {
	        commit(FINISH_REQUEST);
	        commit({
	          type: SET_REGIONS_FOR_PLATFORMS,
	          regionsForPlatforms: res.body
	        });
	        resolve();
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        console.log(err);
	        reject();
	      });
	    });
	  },
	  getOrganisationsById: function getOrganisationsById(_ref51, data) {
	    var commit = _ref51.commit;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      var promises = data.map(function (e) {
	        return _managedata2.default.getOrganisationById(e.organisationId).then(function (org) {
	          e.organizationName = org.body.name;
	          return e;
	        });
	      });
	
	      Promise.all(promises).then(function (res) {
	        commit(FINISH_REQUEST);
	        resolve(res);
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        reject(err);
	      });
	    });
	  },
	  resetAuth0Credentials: function resetAuth0Credentials(_ref52) {
	    var commit = _ref52.commit,
	        state = _ref52.state;
	
	    commit(START_REQUEST);
	    return new Promise(function (resolve, reject) {
	      _managedata2.default.resetAuth0Credentials(state.user.id).then(function (resp) {
	        commit({
	          type: SET_MESSAGE,
	          message: "Credentials resetted!"
	        });
	        commit(FINISH_REQUEST);
	        resolve(resp);
	      }).catch(function (err) {
	        commit(FINISH_REQUEST);
	        reject(err);
	      });
	    });
	  }
	};
	
	var mutations = (_mutations = {}, _defineProperty(_mutations, START_REQUEST, function (state) {
	  state.pending = true;
	}), _defineProperty(_mutations, FINISH_REQUEST, function (state) {
	  state.pending = false;
	}), _defineProperty(_mutations, LOGOUT, function (state) {
	  var _this3 = this;
	
	  var exec = {
	    message: {
	      type: SET_MESSAGE,
	      message: "You logged out"
	    }
	  };
	  _managedata2.default.logout(this.state.customApiUrl).then(function () {
	    localStorage.removeItem("WBToken");
	    localStorage.removeItem("userId");
	    var initialState = getInitialState();
	    state = Object.assign(state, initialState);
	    _this3.commit(exec.message);
	  }).catch(function (err) {
	    localStorage.removeItem("WBToken");
	    localStorage.removeItem("userId");
	    var initialState = getInitialState();
	    state = Object.assign(state, initialState);
	    _this3.commit(exec.message);
	  });
	}), _defineProperty(_mutations, SET_USERID, function (state, _ref53) {
	  var data = _ref53.data;
	
	  if (data.userId) {
	    state.userId = data.userId;
	  }
	}), _defineProperty(_mutations, LOGIN_SUCCESS, function (state, payload) {
	  this.commit(CLEAR_MESSAGE);
	  state.isLoggedIn = true;
	  state.WBToken = payload.response.id;
	  state.userId = payload.response.userId;
	
	  if (payload.remember) {
	    localStorage.setItem("WBToken", state.WBToken);
	    localStorage.setItem("userId", state.userId);
	  }
	  state.message = "Login succesful. Welcome back!";
	}), _defineProperty(_mutations, LOGIN_ERROR, function (state, payload) {
	  this.commit(CLEAR_ERROR_DIALOG_MESSAGE);
	  state.dialogErrorMessage = "Oops… seems like you cannot access your application right now.";
	  state.dialogErrorCode = 500;
	}), _defineProperty(_mutations, LOGIN_FAILED, function (state, payload) {
	  this.commit(CLEAR_ERROR_DIALOG_MESSAGE);
	  state.dialogErrorMessage = payload.message;
	  state.dialogErrorCode = payload.errorCode;
	}), _defineProperty(_mutations, LOGIN_FAILED_PERMISSION_DENIED, function (state, payload) {
	  this.commit(CLEAR_ERROR_DIALOG_MESSAGE);
	  state.dialogErrorMessage = payload.message;
	  state.dialogErrorCode = payload.errorCode;
	}), _defineProperty(_mutations, SET_ROUTE, function (state, payload) {
	  state.route = payload.route;
	}), _defineProperty(_mutations, SET_USER, function (state, payload) {
	  state.user = payload.user;
	}), _defineProperty(_mutations, SET_ROLE, function (state, payload) {
	  state.role = payload.role;
	}), _defineProperty(_mutations, CHANGE_ROUTE, function (state, payload) {
	  state.route = payload.item.url;
	}), _defineProperty(_mutations, CLEAR_MESSAGE, function (state) {
	  state.messageRandom = Math.random();
	  state.message = null;
	}), _defineProperty(_mutations, CLEAR_ERROR_DIALOG_MESSAGE, function (state) {
	  state.dialogErrorMessageRandom = Math.random();
	  state.dialogErrorMessage = null;
	  state.dialogErrorCode = null;
	}), _defineProperty(_mutations, SET_MESSAGE, function (state, payload) {
	  this.commit(CLEAR_MESSAGE);
	  state.message = payload.message;
	}), _defineProperty(_mutations, SET_ACTIVE_LINK, function (state, payload) {
	  var currentItem = payload.currentItem;
	  if (currentItem) {
	    state.navbarItems.forEach(function (item) {
	      if (currentItem.id === item.id) {
	        item.active = true;
	      } else {
	        item.active = false;
	      }
	    });
	    state.forecastItems.forEach(function (item) {
	      if (currentItem.id === item.id) {
	        item.active = true;
	      } else {
	        item.active = false;
	      }
	    });
	  } else {
	    state.navbarItems.forEach(function (item) {
	      item.active = false;
	    });
	  }
	}), _defineProperty(_mutations, SET_GROUPED_APPS, function (state, payload) {
	  state.groupedApps = payload.apps;
	}), _defineProperty(_mutations, SET_USERS_TEAM_ASSIGNMENTS, function (state, payload) {
	  state.userTeamAssignments = payload.userTeam;
	}), _defineProperty(_mutations, SET_APPS, function (state, payload) {
	  state.apps = payload.apps;
	}), _defineProperty(_mutations, SET_SELECTED_CATEGORIES, function (state, payload) {
	  state.selectedCategories = payload.selectedCategories;
	}), _defineProperty(_mutations, SET_CATEGORIES, function (state, payload) {
	  state.categories = payload.categories;
	}), _defineProperty(_mutations, SET_ASSIGNMENTS, function (state, payload) {
	  state.assignments = payload.assignments;
	}), _defineProperty(_mutations, SET_ALLOWED_ORG_AND_ALGORITHMS, function (state, payload) {
	  state.allowedOrganizationsAndAlgorithms = payload.allowedOrganizationsAndAlgorithms;
	}), _defineProperty(_mutations, SET_USER_STATUSES, function (state, payload) {
	  state.userStatuses = payload.userStatuses;
	}), _defineProperty(_mutations, SET_USERS, function (state, payload) {
	  state.users = payload.users;
	}), _defineProperty(_mutations, SET_ROLES, function (state, payload) {
	  state.roles = payload.roles;
	}), _defineProperty(_mutations, SET_ORGANIZATIONS, function (state, payload) {
	  state.organizations = payload.organizations;
	}), _defineProperty(_mutations, SET_TEAMS, function (state, payload) {
	  state.teams = payload.teams;
	}), _defineProperty(_mutations, SET_TEAMSASSIGNED, function (state, payload) {
	  state.teamsAssigned = payload.teamsAssigned;
	}), _defineProperty(_mutations, SET_ORGANIZATION_ASSIGNMENT, function (state, payload) {
	  state.organizationAssignments = payload.organizationAssignments;
	}), _defineProperty(_mutations, SET_IS_ADMIN, function (state, payload) {
	  state.isAdmin = payload.isAdmin;
	}), _defineProperty(_mutations, SET_AUDIENCES, function (state, payload) {
	  state.audiences = payload.audiences;
	}), _defineProperty(_mutations, SET_PROTOCOLS, function (state, payload) {
	  state.protocols = payload.protocols;
	}), _defineProperty(_mutations, SET_INVOCATION_TYPES, function (state, payload) {
	  state.invocationTypes = payload.invocationTypes;
	}), _defineProperty(_mutations, SET_PLATFORMS, function (state, payload) {
	  state.platforms = payload.platforms;
	}), _defineProperty(_mutations, SET_REGIONS_FOR_PLATFORMS, function (state, payload) {
	  state.regionsForPlatforms = payload.regionsForPlatforms;
	}), _defineProperty(_mutations, SET_CUSTOM_API_URL, function (state, payload) {
	  state.customApiUrl = payload.url;
	}), _mutations);
	
	function getInitialState() {
	  var _ref54;
	
	  return _ref54 = {
	    isLoggedIn: !!localStorage.getItem("WBToken") || _utils2.default.isQuinyx(),
	    pending: false,
	    WBToken: null,
	    userId: null,
	    user: null,
	    role: null,
	    message: null,
	    messageRandom: null,
	    dialogErrorMessage: null,
	    dialogErrorMessageRandom: null,
	    dialogErrorCode: null,
	    route: null,
	    apps: null,
	    selectedCategories: [],
	    categories: [],
	    assignments: null,
	    allowedOrganizationsAndAlgorithms: null,
	    userStatuses: null,
	    users: null,
	    roles: null,
	    organizations: null,
	    teams: null,
	    teamsAssigned: null,
	    organizationAssignments: null,
	    isAdmin: false,
	    verticals: [{ name: "Logistics", show: true }, { name: "Equipment", show: true }, { name: "Industry", show: true }, { name: "Admin", show: true }],
	    navbarItems: [{
	      id: 0,
	      name: "Applications",
	      url: "/portal",
	      onClick: function onClick() {
	        store.dispatch("changeRoute", this);
	      },
	
	      active: false,
	      access: "application"
	    }],
	    forecastItems: [
	      /*{
	                id: 6,
	                name: 'Raw data',
	                url: '/rawdata',
	                onClick() {
	                    store.dispatch('changeRoute', this)
	                },
	                active: false,
	                access: 'forecast',
	            },
	            {
	                id: 7,
	                name: 'Forecast',
	                url: '/forecast',
	                onClick() {
	                    store.dispatch('changeRoute', this)
	                },
	                active: false,
	                access: 'forecast',
	            },*/
	    ],
	    profileMenuItems: [{
	      icon: "admin",
	      name: "Admin",
	      url: "/admin",
	      onClick: function onClick() {
	        store.dispatch("changeRoute", this);
	      }
	    }, {
	      icon: "",
	      name: "My account",
	      url: "/my-account",
	      onClick: function onClick() {
	        store.dispatch("changeRoute", this);
	      }
	    }, {
	      icon: "",
	      name: "Help",
	      onClick: function onClick() {
	        window.location.href = "https://docs.widgetbrain.io/portal";
	      }
	    }, {
	      icon: "logout",
	      name: "Log out",
	      url: "/logout",
	      onClick: function onClick() {
	        store.dispatch("logout");
	      }
	    }],
	    audiences: [],
	    protocols: [],
	    invocationTypes: [],
	    platforms: [],
	    regionsForPlatforms: [],
	    services: []
	  }, _defineProperty(_ref54, "apps", []), _defineProperty(_ref54, "groupedApps", []), _defineProperty(_ref54, "userTeamAssignments", []), _defineProperty(_ref54, "customApiUrl", null), _ref54;
	}
	
	var state = getInitialState();
	
	var store = exports.store = new _vuex2.default.Store({
	  strict: strict,
	  state: state,
	  mutations: mutations,
	  getters: getters,
	  actions: actions
	});

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(244)
	__webpack_require__(243)
	
	/* script */
	__vue_exports__ = __webpack_require__(168)
	
	/* template */
	var __vue_template__ = __webpack_require__(311)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "datePickerWrapper"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5d525a13"
	
	module.exports = __vue_exports__


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(252)
	
	/* script */
	__vue_exports__ = __webpack_require__(170)
	
	/* template */
	var __vue_template__ = __webpack_require__(316)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "vue-datepicker-es6"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-684d245c"
	
	module.exports = __vue_exports__


/***/ }),
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datePickerWrapper = __webpack_require__(162);
	
	var _datePickerWrapper2 = _interopRequireDefault(_datePickerWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'customTableCell',
	  props: ['adjustableColumnWidth', 'rowIndex', 'row', 'allowTooltips', 'fontSize', 'column', 'dataList0', 'dataList1', 'dataList2', 'dataList3', 'objectList', 'columnCellClass', 'listOfOptionsForSwitch', 'isSimpleCell', 'isEditableBoolean', 'dataTimePlaceholder', 'columns', 'hasSelection', 'columnIndex'],
	  components: {
	    datePickerWrapper: _datePickerWrapper2.default
	  },
	  methods: {
	    onmousedownAdjustableBorder: function onmousedownAdjustableBorder(row, column, e) {
	      var firstPosition = void 0,
	          line = void 0,
	          self = this,
	          column1Width = void 0,
	          column2Width = void 0;
	      if (e.target) {
	        line = e.target.cloneNode(true);
	        line.style.position = 'absolute';
	        var visibleColumns = this.columns.filter(function (i) {
	          return i.visible;
	        });
	        var tempIndex = visibleColumns.findIndex(function (i) {
	          return i.name === column.name && i.displayName === column.displayName;
	        });
	
	        if (!visibleColumns[tempIndex - 1]) return;
	        var th = document.querySelector('.md-table-header .' + column.name);
	        var th1 = document.querySelector('.md-table-header .' + visibleColumns[tempIndex - 1].name);
	        column1Width = th.offsetWidth;
	        column2Width = th1.offsetWidth;
	        line.className = line.className + ' temp-line';
	
	        moveAt(e);
	        document.querySelector('.adjustable-column-width-table').appendChild(line);
	        line.style.zIndex = 1000;
	      }
	      function moveAt(e) {
	        var newLeft = e.pageX - line.offsetWidth / 2;
	        if (!firstPosition) firstPosition = newLeft;
	
	        var diff = firstPosition - newLeft;
	
	        if (diff > column2Width - 4 || diff < -1 * column1Width + 2) return;
	        line.style.left = newLeft + 'px';
	        self.$emit('ondragAdjustableBorder', row, column, firstPosition, line.style.left, column1Width, column2Width);
	      }
	
	      document.onmousemove = function (e) {
	        moveAt(e);
	      };
	
	      document.onmouseup = function () {
	        document.onmousemove = null;
	        line.onmouseup = null;
	      };
	    },
	    ondragAdjustableBorder: function ondragAdjustableBorder(row, column, event) {}
	  },
	  data: function data() {
	    return {
	      getObjectList: this.column.objectList === 'objectList' ? this.objectList[this.column.name] : this[this.column.objectList]
	    };
	  },
	
	  computed: {
	    computedSelectValue: function computedSelectValue() {
	      var _this = this;
	
	      if (this.row[this.column.name] && Array.isArray(this.getObjectList)) {
	        var value = this.getObjectList.find(function (i) {
	          return i.id == _this.row[_this.column.name];
	        });
	        return value && value.name ? value.name : '';
	      } else if (this.getObjectList && this.row[this.column.name] && this.column.name && this.getObjectList[this.row[this.column.name]]) {
	        var _value = this.getObjectList[this.row[this.column.name]];
	        return _value && _value.name ? _value.name : '';
	      }
	      return '';
	    },
	
	    inputType: function inputType() {
	      var type = this.column.type.toLowerCase().trim();
	      if (type === 'number') return 'number';
	      if (type === 'boolean') return 'checkbox';
	      if (type === 'password') return 'password';
	      return 'text';
	    },
	    isEditableFunction: function isEditableFunction() {
	      return this.column && typeof this.column.isEditable === 'function' && this.column.isEditable(this.row);
	    }
	  }
	};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(194);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(193);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(14);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vueDatepickerEs = __webpack_require__(163);
	
	var _vueDatepickerEs2 = _interopRequireDefault(_vueDatepickerEs);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _filterModal = __webpack_require__(273);
	
	var _filterModal2 = _interopRequireDefault(_filterModal);
	
	var _datePickerWrapper = __webpack_require__(162);
	
	var _datePickerWrapper2 = _interopRequireDefault(_datePickerWrapper);
	
	var _customTableCell = __webpack_require__(272);
	
	var _customTableCell2 = _interopRequireDefault(_customTableCell);
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dataTable',
	  components: {
	    filterModal: _filterModal2.default,
	    datePickerWrapper: _datePickerWrapper2.default,
	    Datepicker: _vueDatepickerEs2.default,
	    customTableCell: _customTableCell2.default
	  },
	  props: ['adjustableColumnWidth', 'isTitleHtml', 'htmlTitle', 'dateTimeFormat', 'dataTimePlaceholder', 'customHeaderTools', 'columns', 'dataext', 'dataLength', 'hasControls', 'hasSelection', 'hasAutoSelection', 'tableName', 'dataList0', 'dataList1', 'dataList2', 'dataList3', 'objectList', 'listOfOptionsForSwitch', 'height', 'fontSize', 'saveColumnSelection', 'saveFilters', 'saveSort', 'indentHeight', 'allowCreation', 'disallowEditing', 'disallowDeleting', 'quickFilter', 'searchKey', 'searchKeys', 'hasFilter', 'disableMultiSelect', 'disableSearch', 'disableRowControlls', 'countTitle', 'customControls', 'listForAutocomplete', 'formatForDateWithTime', 'allowTooltips', 'customSortFunction', 'pagination', 'customFilterOptions', 'showVisibleFilteredDataextCounter', 'selectOrUnselectAllColumnsOptionVisible', 'minItemSize'],
	  data: function data() {
	    return {
	      selectToOpenObj: {},
	      dragColumnBorderTimer: null,
	      applyQuickFilter: this.quickFilter && this.quickFilter.value ? this.quickFilter.value : false,
	      selectedData: {},
	      selectedDataLength: 0,
	      localDataLength: this.dataLength || 100000,
	      sort: {},
	      showColumn: null,
	      showColumnSettings: false,
	      visibleColumns: [],
	      selectedIndexesData: [],
	      filterValues: {},
	      filterBy: [],
	      filterNumber: {},
	      showFilterNumber: {},
	      savedColumns: [],
	      initialSortExecuted: false,
	      showFilterModal: false,
	      selectedFilter: { filterValue: null, filterCondition: null },
	      shadowList: [],
	      previousSelected: 0,
	
	      wasMultiSorted: false,
	      isMounted: false,
	      searchTerm: '',
	      dateArrayForDatepicker: {},
	      option: {
	        type: 'min',
	        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
	        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	        format: this.formatForDateWithTime,
	        placeholder: 'when?'
	      },
	      page: 1,
	      totalSize: null
	    };
	  },
	  created: function created() {
	    this.visibleColumns = this.columns;
	  },
	  mounted: function mounted() {
	    var tbodyArray = document.querySelectorAll('.datatable tbody');
	    for (var i = 0; i < tbodyArray.length; i++) {
	      tbodyArray[i].style.maxHeight = 'calc(100vh - ' + this.indentHeight + 'px)';
	    }
	    this.loadLocalStorage();
	  },
	  updated: function updated() {},
	
	  watch: {
	    columns: function columns(val) {
	      this.loadLocalStorage();
	      if (this.saveColumnSelection) {
	        var oldColumns = this.columns;
	        this.visibleColumns = val.map(function (column) {
	
	          var current = oldColumns.find(function (oldColumn) {
	            return oldColumn.name === column.name && column.visible;
	          });
	          if (current) {
	            column.visible = current.visible;
	          }
	          return column;
	        });
	        this.$forceUpdate();
	      } else {
	        this.visibleColumns = val;
	      }
	    },
	    dataext: function dataext(val, oldVal) {
	      var self = this;
	      var forceSort = val.length != oldVal.length && val.length > 0 && oldVal.length > 0;
	      if (this.filterBy.length > 0) {
	        this.filterData(function () {
	          if (forceSort) {
	            self.executeSavedSortFunction(forceSort);
	          }
	        });
	      } else {
	        if (forceSort) {
	          self.executeSavedSortFunction(forceSort);
	        }
	      }
	    },
	    visibleFilteredDataext: function visibleFilteredDataext(val) {
	      this.$emit('visibleDataChanged', val);
	    }
	  },
	  methods: {
	    selectValue: function selectValue(value, row, column) {
	      var _this = this;
	
	      var curFilteredRowIndex = this.paginatedDataext.findIndex(function (i) {
	        return i.id == row.id;
	      });
	      var curRowIndex = this.dataext.findIndex(function (i) {
	        return i.id == row.id;
	      });
	      row[column.name] = value.id;
	      this.paginatedDataext[curFilteredRowIndex][column.name] = value.id;
	      this.hideSelectWindow();
	      this.$nextTick(function () {
	        _this.dataext[curRowIndex] = (0, _assign2.default)(_this.paginatedDataext[curFilteredRowIndex], row);
	        var element = _this.$el.querySelector('.md-table-row.item-' + row.id + ' .' + column.name + ' .md-select-value');
	        if (element) {
	          element.innerText = value.name;
	        }
	        _this.$emit('changeEmit', _this.dataext[curRowIndex], column);
	        _this.$emit('blurEmit', _this.dataext[curRowIndex], column);
	        _this.$emit('focusEmit', _this.dataext[curRowIndex], column);
	      });
	    },
	    hideSelectWindow: function hideSelectWindow() {
	      this.selectToOpenObj = {
	        show: false
	      };
	    },
	    showSelectWindow: function showSelectWindow(e, row, column, objectList, disabled) {
	      if (disabled) return;
	      var tdEl = e.path.find(function (i) {
	        return i.className.indexOf(' md-table-cell') !== -1;
	      });
	      console.log(e.path);
	      this.selectToOpenObj = {
	        show: true,
	        row: row,
	        column: column,
	        objectList: objectList,
	        top: tdEl.offsetTop + 'px',
	        left: tdEl.offsetLeft + 'px'
	      };
	    },
	    ondragAdjustableBorder: function ondragAdjustableBorder(row, column, firstPosition, lastPosition, column1Width, column2Width) {
	      var tempIndex = this.visibleColumns.findIndex(function (i) {
	        return i.name === column.name && i.displayName === column.displayName;
	      });
	
	      var diff = parseFloat(firstPosition) - parseFloat(lastPosition);
	
	      this.visibleColumns[tempIndex].width = parseFloat(column1Width) + diff + 'px';
	      this.visibleColumns[tempIndex - 1].width = parseFloat(column2Width) - diff + 'px';
	      this.$forceUpdate();
	      var tempLines = document.querySelectorAll('.adjustable-column-width-table .temp-line');
	      if (tempLines.length > 0) {
	        tempLines.forEach(function (i) {
	          i.remove();
	        });
	      }
	      this.$emit('ondragAdjustableBorder', this.visibleColumns);
	    },
	    quickFilterChange: function quickFilterChange(val) {
	      this.applyQuickFilter = this.quickFilter.value;
	      this.$forceUpdate();
	    },
	    filterList: function filterList(list, query) {
	      var result = list.filter(function (item) {
	        return item.name.indexOf(query) === -1 ? false : true;
	      });
	      console.log('RESULT');
	      console.log(result, query);
	      return result;
	    },
	    onTab: function onTab() {
	      console.log('last');
	    },
	    onTabA: function onTabA() {
	      console.log('not last');
	    },
	
	    filterData: function filterData(cb) {
	      var self = this;
	      this.$emit('onFiltered', this.visibleFilteredDataext);
	      if (cb) cb();
	      this.closeModal();
	    },
	    selectRowAlternative: function selectRowAlternative(row) {
	      var index = this.shadowList.findIndex(function (shadowItem) {
	        return shadowItem.id == row.id;
	      });
	      if (index == -1) this.shadowList.push(row);else this.shadowList.splice(index, 1);
	      this.$emit('selectEmit', row);
	    },
	    removeFromShadowList: function removeFromShadowList(orderId) {
	      var index = this.shadowList.findIndex(function (shadowItem) {
	        return shadowItem.id == orderId;
	      });
	      if (index > -1) this.shadowList.splice(index, 1);
	    },
	    clearShadowList: function clearShadowList() {
	      this.shadowList = [];
	    },
	    isSelectedRow: function isSelectedRow(row) {
	      var rez = this.selectedIndexesData.indexOf(row.id);
	      return rez > -1;
	    },
	    selectAll: function selectAll(e) {
	      var self = this;
	      var value = e.target.checked;
	
	      var elements = this.$el.querySelectorAll('.select-column input').forEach(function (e) {
	        return e.checked = value;
	      });
	      if (value) {
	        this.selectedIndexesData = this.visibleFilteredDataext.map(function (i) {
	          return i.id.toString();
	        });
	        this.selectedData = this.visibleFilteredDataext.filter(function (item) {
	          return self.selectedIndexesData.indexOf(item.id.toString()) !== -1;
	        });
	        this.$emit('onSelect', this.selectedData);
	      } else {
	        this.selectedIndexesData = [];
	        this.$emit('onSelect', []);
	      }
	    },
	    onSelect: function onSelect(e) {
	      var _this2 = this;
	
	      var self = this;
	      var value = e.target.checked;
	      var selectedId = e.target.dataset.target.toString();
	
	      if (value && !this.disableMultiSelect) {
	        this.selectedIndexesData.push(selectedId);
	      } else if (value && this.disableMultiSelect) {
	        this.selectedIndexesData.forEach(function (rowId) {
	          if (_this2.$el.querySelector('.item-' + rowId + ' input')) {
	            _this2.$el.querySelector('.item-' + rowId + ' input').checked = false;
	          }
	        });
	        this.selectedIndexesData = [selectedId];
	      } else {
	        var index = this.selectedIndexesData.indexOf(selectedId);
	        if (index !== -1) {
	          this.selectedIndexesData.splice(index, 1);
	        }
	      }
	      this.selectedData = this.visibleFilteredDataext.filter(function (item) {
	        return self.selectedIndexesData.indexOf(item.id.toString()) !== -1;
	      });
	      this.$emit('onSelect', this.selectedData);
	    },
	    onSort: function onSort(sort) {
	      this.sort = sort;
	      this.$emit('sort_column', this.dataext, sort);
	    },
	
	    setSort: function setSort(isShift, e) {
	      var oldSettingsVal = JSON.parse(this.$localStorage.get(this.tableName));
	      if (this.wasMultiSorted) {
	        this.wasMultiSorted = false;
	        return false;
	      }
	      if (!isShift) {
	        oldSettingsVal.sort = {};
	      }
	      oldSettingsVal.sort[this.sort.name] = this.sort.type;
	      if (this.saveSort) {
	        this.saveSortFunction((0, _stringify2.default)(oldSettingsVal));
	      }
	      var newSort = oldSettingsVal.sort;
	      this.$emit('sort_column', this.dataext, newSort);
	      if (e) {
	        this.wasMultiSorted = true;
	      }
	    },
	    getObjectList: function getObjectList(list) {
	      return this[list];
	    },
	    addObject: function addObject() {
	      this.$emit('add_row', this.selectedData);
	    },
	    deleteRows: function deleteRows() {
	      this.$emit('delete_rows', _.sortBy(this.shadowList, 'id'));
	    },
	    saveRow: function saveRow(row) {
	      this.$emit('save_row', row);
	      this.$nextTick(function () {
	        row.hasChanges = undefined;
	      });
	    },
	    setRowBlur: function setRowBlur(row, column) {
	      var _this3 = this;
	
	      this.$nextTick(function () {
	        _this3.$emit('blurEmit', row, column);
	      });
	    },
	    setFocus: function setFocus(row, column) {
	      var _this4 = this;
	
	      this.$nextTick(function () {
	        _this4.$emit('focusEmit', row, column);
	      });
	    },
	    setRowChanged: function setRowChanged(row, column, isDatepicker) {
	      var _this5 = this;
	
	      this.$nextTick(function () {
	        row.hasChanges = true;
	        _this5.$emit('changeEmit', row, column);
	        if (isDatepicker) {
	          _this5.$forceUpdate();
	        }
	      });
	    },
	    setRowSelect: function setRowSelect(row, column) {
	      var _this6 = this;
	
	      this.$nextTick(function () {
	        row.hasChanges = true;
	        _this6.$emit('onSelect', row, column, 'select');
	      });
	    },
	
	    onPagination: function onPagination(payload) {
	      if (this.pagination.size !== payload.size) this.pagination.size = payload.size;
	      this.page = payload.page;
	      this.$emit('paginate', payload);
	    },
	    dragEnd: function dragEnd(row, e) {
	      var oldClassName = e.target.className;
	      e.target.className = oldClassName.replace(/dragging/g, '');
	      this.$emit('drag-end', row);
	    },
	    dragStart: function dragStart(row, e) {
	      var oldClassName = e.target.className;
	      e.target.className = oldClassName + ' dragging';
	      this.$emit('drag-start', row);
	    },
	    allowDrop: function allowDrop(event) {
	      event.preventDefault();
	    },
	    drop: function drop() {
	      this.$emit('drop');
	    },
	    toggleColumnSettings: function toggleColumnSettings(column) {
	      var _this7 = this;
	
	      if (column && column.type === 'click') {
	        this.showColumnSettings = false;
	        document.removeEventListener('click', this.toggleColumnSettings);
	      }
	
	      if (!column) {
	        this.showColumnSettings = !this.showColumnSettings;
	        if (this.showColumnSettings) setTimeout(function () {
	          return document.addEventListener('click', _this7.toggleColumnSettings);
	        }, 0);else document.removeEventListener('click', this.toggleColumnSettings);
	      }
	      if (!column) return;
	
	      var newColumns = this.visibleColumns;
	
	      if (column === 'show all') {
	        newColumns = this.visibleColumns.map(function (curentColumn) {
	          if (!curentColumn.fake) {
	            curentColumn.visible = true;
	          }
	          return curentColumn;
	        });
	      } else if (column === 'hide all') {
	        newColumns = this.visibleColumns.map(function (curentColumn) {
	          if (!curentColumn.fake) {
	            curentColumn.visible = false;
	          }
	          return curentColumn;
	        });
	      } else {
	        var columnName = column[0];
	        var columnVisible = column[1];
	        newColumns = this.visibleColumns.map(function (curentColumn) {
	          if (curentColumn.name === columnName) {
	            curentColumn.visible = !columnVisible;
	          }
	          return curentColumn;
	        });
	      }
	
	      var tempLines = document.querySelectorAll('.adjustable-column-width-table .temp-line');
	      if (tempLines.length > 0) {
	        tempLines.forEach(function (i) {
	          i.remove();
	        });
	      }
	
	      if (this.saveColumnSelection) {
	        var oldSettingsVal = JSON.parse(this.$localStorage.get(this.tableName));
	
	        var newSettings = {};
	        if (oldSettingsVal) {
	          newSettings = (0, _assign2.default)((0, _extends3.default)({}, oldSettingsVal), { columns: newColumns });
	        } else {
	          newSettings = { columns: newColumns };
	        }
	        this.saveColumnSelectionFunction((0, _stringify2.default)(newSettings));
	      }
	    },
	    addFilterCondition: function addFilterCondition() {
	      this.selectedFilter = { isNew: true };
	      this.showFilterModal = true;
	    },
	    editFilterCondition: function editFilterCondition(filter, index) {
	      this.selectedFilter = (0, _assign2.default)({}, filter, { isNew: false, index: index });
	      this.showFilterModal = true;
	    },
	    processFilterChange: function processFilterChange(filter) {
	      if (filter.isNew) {
	        this.filterBy.push(filter);
	      } else {
	        var filterParsed = JSON.parse((0, _stringify2.default)(this.filterBy));
	        this.filterBy = filterParsed.map(function (item, i) {
	          if (filter.index === i) item = filter;
	          return item;
	        });
	      }
	      if (this.saveFilters) {
	        var oldSettingsVal = JSON.parse(this.$localStorage.get(this.tableName));
	        var newSettings = (0, _assign2.default)((0, _extends3.default)({}, oldSettingsVal), { filterBy: this.filterBy });
	        this.saveFiltersFunction((0, _stringify2.default)(newSettings));
	      }
	      this.filterData();
	      this.closeModal();
	    },
	    deleteFilterCondition: function deleteFilterCondition(filter) {
	      var index = this.filterBy.findIndex(function (element) {
	        return element === filter;
	      });
	      if (index > -1) this.filterBy.splice(index, 1);
	      this.filterData();
	      if (this.saveFilters) {
	        var oldSettingsVal = JSON.parse(this.$localStorage.get(this.tableName));
	        var newSettings = (0, _assign2.default)((0, _extends3.default)({}, oldSettingsVal), { filterBy: this.filterBy });
	        this.saveFiltersFunction((0, _stringify2.default)(newSettings));
	      }
	    },
	    closeModal: function closeModal() {
	      this.selectedFilter = {};
	      this.showFilterModal = false;
	    },
	    saveColumnSelectionFunction: function saveColumnSelectionFunction(tableAsJsonString) {
	      this.$localStorage.set(this.tableName, tableAsJsonString);
	    },
	    saveSortFunction: function saveSortFunction(tableAsJsonString) {
	      this.$localStorage.set(this.tableName, tableAsJsonString);
	    },
	    saveFiltersFunction: function saveFiltersFunction(tableAsJsonString) {
	      this.$localStorage.set(this.tableName, tableAsJsonString);
	    },
	    executeSavedSortFunction: function executeSavedSortFunction(forceSort) {
	      if (this.dataext.length > 0 && !this.initialSortExecuted || forceSort) {
	        this.onSort(this.sort);
	        this.initialSortExecuted = true;
	      }
	    },
	    loadLocalStorage: function loadLocalStorage() {
	      if (this.saveColumnSelection) {
	
	        if (JSON.parse(this.$localStorage.get(this.tableName)) && JSON.parse(this.$localStorage.get(this.tableName)).columns) {
	          this.savedColumns = JSON.parse(this.$localStorage.get(this.tableName)).columns;
	          var self = this;
	          this.columns.forEach(function (oldColumn) {
	            if (self.savedColumns.findIndex(function (savedColumn) {
	              return oldColumn.name == savedColumn.name && savedColumn.visible;
	            }) > -1) {
	              oldColumn.visible = true;
	            } else {
	              oldColumn.visible = false;
	            }
	            self.$forceUpdate();
	          });
	        }
	      }
	
	      if (this.saveFilters) {
	        if (JSON.parse(this.$localStorage.get(this.tableName)) && JSON.parse(this.$localStorage.get(this.tableName)).filterBy) {
	          this.filterBy = JSON.parse(this.$localStorage.get(this.tableName)).filterBy;
	        }
	      }
	    },
	    clickOnRow: function clickOnRow(e, selectedId) {
	      if (this.hasAutoSelection && e.target.localName !== 'input' && !e.target.closest('.datepicker-overlay')) {
	        this.$el.querySelector('.item-' + selectedId + ' input').click();
	      }
	    }
	  },
	  computed: {
	    columnCellClasses: function columnCellClasses() {
	      var result = {};
	      this.visibleColumns.map(function (column) {
	        var className = [column.name];
	        if (column && column.type && column.type == 'number') className.push('text-align-right');
	        result[column.name] = className;
	      });
	      return result;
	    },
	    isSimpleCell: function isSimpleCell() {
	      var result = {};
	      this.visibleColumns.map(function (column) {
	        result[column.name] = column.visible && column.type !== 'boolean' && column.type !== 'autocomplete' && column.type !== 'dateWithTime' && column.type !== 'dateFromTo' && column.type !== 'time' && !column.cellTemplate && !column.isObjectSelection && !column.isButtonColumn && !column.isObjectMultiSelection;
	      });
	      return result;
	    },
	    isEditableBoolean: function isEditableBoolean() {
	      var result = {};
	      this.visibleColumns.map(function (column) {
	        result[column.name] = column && typeof column.isEditable !== 'function' && column.isEditable;
	      });
	      return result;
	    },
	    visibleFilteredDataext: function visibleFilteredDataext() {
	      var _this8 = this;
	
	      var visibleValues = JSON.parse((0, _stringify2.default)(this.dataext));
	
	      if (this.visibleColumns) {
	        var sortType = this.visibleColumns.find(function (item) {
	          return item.name === _this8.sort.name;
	        });
	
	        if (sortType) {
	          if (sortType.type === 'number' && !this.customSortFunction) {
	            visibleValues.sort(function (a, b) {
	              return _this8.sort.type == 'desc' ? +b[_this8.sort.name] - +a[_this8.sort.name] : +a[_this8.sort.name] - +b[_this8.sort.name];
	            });
	          } else if (sortType.type === 'dateTime' && !this.customSortFunction) {
	            visibleValues.sort(function (a, b) {
	              if (!a[_this8.sort.name] || (0, _moment2.default)(a[_this8.sort.name], _this8.dateTimeFormat).format().toLowerCase() === 'invalid date') return 1;
	              if (!b[_this8.sort.name] || (0, _moment2.default)(b[_this8.sort.name], _this8.dateTimeFormat).format().toLowerCase() === 'invalid date') return -1;
	              if (a[_this8.sort.name] == b[_this8.sort.name]) return 0;
	              if (_this8.sort.type == 'desc') return (0, _moment2.default)((0, _moment2.default)(a[_this8.sort.name], _this8.dateTimeFormat).format()).isAfter((0, _moment2.default)(b[_this8.sort.name], _this8.dateTimeFormat).format()) ? 1 : -1;
	              return (0, _moment2.default)((0, _moment2.default)(a[_this8.sort.name], _this8.dateTimeFormat).format()).isBefore((0, _moment2.default)(b[_this8.sort.name], _this8.dateTimeFormat).format()) ? 1 : -1;
	            });
	          } else if (this.customSortFunction) {
	            visibleValues.sort(function (a, b) {
	              return _this8.customSortFunction(a, b, _this8.sort);
	            });
	          } else {
	            visibleValues.sort(function (a, b) {
	              if (_this8.sort.type == 'desc') return a[_this8.sort.name] < b[_this8.sort.name] ? 1 : -1;
	              return a[_this8.sort.name] > b[_this8.sort.name] ? 1 : -1;
	            });
	          }
	        }
	      }
	
	      var searchKey = this.searchKey && visibleValues[0] ? this.searchKey : 'name';
	      if (this.searchTerm && this.searchTerm != '' && searchKey && visibleValues[0] && !this.searchKeys) {
	        var columnToSearchBy = this.visibleColumns.find(function (c) {
	          return c.name === _this8.searchKey;
	        });
	        if (columnToSearchBy && columnToSearchBy.isObjectSelection && columnToSearchBy.objectList && columnToSearchBy.objectList != 'objectList' && this[columnToSearchBy.objectList]) {
	          var matchedIds = this[columnToSearchBy.objectList].filter(function (i) {
	            return i.name.toLowerCase().match(_this8.searchTerm.toLowerCase());
	          }).map(function (i) {
	            return ('' + i.id).toLowerCase();
	          });
	          visibleValues = visibleValues.filter(function (item) {
	            if (item[searchKey]) {
	              var searchValue = '' + item[searchKey];
	              var rez = matchedIds.indexOf(searchValue.toLowerCase());
	              return rez > -1;
	            }
	          });
	        } else {
	          visibleValues = visibleValues.filter(function (item) {
	            if (item[searchKey] && (!columnToSearchBy || columnToSearchBy && !columnToSearchBy.format)) {
	              var searchValue = '' + item[searchKey];
	              var rez = searchValue.toLowerCase().match(_this8.searchTerm.toLowerCase());
	              return rez;
	            } else if (item[searchKey] && columnToSearchBy && columnToSearchBy.format) {
	              var _searchValue = '' + (0, _moment2.default)(item[searchKey]).format(columnToSearchBy.format);
	              var _rez = _searchValue.toLowerCase().match(_this8.searchTerm.toLowerCase());
	              return _rez;
	            }
	          });
	        }
	      } else if (this.searchTerm && this.searchTerm != '' && visibleValues[0] && this.searchKeys) {
	        var columnsToSearchBy = this.visibleColumns.filter(function (c) {
	          return _this8.searchKeys.indexOf(c.name) !== -1;
	        });
	        visibleValues = visibleValues.filter(function (item) {
	          var rez = false;
	          columnsToSearchBy.forEach(function (columnToSearchBy) {
	            if (columnToSearchBy && columnToSearchBy.isObjectSelection && columnToSearchBy.objectList && columnToSearchBy.objectList != 'objectList' && _this8[columnToSearchBy.objectList] && item[columnToSearchBy.name]) {
	              var _matchedIds = _this8[columnToSearchBy.objectList].filter(function (i) {
	                return i.name.toLowerCase().match(_this8.searchTerm.toLowerCase());
	              }).map(function (i) {
	                return ('' + i.id).toLowerCase();
	              });
	              var searchValue = '' + item[columnToSearchBy.name];
	              if (_matchedIds.indexOf(searchValue.toLowerCase()) > -1) {
	                rez = true;
	              }
	            } else if (!rez && item[columnToSearchBy.name] && (!columnToSearchBy || columnToSearchBy && !columnToSearchBy.format)) {
	              var _searchValue2 = '' + item[columnToSearchBy.name];
	              if (!!_searchValue2.toLowerCase().match(_this8.searchTerm.toLowerCase())) {
	                rez = true;
	              }
	            } else if (!rez && item[columnToSearchBy.name] && columnToSearchBy && columnToSearchBy.format) {
	              var _searchValue3 = '' + (0, _moment2.default)(item[columnToSearchBy.name]).format(columnToSearchBy.format);
	              if (!!_searchValue3.toLowerCase().match(_this8.searchTerm.toLowerCase())) {
	                rez = true;
	              }
	            }
	          });
	          return rez;
	        });
	      }
	
	      var filterValue = '';
	      if (this.quickFilter && this.quickFilter.value && this.applyQuickFilter) filterValue = typeof this.quickFilter.value == 'string' ? this.quickFilter.value : (!!this.quickFilter.value).toString();
	      if (this.applyQuickFilter && this.quickFilter && this.quickFilter.title && this.quickFilter.property && filterValue === 'true') {
	        visibleValues = visibleValues.filter(function (item) {
	          var itemValue = typeof item[_this8.quickFilter.property] == 'string' ? item[_this8.quickFilter.property] : (!!item[_this8.quickFilter.property]).toString();
	          if (_this8.quickFilter.reverse) return itemValue !== filterValue;else return itemValue === filterValue;
	        });
	      }
	
	      if (this.quickFilter && this.applyQuickFilter && this.quickFilter.filterValue && this.quickFilter.conditions && this.quickFilter.property) {
	        filterValue = this.quickFilter.filterValue;
	        visibleValues = visibleValues.filter(function (item) {
	          var itemValue = item[_this8.quickFilter.property] ? item[_this8.quickFilter.property] : (!!item[_this8.quickFilter.property]).toString();
	          var result = true;
	
	          switch (_this8.quickFilter.conditions) {
	            case '>':
	              result = +itemValue > +filterValue;
	              break;
	            case '>=':
	              result = +itemValue >= +filterValue;
	              break;
	            case '<':
	              result = +itemValue < +filterValue;
	              break;
	            case '<=':
	              result = +itemValue <= +filterValue;
	              break;
	            case '==':
	              result = itemValue == filterValue;
	              break;
	            case '!=':
	              result = itemValue != filterValue;
	              break;
	            case '===':
	              result = itemValue === filterValue;
	              break;
	            case '!==':
	              result = itemValue !== filterValue;
	              break;
	          }
	          return result;
	        });
	      }
	
	      var filteredData = [];
	      for (var i = 0; i < visibleValues.length; i++) {
	        var element = visibleValues[i];
	        var rowOk = true;
	
	        var _loop = function _loop(j) {
	          var filter = _this8.filterBy[j];
	          var column = _this8.columns.find(function (c) {
	            return c.name === filter.column;
	          });
	          var value = element[filter.column] + '';
	          if (column && column.filterByValue) {
	            value = '' + column.filterByValue(element);
	          }
	
	          if (filter.columnType !== 'number' && !filter.filterObjectSelection && value && filter.filterValue && value != '') {
	            if (filter.filterCondition == '=') {
	              if (value.toLowerCase() !== filter.filterValue.toLowerCase()) rowOk = false;
	            } else if (filter.filterCondition == 'Contains') {
	              if (value.toLowerCase().indexOf(filter.filterValue.toLowerCase()) === -1) {
	                rowOk = false;
	              }
	            } else if (filter.filterCondition == 'Starts with' && !value.toLowerCase().startsWith(filter.filterValue.toLowerCase())) {
	              rowOk = false;
	            } else if (filter.filterCondition == 'Ends with' && !value.toLowerCase().endsWith(filter.filterValue.toLowerCase())) {
	              rowOk = false;
	            }
	          } else if (!filter.filterObjectSelection && value && filter.filterValue && value != '') {
	            if (filter.filterCondition == '-' && value != filter.filterValue) {
	              rowOk = false;
	            } else if (filter.filterCondition == '>' && value <= filter.filterValue) {
	              rowOk = false;
	            } else if (filter.filterCondition == '>=' && value < filter.filterValue) {
	              rowOk = false;
	            } else if (filter.filterCondition == '<' && value >= filter.filterValue) {
	              rowOk = false;
	            } else if (filter.filterCondition == '<=' && value > filter.filterValue) {
	              rowOk = false;
	            } else if (filter.filterCondition == '!=' && value == filter.filterValue) {
	              rowOk = false;
	            }
	          } else if ((value || value + '' === 'false') && filter.filterValues && filter.filterValues != '' && filter.filterValues.indexOf(value + '') === -1) {
	            rowOk = false;
	          } else if (!value && filter.filterValue && filter.columnType !== "boolean") {
	            rowOk = false;
	          } else if ((!value || value && value == '') && filter.columnType !== "boolean") {
	            rowOk = false;
	          }
	        };
	
	        for (var j = 0; j < this.filterBy.length; j++) {
	          _loop(j);
	        };
	        if (rowOk) filteredData.push(element);
	      };
	      visibleValues = filteredData;
	
	      this.totalSize = visibleValues.length;
	
	      return visibleValues;
	    },
	    paginatedDataext: function paginatedDataext() {
	      var visibleValues = this.visibleFilteredDataext;
	      if (this.pagination && this.pagination.size && Math.ceil(this.totalSize / this.pagination.size) < this.page) {
	        this.page = 1;
	      }
	
	      if (this.pagination && this.pagination.size) {
	        var tempData = JSON.parse((0, _stringify2.default)(visibleValues));
	        visibleValues = tempData.splice((this.page - 1) * this.pagination.size, this.pagination.size);
	      }
	      return visibleValues;
	    }
	  }
	};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(14);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueDatepickerEs = __webpack_require__(163);
	
	var _vueDatepickerEs2 = _interopRequireDefault(_vueDatepickerEs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'datePickerWrapper',
	  components: {
	    Datepicker: _vueDatepickerEs2.default
	  },
	  props: ['row', 'limit', 'value', 'disabled', 'placeholder', 'format', 'datepickerOptions'],
	  data: function data() {
	    return {
	      visibleData: {
	        time: typeof this.value != 'undefined' && (0, _moment2.default)(this.value).isValid() ? this.value : ''
	      },
	      actualLimit: [],
	      option: {
	        type: 'min',
	        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
	        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	        placeholder: this.placeholder
	      }
	    };
	  },
	
	  watch: {
	    value: function value(val) {
	      this.visibleData.time = typeof val != 'undefined' && (0, _moment2.default)(val).isValid() ? val : '';
	    },
	    datepickerOptions: function datepickerOptions(val) {
	      if (val && typeof val === "function") this.option = (0, _assign2.default)(this.option, val(this.row));else if (val) this.option = (0, _assign2.default)(this.option, val);
	    },
	    limit: function limit(val) {
	      if (val && typeof val === "function") this.actualLimit = val(this.row);else if (val) this.actualLimit = val;
	    }
	  },
	  methods: {
	    clickOnTempDate: function clickOnTempDate() {
	      if (!this.disabled) this.$refs.datepicker.showCheck();
	    },
	    visibleDataChange: function visibleDataChange(value) {
	      this.$emit('input', value);
	      this.$emit('blur', value);
	      this.$emit('change', value);
	    }
	  },
	  created: function created() {
	    if (this.datepickerOptions && typeof this.datepickerOptions === "function") this.option = (0, _assign2.default)(this.option, this.datepickerOptions(this.row));else if (this.datepickerOptions) this.option = (0, _assign2.default)(this.option, this.datepickerOptions);
	
	    if (this.limit && typeof this.limit === "function") this.actualLimit = this.limit(this.row);else if (this.limit) this.actualLimit = this.limit;
	  },
	
	  computed: {
	    visibleTempDate: function visibleTempDate() {
	      if (this.visibleData.time == '') return '-';
	      var timeZone = (0, _moment2.default)().utcOffset();
	      return (0, _moment2.default)(this.visibleData.time).format(this.format);
	    }
	  }
	};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'filterModal',
	  components: {},
	  methods: {
	    setColumnChanged: function setColumnChanged(column) {
	      this.filter.columnDisplayName = column.displayName;
	      this.filter.columnName = column.name;
	      this.filter.columnType = column.type;
	      this.filter.filterObjectSelection = column.filterObjectSelection;
	      var self = this;
	      if (this.filter.filterObjectSelection && !(this.customFilterOptions && this.customFilterOptions[this.filter.columnName])) {
	        this.filter.filterCondition = '';
	        this.filter.filterValue = '';
	        self.filterValues.length = 0;
	        this.data.forEach(function (item) {
	          if (self.filterValues.indexOf(item[self.filter.columnName]) === -1) {
	            console.log('item[self.filter.columnName]', item[self.filter.columnName]);
	            self.filterValues.push(item[self.filter.columnName]);
	          }
	        });
	
	        this.filterValues = this.filterValues.sort();
	      } else if (this.customFilterOptions && this.customFilterOptions[this.filter.columnName]) {
	        this.filterValues = this.customFilterOptions[this.filter.columnName];
	      } else {
	        self.selectedFilterValues = [];
	      }
	
	      this.setFilterConditions(this.filter.columnType);
	      this.checkFilter();
	      this.$forceUpdate();
	    },
	    checkFilter: function checkFilter() {
	      var returnValue = true;
	      this.filter.filterValues = this.selectedFilterValues;
	      var filter = this.filter;
	      if (filter && filter.column && filter.column.length > 0 && (filter.filterValue && filter.filterValue.length > 0 && !filter.filterObjectSelection && filter.filterCondition && filter.filterCondition.length > 0 || filter.filterObjectSelection && filter.filterValues && filter.filterValues.length > 0)) {
	        returnValue = false;
	      }
	      this.disableOk = returnValue;
	    },
	    setFilterConditions: function setFilterConditions(type) {
	      this.filterConditions = [];
	      this.filterConditions = this.filterConditionsString;
	      if (type === 'number') {
	        this.filterConditions = this.filterConditionsNumber;
	      }
	    },
	    unselectFilterValue: function unselectFilterValue(filterValue) {
	      var index = this.selectedFilterValues.findIndex(function (element) {
	        return element === filterValue;
	      });
	      if (index > -1) this.selectedFilterValues.splice(index, 1);
	      this.checkFilter();
	    }
	  },
	  watch: {
	    filter: {
	      handler: function handler() {
	        this.checkFilter();
	      },
	      deep: true
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.filter.column && this.filter.column.length > 0) {
	      this.setFilterConditions(this.filter.columnType);
	    }
	
	    if (this.data && this.data.length > 0 && this.filter.columnName && !(this.customFilterOptions && this.customFilterOptions[this.filter.columnName])) {
	      var self = this;
	      self.filterValues.length = 0;
	      this.data.forEach(function (item) {
	        if (self.filterValues.indexOf(item[self.filter.columnName]) === -1) {
	          self.filterValues.push(item[self.filter.columnName]);
	        }
	      });
	    } else if (this.customFilterOptions && this.customFilterOptions[this.filter.columnName]) {
	      this.filterValues = this.customFilterOptions[this.filter.columnName];
	    }
	
	    if (this.filter.filterValues && this.filter.filterValues.length > 0) {
	      var lostFilterValues = this.filter.filterValues.filter(function (i) {
	        if (_this.filter.columnType == 'boolean') {
	          return _this.filterValues.indexOf(Boolean(i)) === -1;
	        } else {
	          return _this.filterValues.indexOf(i) === -1;
	        }
	      });
	      this.filterValues = this.filterValues.concat(lostFilterValues);
	      this.selectedFilterValues = this.filter.filterValues;
	    }
	  },
	
	  props: ['filter', 'columns', 'data', 'customFilterOptions'],
	  data: function data() {
	    return {
	      filterConditions: [],
	      filterConditionsString: ['=', 'Contains', 'Starts with', 'Ends with'],
	      filterConditionsNumber: ['=', '>=', '>', '<=', '<', '!='],
	      filterConditionsObject: [],
	      disableOk: true,
	      filterValues: [],
	      selectedFilterValues: []
	    };
	  }
	};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    required: false,
	    date: {
	      type: Object,
	      required: true
	    },
	    option: {
	      type: Object,
	      default: function _default() {
	        return {
	          type: 'day',
	          SundayFirst: false,
	          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
	          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	          format: 'YYYY-MM-DD',
	          color: {
	            checked: '#F50057',
	            header: '#3f51b5',
	            headerText: '#fff'
	          },
	          inputStyle: {
	            'display': 'inline-block',
	            'padding': '6px',
	            'line-height': '22px',
	            'font-size': '16px',
	            'border': '2px solid #fff',
	            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
	            'border-radius': '2px',
	            'color': '#5F5F5F'
	          },
	          placeholder: 'when?',
	          buttons: {
	            ok: 'OK',
	            cancel: 'Cancel'
	          },
	          overlayOpacity: 0.5,
	          dismissible: true
	        };
	      }
	    },
	    limit: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    function hours() {
	      var list = [];
	      var hour = 24;
	      while (hour > 0) {
	        hour--;
	        list.push({
	          checked: false,
	          value: hour < 10 ? '0' + hour : hour
	        });
	      }
	      return list;
	    }
	    function mins() {
	      var list = [];
	      var min = 60;
	      while (min > 0) {
	        min--;
	        list.push({
	          checked: false,
	          value: min < 10 ? '0' + min : min
	        });
	      }
	      return list;
	    }
	    return {
	      hours: hours(),
	      mins: mins(),
	      showInfo: {
	        hour: false,
	        day: false,
	        month: false,
	        year: false,
	        check: false
	      },
	      displayInfo: {
	        month: ''
	      },
	      library: {
	        week: this.option.week,
	        month: this.option.month,
	        year: []
	      },
	      checked: {
	        oldtime: '',
	        currentMoment: null,
	        year: '',
	        month: '',
	        day: '',
	        hour: '00',
	        min: '00'
	      },
	      dayList: [],
	      selectedDays: []
	    };
	  },
	
	  methods: {
	    pad: function pad(n) {
	      n = Math.floor(n);
	      return n < 10 ? '0' + n : n;
	    },
	    nextMonth: function nextMonth(type) {
	      var next = null;
	      type === 'next' ? next = (0, _moment2.default)(this.checked.currentMoment).add(1, 'M') : next = (0, _moment2.default)(this.checked.currentMoment).add(-1, 'M');
	      this.showDay(next);
	    },
	    showDay: function showDay(time) {
	      if (time === undefined || !Date.parse(time)) {
	        this.checked.currentMoment = (0, _moment2.default)();
	      } else {
	        this.checked.currentMoment = (0, _moment2.default)(time, this.option.format);
	      }
	      this.showOne('day');
	      this.checked.year = (0, _moment2.default)(this.checked.currentMoment).format('YYYY');
	      this.checked.month = (0, _moment2.default)(this.checked.currentMoment).format('MM');
	      this.checked.day = (0, _moment2.default)(this.checked.currentMoment).format('DD');
	      this.displayInfo.month = this.library.month[(0, _moment2.default)(this.checked.currentMoment).month()];
	      var days = [];
	      var currentMoment = this.checked.currentMoment;
	      var firstDay = (0, _moment2.default)(currentMoment).date(1).day();
	      // gettting previous and next month
	      // let currentMonth = moment(currentMoment)
	      var previousMonth = (0, _moment2.default)(currentMoment);
	      var nextMonth = (0, _moment2.default)(currentMoment);
	      nextMonth.add(1, 'months');
	      previousMonth.subtract(1, 'months');
	      var monthDays = (0, _moment2.default)(currentMoment).daysInMonth();
	      var oldtime = this.checked.oldtime;
	      for (var i = 1; i <= monthDays; ++i) {
	        days.push({
	          value: i,
	          inMonth: true,
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).date(i)
	        });
	        if (i === Math.ceil((0, _moment2.default)(currentMoment).format('D')) && (0, _moment2.default)(oldtime, this.option.format).year() === (0, _moment2.default)(currentMoment).year() && (0, _moment2.default)(oldtime, this.option.format).month() === (0, _moment2.default)(currentMoment).month()) {
	          days[i - 1].checked = true;
	        }
	        this.checkBySelectDays(i, days);
	      }
	      if (firstDay === 0) firstDay = 7;
	      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
	        var passiveDay = {
	          value: previousMonth.daysInMonth() - _i,
	          inMonth: false,
	          action: 'previous',
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).date(1).subtract(_i + 1, 'days')
	        };
	        days.unshift(passiveDay);
	      }
	      if (this.limit.length > 0) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = this.limit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var li = _step.value;
	
	            switch (li.type) {
	              case 'fromto':
	                days = this.limitFromTo(li, days);
	                break;
	              case 'weekday':
	                days = this.limitWeekDay(li, days);
	                break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      var passiveDaysAtFinal = 42 - days.length;
	      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
	        var _passiveDay = {
	          value: _i2,
	          inMonth: false,
	          action: 'next',
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).add(1, 'months').date(_i2)
	        };
	        days.push(_passiveDay);
	      }
	      this.dayList = days;
	    },
	    checkBySelectDays: function checkBySelectDays(d, days) {
	      var _this = this;
	
	      this.selectedDays.forEach(function (day) {
	        if (_this.checked.year === (0, _moment2.default)(day).format('YYYY') && _this.checked.month === (0, _moment2.default)(day).format('MM') && d === Math.ceil((0, _moment2.default)(day).format('D'))) {
	          days[d - 1].checked = true;
	        }
	      });
	    },
	    limitWeekDay: function limitWeekDay(limit, days) {
	      days.map(function (day) {
	        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
	          day.unavailable = true;
	        }
	      });
	      return days;
	    },
	    limitFromTo: function limitFromTo(limit, days) {
	      var _this2 = this;
	
	      if (limit.from || limit.to) {
	        days.map(function (day) {
	          if (_this2.getLimitCondition(limit, day)) {
	            day.unavailable = true;
	          }
	        });
	      }
	      return days;
	    },
	    getLimitCondition: function getLimitCondition(limit, day) {
	      var tmpMoment = (0, _moment2.default)(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value));
	      if (limit.from && !limit.to) {
	        return !tmpMoment.isAfter(limit.from);
	      } else if (!limit.from && limit.to) {
	        return !tmpMoment.isBefore(limit.to);
	      } else {
	        return !tmpMoment.isBetween(limit.from, limit.to);
	      }
	    },
	    checkDay: function checkDay(obj) {
	      if (obj.unavailable || obj.value === '') {
	        return false;
	      }
	      if (!obj.inMonth) {
	        this.nextMonth(obj.action);
	      }
	      if (this.option.type === 'day' || this.option.type === 'min') {
	        this.dayList.forEach(function (x) {
	          x.checked = false;
	        });
	        this.checked.day = this.pad(obj.value);
	        obj.checked = true;
	      } else {
	        var day = this.pad(obj.value);
	        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
	        if (obj.checked === true) {
	          obj.checked = false;
	          this.selectedDays.$remove(ctime);
	        } else {
	          this.selectedDays.push(ctime);
	          obj.checked = true;
	        }
	      }
	      switch (this.option.type) {
	        case 'day':
	          this.picked();
	          break;
	        case 'min':
	          this.showOne('hour');
	          // shift activated time items to visible position.
	          this.shiftActTime();
	          break;
	      }
	    },
	    showYear: function showYear() {
	      var _this3 = this;
	
	      var year = (0, _moment2.default)(this.checked.currentMoment).year();
	      this.library.year = [];
	      var yearTmp = [];
	      for (var i = year - 100; i < year + 5; ++i) {
	        yearTmp.push(i);
	      }
	      this.library.year = yearTmp;
	      this.showOne('year');
	      this.$nextTick(function () {
	        var listDom = document.getElementById('yearList');
	        listDom.scrollTop = listDom.scrollHeight - 100;
	        _this3.addYear();
	      });
	    },
	    showOne: function showOne(type) {
	      switch (type) {
	        case 'year':
	          this.showInfo.hour = false;
	          this.showInfo.day = false;
	          this.showInfo.year = true;
	          this.showInfo.month = false;
	          break;
	        case 'month':
	          this.showInfo.hour = false;
	          this.showInfo.day = false;
	          this.showInfo.year = false;
	          this.showInfo.month = true;
	          break;
	        case 'day':
	          this.showInfo.hour = false;
	          this.showInfo.day = true;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          break;
	        case 'hour':
	          this.showInfo.hour = true;
	          this.showInfo.day = false;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          break;
	        default:
	          this.showInfo.day = true;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          this.showInfo.hour = false;
	      }
	    },
	    showMonth: function showMonth() {
	      this.showOne('month');
	    },
	    addYear: function addYear() {
	      var _this4 = this;
	
	      var listDom = document.getElementById('yearList');
	      listDom.addEventListener('scroll', function (e) {
	        if (listDom.scrollTop < listDom.scrollHeight - 100) {
	          var len = _this4.library.year.length;
	          var lastYear = _this4.library.year[len - 1];
	          _this4.library.year.push(lastYear + 1);
	        }
	      }, false);
	    },
	    setYear: function setYear(year) {
	      this.checked.currentMoment = (0, _moment2.default)(year + '-' + this.checked.month + '-' + this.checked.day);
	      this.showDay(this.checked.currentMoment);
	    },
	    setMonth: function setMonth(month) {
	      var mo = this.library.month.indexOf(month) + 1;
	      if (mo < 10) {
	        mo = '0' + '' + mo;
	      }
	      this.checked.currentMoment = (0, _moment2.default)(this.checked.year + '-' + mo + '-' + this.checked.day);
	      this.showDay(this.checked.currentMoment);
	    },
	    showCheck: function showCheck() {
	      if (this.date.time === '') {
	        this.showDay();
	      } else {
	        if (this.option.type === 'day' || this.option.type === 'min') {
	          this.checked.oldtime = this.date.time;
	          this.showDay(this.date.time);
	        } else {
	          this.selectedDays = JSON.parse(this.date.time);
	          if (this.selectedDays.length) {
	            this.checked.oldtime = this.selectedDays[0];
	            this.showDay(this.selectedDays[0]);
	          } else {
	            this.showDay();
	          }
	        }
	      }
	      this.showInfo.check = true;
	    },
	    setTime: function setTime(type, obj, list) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = list[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var item = _step2.value;
	
	          item.checked = false;
	          if (item.value === obj.value) {
	            item.checked = true;
	            this.checked[type] = item.value;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    },
	    picked: function picked() {
	      if (this.option.type === 'day' || this.option.type === 'min') {
	        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
	        this.checked.currentMoment = (0, _moment2.default)(ctime, 'YYYY-MM-DD HH:mm');
	        this.date.time = (0, _moment2.default)(this.checked.currentMoment).format(this.option.format);
	      } else {
	        this.date.time = JSON.stringify(this.selectedDays);
	      }
	      this.showInfo.check = false;
	      this.$emit('change', this.date.time);
	    },
	    dismiss: function dismiss(evt) {
	      if (evt.target.className === 'datepicker-overlay') {
	        if (this.option.dismissible === undefined || this.option.dismissible) {
	          this.showInfo.check = false;
	          this.$emit('cancel');
	        }
	      }
	    },
	    shiftActTime: function shiftActTime() {
	      // shift activated time items to visible position.
	      this.$nextTick(function () {
	        if (!document.querySelector('.hour-item.active')) {
	          return false;
	        }
	        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
	        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
	      });
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'wbNav',
	  props: ['showItems', 'userName', 'navbarItems', 'profileMenuItems', 'mainColor', 'navLogo', 'title', 'vuexUsing', 'userMenuDirection', 'usePinkLogo', 'backgroundColor', 'textColor', 'textHoverColor', 'separatorColor'],
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	  updated: function updated() {},
	
	  watch: {},
	  methods: {
	    itemOnclick: function itemOnclick(item) {
	      if (!this.vuexUsing) {
	        this.navbarItems.forEach(function (navItem) {
	          if (navItem.id === item.id) {
	            navItem.active = true;
	          } else {
	            navItem.active = false;
	          }
	        });
	      }
	      item.onClick(item);
	    },
	    profileMenuItemOnClick: function profileMenuItemOnClick(item) {
	      if (!this.vuexUsing) {
	        this.navbarItems.forEach(function (navItem) {
	          return navItem.active = false;
	        });
	      }
	      item.onClick(item);
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _wbNav = __webpack_require__(274);
	
	var _wbNav2 = _interopRequireDefault(_wbNav);
	
	var _vuex = __webpack_require__(3);
	
	var _sidebar = __webpack_require__(294);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(8);
	
	exports.default = {
	  name: "app",
	  components: {
	    wbNav: _wbNav2.default,
	    sidebar: _sidebar2.default
	  },
	  mounted: function mounted() {
	    // if (this.$route.path !== '/activate' && this.$route.path !== '/login') {
	    //     if ((this.services && this.services.length === 0) || !this.services)
	    //         this.$store.dispatch('getServices');
	    // }
	  },
	
	  methods: {
	    closeSidebar: function closeSidebar() {
	      this.showSidebar = false;
	    },
	    toggleNotification: function toggleNotification() {
	      this.sideBarType = "notifications";
	      this.sideBarTitle = "notification center";
	      _.sortBy(_.sortBy(this.alarmMessages, "serviceName"), "time");
	      this.sideBarData = this.alarmMessages;
	      this.showSidebar = !this.showSidebar;
	    }
	  },
	  data: function data() {
	    return {
	      showSidebar: false,
	      sideBarType: "notifications",
	      sideBarTitle: "notification center",
	      sideBarData: {},
	      alarmMessages: []
	    };
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)(["message", "messageRandom", "pending", "apps", "assignments", "route", "isLoggedIn", "navbarItems", "profileMenuItems", "services"]), {
	    navbarItemsLocal: function navbarItemsLocal() {
	      return this.navbarItems;
	    },
	    alarmsCount: function alarmsCount() {
	      return this.alarmMessages.filter(function (e) {
	        return !e.isRead;
	      }).length;
	    },
	    logoPath: function logoPath() {
	      if (_utils2.default.isQuinyx()) {
	        return "/static/quinyx.svg";
	      } else {
	        return "/static/logo-white.png";
	      }
	    }
	  }),
	  watch: {
	    messageRandom: function messageRandom(newValue, oldValue) {
	      if (newValue) {
	        this.$refs.snackbar.open();
	      }
	    },
	
	    // isLoggedIn(newValue, oldValue) {
	    //   const path = this.$router.currentRoute.path;
	    //   const notNeedRedirectPaths = [
	    //     "/externallogin",
	    //     "/quinyx-sign-in",
	    //     "/activate",
	    //     "/login",
	    //   ];
	
	    //   if (!newValue && !notNeedRedirectPaths.includes(path)) {
	    //     this.$router.push("login");
	    //   }
	    // },
	    route: function route(newValue, oldValue) {
	      this.$router.push(newValue);
	    }
	  }
	};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(13);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	var _quinyxGreen = __webpack_require__(161);
	
	var _quinyxGreen2 = _interopRequireDefault(_quinyxGreen);
	
	var _params = __webpack_require__(10);
	
	var _params2 = _interopRequireDefault(_params);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  name: "Activate",
	  data: function data() {
	    return {
	      correctAccess: true,
	      activationSuccess: false,
	      countDown: 10,
	      logoUrl: _quinyxGreen2.default,
	      email: null,
	      key: null,
	      application: null,
	      firstname: null,
	      organization: null,
	      username: null,
	      password: null,
	      passwordRepeat: null,
	      usernameRequirements: [],
	      passwordRequirements: [],
	      passwordRepeatRequirements: [],
	      isUsernameValid: false,
	      isPasswordValid: false,
	      isPasswordRepeatValid: false,
	      clientId: null,
	      clientSecret: null
	    };
	  },
	
	  watch: {
	    username: function username(val) {
	      var _this = this;
	
	      this.usernameRequirements = [];
	
	      // Min username length should be 8 characters
	      if (val.length < 8) {
	        this.isUsernameValid = false;
	        this.usernameRequirements.push("Username must contain at least 8 characters");
	      } else {
	        _managedata2.default.validateUsername(this.email, this.username).then(function (res) {
	          if (res.body.result.requirements && res.body.result.requirements.length > 0) {
	            _this.usernameRequirements = res.body.result.requirements;
	            _this.isUsernameValid = false;
	          } else {
	            _this.isUsernameValid = true;
	          }
	        }).catch(function (err) {
	          _this.isUsernameValid = false;
	          console.log(err);
	        });
	      }
	    },
	    password: function password(val) {
	      var _this2 = this;
	
	      this.passwordRequirements = [];
	
	      // Min password length should be 8 characters
	      if (val.length < 8) {
	        this.isPasswordValid = false;
	        this.passwordRequirements.push("Password must contain at least 8 characters");
	      } else {
	        _managedata2.default.validatePassword(this.password).then(function (res) {
	          if (res.body.result.requirements && res.body.result.requirements.length > 0) {
	            _this2.passwordRequirements = res.body.result.requirements;
	            _this2.isPasswordValid = false;
	          } else {
	            _this2.isPasswordValid = true;
	          }
	        }).catch(function (err) {
	          _this2.isPasswordValid = false;
	          console.log(err);
	        });
	      }
	    },
	    passwordRepeat: function passwordRepeat(val) {
	      this.passwordRepeatRequirements = [];
	
	      // Min password length should be 8 characters
	      if (val.length >= 8) {
	        this.isPasswordRepeatValid = this.password === this.passwordRepeat;
	
	        if (!this.isPasswordRepeatValid) {
	          this.passwordRepeatRequirements.push("Passwords should match");
	        }
	      } else {
	        this.isPasswordRepeatValid = false;
	      }
	    },
	
	    countDown: {
	      handler: function handler(value) {
	        var _this3 = this;
	
	        if (value > 0) {
	          setTimeout(function () {
	            _this3.countDown--;
	          }, 1000);
	        } else {
	          if (!this.correctAccess || this.activationSuccess) this.redirectToALFA();
	        }
	      },
	
	      immediate: true
	    }
	  },
	  methods: {
	    redirectToALFA: function redirectToALFA() {
	      var url = _params2.default.getParameterValue("ALFA_URL");
	      window.open(url, "_self");
	    },
	    checkActivateKeyEmail: function checkActivateKeyEmail() {
	      var _this4 = this;
	
	      _managedata2.default.checkActivateKeyEmail(this.email, this.key).then(function (res) {
	        if (!res.body) {
	          _this4.correctAccess = false;
	          _this4.countDown = 10;
	        } else {
	          _this4.correctAccess = true;
	          return true;
	        }
	      }).catch(function (err) {
	        _this4.correctAccess = false;
	        _this4.countDown = 10;
	      });
	    },
	    getUserDetails: function getUserDetails() {
	      var _this5 = this;
	
	      _managedata2.default.getDescriptionValues(this.email, this.key).then(function (res) {
	        _this5.application = res.body.application;
	        _this5.firstname = res.body.firstname;
	        _this5.organization = res.body.organization;
	      }).catch(function (err) {
	        _this5.$store.commit("CLEAR_MESSAGE");
	        _this5.$store.commit({
	          type: "SET_MESSAGE",
	          message: "The key has expired. Please contact WidgetBrain (support@widgetbrain.com / +31103130313) for assistance."
	        });
	      });
	    },
	    activateUser: function activateUser() {
	      var _this6 = this;
	
	      if (!this.isUsernameValid || !this.isPasswordValid || !this.isPasswordRepeatValid) {
	        return;
	      }
	
	      var newUser = {
	        username: this.username,
	        password: this.password,
	        key: this.key,
	        email: this.email
	      };
	
	      _managedata2.default.activateUser(newUser).then(function (res) {
	        _this6.$store.commit("CLEAR_MESSAGE");
	        _this6.$store.commit({
	          type: "SET_MESSAGE",
	          message: "Activation successful!"
	        });
	
	        _this6.activationSuccess = true;
	        _this6.countDown = 5;
	
	        // const user = {
	        //   email: this.email,
	        //   password: this.password,
	        // };
	
	        // setTimeout(() => {
	        //   this.$store
	        //     .dispatch("login", {
	        //       user,
	        //       remember: true,
	        //       rememberAll: true,
	        //       isExternal: true,
	        //     })
	        //     .then((res) => {
	        //       const message = {
	        //         message: "loggedIn",
	        //         token: res.body.id,
	        //         userId: res.body.userId,
	        //         remember: true,
	        //       };
	        //       this.redirectToALFA();
	        //       // window.parent.postMessage(message, "*");
	        //     })
	        //     .catch((err) => {
	        //       console.log("Error: ", err);
	        //       if (this.isExternal) {
	        //         window.parent.postMessage({ message: "loggedOut" }, "*");
	        //       }
	        //     });
	        // }, 3000);
	      }).catch(function (err) {
	        _this6.$store.commit("CLEAR_MESSAGE");
	        _this6.$store.commit({
	          type: "SET_MESSAGE",
	          message: err.body.error.message
	        });
	      });
	    },
	    loginUser: function loginUser() {
	      var _this7 = this;
	
	      this.$refs.credentialsDialog.close();
	      // login user
	      this.$store.dispatch("login", {
	        user: {
	          email: this.email,
	          password: this.password
	        },
	        remember: true,
	        rememberAll: true,
	        isExternal: false
	      }).then(function (res) {
	        _this7.$store.dispatch("getApps").then(function () {
	          var userApps = _this7.$store.state.apps.filter(function (app) {
	            return app.id !== _config2.default.appId;
	          });
	          if (userApps.length > 1 || userApps.length === 1 && userApps[0].url === null) {
	            return _this7.$store.dispatch("getAssignments");
	          }
	        });
	      }).catch(function (err) {});
	    }
	  },
	  mounted: function mounted() {
	    this.email = this.$route.query.email;
	    this.key = this.$route.query.key;
	
	    if (this.checkActivateKeyEmail()) {
	      this.getUserDetails();
	    }
	  }
	};

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  name: 'Admin'
	};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _WBDataTable = __webpack_require__(5);
	
	var _WBDataTable2 = _interopRequireDefault(_WBDataTable);
	
	var _vuex = __webpack_require__(3);
	
	var _vueMultiselect = __webpack_require__(6);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: "AdminAppGroups",
	    components: {
	        'wb-datatable': _WBDataTable2.default,
	        'multiselect': _vueMultiselect2.default
	    },
	    data: function data() {
	        return {
	            tableAppProps: {
	                dataext: [],
	                columns: null,
	                hasControls: true,
	                allowCreation: true,
	                disableSearch: false,
	                pagination: {
	                    size: 50
	                }
	            },
	            tableAppColumns: [{ name: 'id', displayName: 'ID', visible: true, type: 'number', isEditable: false, width: '20px' }, { name: 'Name', displayName: 'Name', visible: true, type: 'string', isEditable: false }, { name: 'Category', displayName: 'Category', visible: true, type: 'string', isEditable: false }, { name: 'image', displayName: 'Image URL', visible: true, type: 'string', isEditable: false }],
	            appGroup: null,
	            isNew: true
	        };
	    },
	    methods: {
	        getAppGroups: function getAppGroups() {
	            var _this = this;
	
	            _managedata2.default.getAppGroups().then(function (res) {
	                _this.tableAppProps.dataext = res.body;
	                _this.tableAppProps.columns = _this.tableAppColumns;
	            });
	        },
	        openDialog: function openDialog(row) {
	            this.isNew = !row;
	            this.appGroup = this.isNew ? {} : row;
	            this.$refs.dialog.open();
	        },
	        closeDialog: function closeDialog(isSaved) {
	            var _this2 = this;
	
	            if (isSaved) {
	                if (this.isNew) {
	                    _managedata2.default.createAppGroup(this.appGroup).then(function (res) {
	                        _this2.getAppGroups();
	                        _this2.$refs.dialog.close();
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                } else {
	                    _managedata2.default.updateAppGroup(this.appGroup).then(function (res) {
	                        _this2.getAppGroups();
	                        _this2.$refs.dialog.close();
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                }
	            } else {
	                this.$refs.dialog.close();
	            }
	        },
	        openConfirmDialog: function openConfirmDialog(row) {
	            this.appGroup = row;
	            this.$refs.confirmDialog.open();
	        },
	        closeConfirmDialog: function closeConfirmDialog(isSaved) {
	            var _this3 = this;
	
	            if (isSaved) {
	                _managedata2.default.deleteAppGroup(this.appGroup.id).then(function (res) {
	                    _this3.getAppGroups();
	                    _this3.$refs.confirmDialog.close();
	                });
	            } else {
	                this.$refs.confirmDialog.close();
	            }
	        }
	    },
	    mounted: function mounted() {
	        this.getAppGroups();
	    }
	};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _WBDataTable = __webpack_require__(5);
	
	var _WBDataTable2 = _interopRequireDefault(_WBDataTable);
	
	var _vuex = __webpack_require__(3);
	
	var _validators = __webpack_require__(19);
	
	var _vueMultiselect = __webpack_require__(6);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'AdminApps',
	    components: {
	        'wb-datatable': _WBDataTable2.default,
	        'multiselect': _vueMultiselect2.default
	    },
	    data: function data() {
	        return {
	            algorithm: null,
	            newAlgData: {},
	            customerTags: [],
	            app: null,
	            isNew: false,
	            tableAppProps: {
	                dataext: [],
	                columns: null,
	                hasControls: true,
	                allowCreation: true,
	                disableSearch: false,
	                pagination: {
	                    size: 50
	                }
	            },
	            tableAppColumns: [{ name: 'id', displayName: 'ID', visible: true, type: 'number', isEditable: false, width: '20px' }, { name: 'Name', displayName: 'App Name', visible: true, type: 'string', isEditable: false }, { name: 'environment', displayName: 'Environment', visible: true, type: 'string', isEditable: false }, { name: 'Category', displayName: 'App Category', visible: true, type: 'string', isEditable: false }, { name: 'wbAppGroup', displayName: 'App Group', visible: true, type: 'string', isEditable: false }, {
	                name: 'image',
	                displayName: 'Image',
	                visible: true,
	                type: 'string',
	                isEditable: false,
	                width: '80px'
	            }, { name: 'url', displayName: 'Url', visible: true, type: 'string', isEditable: false, width: '150px' }, {
	                name: 'audienceParameter',
	                displayName: 'Audience parameter',
	                visible: true,
	                type: 'string',
	                isEditable: false
	            }],
	            environments: ['Develop', 'Test', 'Acceptance', 'Production'],
	            deleteAnAudience: false,
	            appGroups: [],
	            selectedAppGroup: null,
	            createNewAppGroup: true
	        };
	    },
	
	    validations: {},
	    watch: {
	        'newAlgData.platform': function newAlgDataPlatform(val) {
	            this.$store.dispatch('getRegionsForPlatform', val);
	        },
	        'newAlgData.category': function newAlgDataCategory(val) {
	            this.generateAlgorithmKey();
	            if (this.algorithm) this.generateAlgorithmGroupKey();
	        },
	        'newAlgData': function newAlgData(val) {
	            this.generateAlgorithmKey();
	            if (this.algorithm) this.generateAlgorithmGroupKey();
	        },
	        'newAlgData.environment': function newAlgDataEnvironment(val) {
	            this.generateAlgorithmKey();
	        },
	        selectedAppGroup: function selectedAppGroup(val) {
	            if (val) {
	                this.app.Name = val.Name;
	                this.app.Category = val.Category;
	                this.app.image = val.image;
	            } else if (this.isNew) {
	                this.app.Name = '';
	                this.app.Category = '';
	                this.app.image = '';
	            }
	        },
	        createNewAppGroup: function createNewAppGroup() {
	            var _this = this;
	
	            if (this.app.wbAppGroupId) {
	                this.selectedAppGroup = this.appGroups.find(function (group) {
	                    return group.id === _this.app.wbAppGroupId;
	                });
	            } else {
	                this.selectedAppGroup = null;
	            }
	        }
	    },
	    computed: _extends({}, (0, _vuex.mapGetters)(['apps', 'audiences', 'baasAlgorithms', 'protocols', 'invocationTypes', 'platforms', 'regionsForPlatforms', 'services', 'baasEnvs', 'baasCategories']), {
	        baasValidMessage: function baasValidMessage() {
	            var res = {};
	            if (!this.newAlgData) return res;
	
	            if (!this.newAlgData.name) {
	                res.name = 'field is required';
	            }
	            if (!this.newAlgData.category) {
	                res.category = 'field is required';
	            }
	            if (!this.newAlgData.service) {
	                res.service = 'field is required';
	            }
	            if (!this.newAlgData.environment) {
	                res.environment = 'field is required';
	            }
	            if (!this.newAlgData.invocationType) {
	                res.invocationType = 'field is required';
	            }
	            if (!this.newAlgData.protocol) {
	                res.protocol = 'field is required';
	            }
	            if (!this.newAlgData.platform) {
	                res.platform = 'field is required';
	            }
	            if (!this.newAlgData.region) {
	                res.region = 'field is required';
	            }
	            return res;
	        }
	    }),
	    methods: {
	        createBaasChange: function createBaasChange(val) {
	            if (val) {
	                console.log(this.app);
	                this.newAlgData = {
	                    name: this.app.Name,
	                    environment: this.app.environment,
	                    category: this.app.Category,
	                    protocol: this.app.protocol
	                };
	            }
	        },
	        maasServiceSelect: function maasServiceSelect(val) {
	            var _this2 = this;
	
	            var index = this.platforms.findIndex(function (item) {
	                return item.tag == val.platform;
	            });
	            if (index > -1) {
	                this.newAlgData.platform = val.platform;
	                this.$store.dispatch('getRegionsForPlatform', val.platform);
	                this.$nextTick(function () {
	                    _this2.newAlgData.region = val.region;
	                    _this2.$forceUpdate();
	                });
	            }
	        },
	        algorithmSelected: function algorithmSelected(alg) {
	            this.newAlgData = {
	                name: this.algorithm.name,
	                environment: this.algorithm.environment,
	                protocol: this.algorithm.address ? this.algorithm.address.protocol : null,
	                invocationType: this.algorithm.invocationType,
	                platform: this.algorithm.platform,
	                region: this.algorithm.region,
	                reportInSlack: this.algorithm.reportInSlack,
	                logProblem: this.algorithm.logProblem,
	                logResult: this.algorithm.logResult,
	                logToPythia: this.algorithm.logToPythia,
	                customerTag: this.algorithm.customerTag,
	                algorithmGroupKey: this.algorithm.algorithmGroupKey
	            };
	        },
	        generateAlgorithmKey: function generateAlgorithmKey() {
	            this.newAlgData.algorithmKey = '';
	            if (this.newAlgData.environment && this.newAlgData.category && this.algorithm.algorithmKey) {
	                this.newAlgData.algorithmKey = this.newAlgData.category.identifier + '.';
	                this.newAlgData.algorithmKey += this.newAlgData.environment.identifier + '.';
	                this.newAlgData.algorithmKey += this.algorithm.algorithmKey;
	            }
	        },
	        generateAlgorithmGroupKey: function generateAlgorithmGroupKey() {
	            this.newAlgData.algorithmGroupKey = '';
	            if (this.newAlgData.environment && this.newAlgData.category && this.algorithm.algorithmKey) {
	                this.newAlgData.algorithmKey = this.newAlgData.category.identifier + '.';
	                this.newAlgData.algorithmKey += '*.';
	                this.newAlgData.algorithmKey += this.algorithm.algorithmKey;
	            }
	        },
	        getApps: function getApps() {
	            var _this3 = this;
	
	            this.$store.dispatch('getApps').then(function () {
	                _this3.tableAppProps.dataext = [];
	                _this3.$nextTick(function () {
	                    var tempData = JSON.parse(JSON.stringify(_this3.apps));
	                    tempData = tempData.map(function (row) {
	                        if (!row.algorithmId) {
	                            row.customClassName = 'haveNotAlgorithmId';
	                            if (row.audienceId) {
	                                row.customClassName = 'haveNotAlgorithmId audienceDelete';
	                            } else if (row.url) {
	                                row.customClassName = 'haveNotAlgorithmId audience';
	                            }
	                        }
	                        return row;
	                    });
	                    tempData.forEach(function (e) {
	                        if (e.wbAppGroupId) {
	                            var appGroup = _this3.appGroups.find(function (group) {
	                                return group.id === e.wbAppGroupId;
	                            });
	                            e.wbAppGroup = appGroup ? appGroup.Name : '';
	                        }
	                    });
	                    _this3.tableAppProps.dataext = tempData.filter(function (item) {
	                        return !item.algorithmId;
	                    });
	                });
	            });
	        },
	        addTag: function addTag(newTag) {
	            this.customerTags.push(newTag);
	            if (!this.app.customerTag) {
	                this.app.customerTag = [];
	            }
	            this.app.customerTag.push(newTag);
	        },
	        removeTag: function removeTag(tag) {
	            var positionTag = this.app.customerTag.indexOf(tag);
	            this.app.customerTag.splice(positionTag, 1);
	
	            var positionTags = this.app.customerTag.indexOf(tag);
	            this.customerTags.splice(positionTags, 1);
	        },
	        openDialog: function openDialog(row) {
	            if (row) {
	                this.isNew = false;
	                this.app = Object.assign({ timeToLive: 330 }, row);
	                if (row.wbAppGroupId) {
	                    this.createNewAppGroup = false;
	                    this.selectedAppGroup = this.appGroups.find(function (group) {
	                        return group.id === row.wbAppGroupId;
	                    });
	                } else {
	                    this.createNewAppGroup = true;
	                }
	            } else {
	                this.isNew = true;
	                this.app = {
	                    Name: null,
	                    Category: null,
	                    image: null,
	                    url: null,
	                    algorithmId: null,
	                    configureManually: false,
	                    customerTag: [],
	                    protocol: null,
	                    timeToLive: 330,
	                    registerAudience: false
	                };
	                this.createNewAppGroup = true;
	            }
	            this.$refs.dialog.open();
	        },
	        openAdditionalDialog: function openAdditionalDialog(row, type) {
	            if (row) {
	                this.isNew = false;
	                this.app = Object.assign({ timeToLive: 330 }, row);
	            } else {
	                this.isNew = true;
	                this.app = {
	                    Name: null,
	                    Category: null,
	                    image: null,
	                    url: null,
	                    algorithmId: null,
	                    configureManually: false,
	                    customerTag: [],
	                    protocol: null,
	                    timeToLive: 330,
	                    registerAudience: false
	                };
	            }
	            if (type === 'baas') {
	                if (this.protocols && this.protocols.length === 0 || !this.protocols) this.$store.dispatch('getProtocols');
	                if (this.invocationTypes && this.invocationTypes.length === 0 || !this.invocationTypes) this.$store.dispatch('getInvocationTypes');
	                if (this.platforms && this.platforms.length === 0 || !this.platforms) this.$store.dispatch('getPlatforms');
	                this.$refs.baasDialog.open();
	            } else if (type === 'maas') {
	                if (this.services && this.services.length === 0 || !this.services) this.$store.dispatch('getServices');
	                this.$refs.maasDialog.open();
	            }
	        },
	        closeDialog: function closeDialog(isSaved) {
	            var _this4 = this;
	
	            if (isSaved) {
	                if (this.createNewAppGroup) {
	                    this.createAppGroup().then(function (res) {
	                        _this4.app.wbAppGroupId = res.body.id;
	                        _this4.createApp();
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                } else if (this.selectedAppGroup) {
	                    this.app.wbAppGroupId = this.selectedAppGroup.id;
	                    this.createApp();
	                } else {
	                    this.createApp();
	                }
	            } else {
	                this.$refs.dialog.close();
	                this.app = null;
	            }
	        },
	        createAppGroup: function createAppGroup() {
	            return _managedata2.default.createAppGroup({
	                Name: this.app.Name,
	                Category: this.app.Category,
	                image: this.app.image
	            });
	        },
	        createApp: function createApp() {
	            var _this5 = this;
	
	            var actionName = this.isNew ? 'createApp' : 'updateApp';
	            if (this.app.registerMaas || this.app.registerBaas) {
	                if (this.app.registerMaas) {
	                    this.$store.dispatch('createMaasAlgorithm', this.app);
	                }
	                if (this.app.registerBaas) {
	                    this.$store.dispatch('createBaasAlgorithm', this.newAlgData);
	                }
	                this.$store.dispatch(actionName, this.app).then(function () {
	                    _this5.getApps();
	                    _this5.$refs.dialog.close();
	                    _this5.app = null;
	                });
	            } else if (this.app.registerAudience) {
	                this.registerAudience(this.app.Name, this.app.environment, this.app.url).then(function (resp) {
	                    console.log(resp);
	                    _this5.app.audienceId = resp.body.id;
	                    _this5.app.audienceParameter = resp.body.parameter;
	                    _this5.$store.dispatch(actionName, _this5.app).then(function () {
	                        _this5.getApps();
	                        _this5.$refs.dialog.close();
	                        _this5.app = null;
	                    });
	                });
	            } else {
	                this.$store.dispatch(actionName, this.app).then(function () {
	                    _this5.getApps();
	                    _this5.$refs.dialog.close();
	                    _this5.app = null;
	                });
	            }
	        },
	        closeAdditionalDialog: function closeAdditionalDialog(isSaved, type) {
	            this.app = null;
	            this.$refs.maasDialog.close();
	            this.$refs.baasDialog.close();
	        },
	        openConfirmDialog: function openConfirmDialog(row) {
	            this.app = row;
	            this.$refs.confirmDialog.open();
	        },
	        closeConfirmDialog: function closeConfirmDialog(isConfirmed) {
	            var _this6 = this;
	
	            if (isConfirmed) {
	                if (this.deleteAnAudience) {
	                    this.deleteAudience(this.app.audienceId, this.app.audienceParameter).then(function () {
	                        _this6.$store.dispatch('deleteApp', _this6.app).then(function () {
	                            return _this6.getApps();
	                        });
	                    });
	                } else {
	                    this.$store.dispatch('deleteApp', this.app).then(function () {
	                        return _this6.getApps();
	                    });
	                }
	                this.deleteAnAudience = false;
	            }
	            this.$refs.confirmDialog.close();
	        },
	        registerAudienceVert: function registerAudienceVert(row) {
	            var _this7 = this;
	
	            this.registerAudience(row.Name, row.environment, row.url).then(function (resp) {
	                row.audienceId = resp.body.id;
	                row.audienceParameter = resp.body.parameter;
	                _this7.$store.dispatch('updateApp', row).then(function () {
	                    _this7.getApps();
	                });
	            }).catch(function (err) {
	                return console.log(err);
	            });
	        },
	        registerAudience: function registerAudience(name, environment, audience) {
	            return new Promise(function (resolve, reject) {
	                _managedata2.default.createAuth0Audience({ name: name, environment: environment, audience: audience }).then(function (resp) {
	                    return resolve(resp);
	                }).catch(function (err) {
	                    return reject(err);
	                });
	            });
	        },
	        deleteAudienceVert: function deleteAudienceVert(row) {
	            var _this8 = this;
	
	            this.deleteAudience(row.audienceId, row.audienceParameter).then(function () {
	                row.audienceId = '';
	                row.audienceParameter = '';
	                _this8.$store.dispatch('updateApp', row).then(function () {
	                    _this8.getApps();
	                });
	            }).catch(function (err) {
	                return console.log(err);
	            });
	        },
	        deleteAudience: function deleteAudience(id, parameter) {
	            return new Promise(function (resolve, reject) {
	                _managedata2.default.deleteAuth0Audience([{ key: 'id', value: id }, { key: 'parameter', value: parameter }]).then(function (resp) {
	                    return resolve(resp);
	                }).catch(function (err) {
	                    return reject(err);
	                });
	            });
	        },
	        getAppGroups: function getAppGroups() {
	            var _this9 = this;
	
	            _managedata2.default.getAppGroups().then(function (res) {
	                _this9.appGroups = res.body;
	                _this9.getApps();
	            });
	        }
	    },
	    mounted: function mounted() {
	        this.tableAppProps.columns = this.tableAppColumns;
	        this.getAppGroups();
	        this.$store.dispatch('getServices');
	    }
	};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _WBDataTable = __webpack_require__(5);
	
	var _WBDataTable2 = _interopRequireDefault(_WBDataTable);
	
	var _vuex = __webpack_require__(3);
	
	var _vueMultiselect = __webpack_require__(6);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	var _underscore = __webpack_require__(8);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'AdminDocumentation',
	    components: {
	        'wb-datatable': _WBDataTable2.default,
	        Multiselect: _vueMultiselect2.default
	    },
	    data: function data() {
	        return {
	            documentation: null,
	            selectedKey: null,
	            keys: [],
	            isNew: false,
	            tableProps: {
	                dataext: [],
	                columns: [{ name: 'id', displayName: 'ID', visible: false, type: 'number', isEditable: false }, { name: 'name', displayName: 'Name', visible: true, type: 'string', isEditable: false }, { name: 'collection', displayName: 'Collection', visible: true, type: 'string', isEditable: false }, { name: 'key', displayName: 'Key', visible: true, type: 'number', isEditable: false }, { name: 'position', displayName: 'Position', visible: true, type: 'number', isEditable: false }, { name: 'secured', displayName: 'Secured', visible: true, type: 'boolean', isEditable: false }],
	                hasControls: true,
	                allowCreation: true,
	                disableSearch: false,
	                pagination: {
	                    size: 50
	                }
	            }
	        };
	    },
	
	    methods: {
	        getDocs: function getDocs() {
	            var _this = this;
	
	            _managedata2.default.getDocs().then(function (resp) {
	                _this.tableProps.dataext = resp.body;
	            });
	        },
	        getDocsKeys: function getDocsKeys() {
	            var _this2 = this;
	
	            _managedata2.default.getDocsKeys().then(function (resp) {
	                _this2.keys = resp.body;
	            });
	        },
	        openDialog: function openDialog(row) {
	            if (row) {
	                this.isNew = false;
	                this.documentation = row;
	                var key = row.key;
	                this.selectedKey = this.keys.find(function (keyItem) {
	                    return keyItem.Key === key;
	                });
	            } else {
	                this.isNew = true;
	                this.documentation = {
	                    name: null,
	                    collection: null,
	                    position: null,
	                    secured: true
	                };
	                this.selectedKey = null;
	            }
	            this.$refs.dialog.open();
	        },
	        closeDialog: function closeDialog(isSaved) {
	            var _this3 = this;
	
	            if (isSaved) {
	                var actionName = this.isNew ? 'createDoc' : 'updateDoc';
	                var docForRequest = {
	                    id: this.documentation.id,
	                    name: this.documentation.name,
	                    key: this.selectedKey.Key,
	                    collection: this.documentation.collection,
	                    position: this.documentation.position,
	                    secured: this.documentation.secured
	                };
	
	                _managedata2.default[actionName](this.isNew ? docForRequest : { doc: docForRequest }).then(function () {
	                    _this3.getDocs();
	                });
	            }
	            this.$refs.dialog.close();
	            this.documentation = null;
	            this.selectedKey = null;
	        },
	        openConfirmDialog: function openConfirmDialog(row) {
	            this.documentation = row;
	            this.$refs.confirmDialog.open();
	        },
	        closeConfirmDialog: function closeConfirmDialog(isConfirmed) {
	            var _this4 = this;
	
	            if (isConfirmed) {
	                _managedata2.default.deleteDoc(this.documentation.id).then(function () {
	                    _this4.getDocs();
	                });
	            }
	            this.$refs.confirmDialog.close();
	        }
	    },
	    mounted: function mounted() {
	        this.getDocs();
	        this.getDocsKeys();
	    }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _WBDataTable = __webpack_require__(5);
	
	var _WBDataTable2 = _interopRequireDefault(_WBDataTable);
	
	var _vuex = __webpack_require__(3);
	
	var _vueMultiselect = __webpack_require__(6);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	var _underscore = __webpack_require__(8);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AdminOrganizationAssignments',
	  components: {
	    'wb-datatable': _WBDataTable2.default,
	    'multiselect': _vueMultiselect2.default
	  },
	  data: function data() {
	    return {
	      selectedUser: null,
	      selectedOrganization: null,
	      organizationAssignment: null,
	      isNew: false,
	      organizationsCopy: null,
	      usersCopy: null,
	      tableProps: {
	        dataext: [],
	        columns: null,
	        hasControls: true,
	        allowCreation: true,
	        disableSearch: false,
	        pagination: {
	          size: 50
	        }
	      },
	      tableColumns: [{ name: 'id', displayName: 'ID', visible: true, type: 'number', isEditable: false }, { name: 'organizationName', displayName: 'Organization', visible: true, type: 'string', isEditable: false }, { name: 'userEmail', displayName: 'User email', visible: true, type: 'string', isEditable: false }]
	    };
	  },
	
	  validations: {},
	  computed: _extends({}, (0, _vuex.mapGetters)(['organizationAssignments', 'organizations', 'users'])),
	  methods: {
	    changeUser: function changeUser(organizationAssignment, user) {
	      organizationAssignment.user = Object.assign({}, user);
	      organizationAssignment.userId = user.id;
	    },
	    changeOrganization: function changeOrganization(organizationAssignment, organization) {
	      organizationAssignment.organization = Object.assign({}, organization);
	      organizationAssignment.organizationId = organization.id;
	    },
	    getOrganizationAssignments: function getOrganizationAssignments() {
	      var _this = this;
	
	      this.$store.dispatch('getOrganizationAssignments').then(function () {
	        var customOrganizationAssignments = _this.organizationAssignments.map(function (organizationAssignment) {
	          var organizationName = organizationAssignment.organization ? organizationAssignment.organization.name : null;
	          var userEmail = organizationAssignment.user ? organizationAssignment.user.email : null;
	          var organizationAssignmentCopy = {
	            id: organizationAssignment.id,
	            organization: organizationAssignment.organization,
	            organizationName: organizationName,
	            user: organizationAssignment.user,
	            userId: organizationAssignment.userId,
	            userEmail: userEmail,
	            organizationId: organizationAssignment.organizationId
	          };
	          return organizationAssignmentCopy;
	        });
	        _this.tableProps.dataext = [];
	        _this.$nextTick(function () {
	          _this.tableProps.dataext = customOrganizationAssignments;
	        });
	        _this.$store.dispatch('getOrganizations').then(function () {
	          _this.organizationsCopy = JSON.parse(JSON.stringify(_this.organizations));
	          _this.organizationsCopy = _underscore2.default.sortBy(_this.organizationsCopy, function (o) {
	            return o.name.toLowerCase();
	          });
	        });
	
	        _this.$store.dispatch('getUsers').then(function () {
	          _this.usersCopy = JSON.parse(JSON.stringify(_this.users));
	          _this.usersCopy = _underscore2.default.sortBy(_this.usersCopy, function (o) {
	            return o.email.toLowerCase();
	          });
	        });
	      });
	    },
	    openDialog: function openDialog(row) {
	      if (row) {
	        this.isNew = false;
	        this.selectedUser = this.usersCopy.find(function (user) {
	          return user.email === row.userEmail;
	        });
	        this.selectedOrganization = this.organizationsCopy.find(function (org) {
	          return org.name == row.organizationName;
	        });
	        this.organizationAssignment = row;
	      } else {
	        this.isNew = true;
	        this.organizationAssignment = {
	          organization: null,
	          organizationName: null,
	          user: null,
	          userId: null,
	          userEmail: null,
	          organizationId: null
	        };
	      }
	      this.$refs.dialog.open();
	    },
	    closeDialog: function closeDialog(isSaved) {
	      var _this2 = this;
	
	      if (isSaved) {
	        var actionName = this.isNew ? 'createOrganizationAssignment' : 'updateOrganizationAssignment';
	        var organizationAssignmentForRequest = {
	          organization: this.organizationAssignment.organization ? Object.assign({}, this.organizationAssignment.organization) : null,
	          user: this.organizationAssignment.user ? Object.assign({}, this.organizationAssignment.user) : null,
	          userId: this.organizationAssignment.user ? this.organizationAssignment.user.id : null,
	          organizationId: this.organizationAssignment.organization ? this.organizationAssignment.organization.id : null
	        };
	        if (this.organizationAssignment.id) {
	          organizationAssignmentForRequest.id = this.organizationAssignment.id;
	        }
	
	        this.$store.dispatch(actionName, organizationAssignmentForRequest).then(function () {
	          _this2.getOrganizationAssignments();
	        });
	      }
	      this.$refs.dialog.close();
	      this.organizationAssignment = null;
	    },
	    openConfirmDialog: function openConfirmDialog(row) {
	      this.organizationAssignment = row;
	      this.$refs.confirmDialog.open();
	    },
	    closeConfirmDialog: function closeConfirmDialog(isConfirmed) {
	      var _this3 = this;
	
	      if (isConfirmed) {
	        this.$store.dispatch('deleteOrganizationAssignment', this.organizationAssignment).then(function () {
	          _this3.getOrganizationAssignments();
	        });
	      }
	      this.$refs.confirmDialog.close();
	    }
	  },
	  mounted: function mounted() {
	    this.tableProps.columns = this.tableColumns;
	    this.getOrganizationAssignments();
	  }
	};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _WBDataTable = __webpack_require__(5);
	
	var _WBDataTable2 = _interopRequireDefault(_WBDataTable);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AdminOrganizations',
	  components: {
	    'wb-datatable': _WBDataTable2.default
	  },
	  data: function data() {
	    return {
	      organization: null,
	      isNew: false,
	      tableProps: {
	        dataext: [],
	        columns: null,
	        hasControls: true,
	        allowCreation: true,
	        disableSearch: false,
	        pagination: {
	          size: 50
	        }
	      },
	      tableColumns: [{ name: 'id', displayName: 'ID', visible: true, type: 'number', isEditable: false }, { name: 'name', displayName: 'Organization', visible: true, type: 'string', isEditable: false }]
	    };
	  },
	
	  validations: {},
	  computed: _extends({}, (0, _vuex.mapGetters)(['organizations'])),
	  methods: {
	    getOrganizations: function getOrganizations() {
	      var _this = this;
	
	      this.$store.dispatch('getOrganizations').then(function () {
	        _this.tableProps.dataext = [];
	        _this.$nextTick(function () {
	          _this.tableProps.dataext = JSON.parse(JSON.stringify(_this.organizations));
	        });
	      });
	    },
	    openDialog: function openDialog(row) {
	      if (row) {
	        this.isNew = false;
	
	        this.organization = row;
	      } else {
	        this.isNew = true;
	        this.organization = {
	          name: null,
	          category: null
	        };
	      }
	      this.$refs.dialog.open();
	    },
	    closeDialog: function closeDialog(isSaved) {
	      var _this2 = this;
	
	      if (isSaved) {
	        var actionName = this.isNew ? 'createOrganization' : 'updateOrganization';
	        this.$store.dispatch(actionName, this.organization).then(function () {
	          _this2.getOrganizations();
	        });
	      }
	      this.$refs.dialog.close();
	      this.organization = null;
	    },
	    openConfirmDialog: function openConfirmDialog(row) {
	      this.organization = row;
	      this.$refs.confirmDialog.open();
	    },
	    closeConfirmDialog: function closeConfirmDialog(isConfirmed) {
	      var _this3 = this;
	
	      if (isConfirmed) {
	        this.$store.dispatch('deleteOrganization', this.organization).then(function () {
	          _this3.getOrganizations();
	        });
	      }
	      this.$refs.confirmDialog.close();
	    }
	  },
	  mounted: function mounted() {
	    this.tableProps.columns = this.tableColumns;
	    this.getOrganizations();
	  }
	};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _WBDataTable = __webpack_require__(5);
	
	var _WBDataTable2 = _interopRequireDefault(_WBDataTable);
	
	var _vuex = __webpack_require__(3);
	
	var _vueMultiselect = __webpack_require__(6);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	var _underscore = __webpack_require__(8);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AdminRoles',
	  components: {
	    'wb-datatable': _WBDataTable2.default,
	    Multiselect: _vueMultiselect2.default
	  },
	  data: function data() {
	    return {
	      role: null,
	      selectedUser: null,
	      selectedApp: null,
	      isNew: false,
	      appsCopy: null,
	      usersCopy: null,
	      tableProps: {
	        dataext: [],
	        columns: [{ name: 'id', displayName: 'ID', visible: false, type: 'number', isEditable: false }, { name: 'appId', displayName: 'App ID', visible: true, type: 'string', isEditable: false }, { name: 'displayName', displayName: 'App Name', visible: true, type: 'string', isEditable: false }, { name: 'userEmail', displayName: 'User email', visible: true, type: 'string', isEditable: false }, { name: 'role', displayName: 'Role', visible: true, type: 'string', isEditable: false }],
	        hasControls: true,
	        allowCreation: true,
	        disableSearch: false,
	        pagination: {
	          size: 50
	        }
	      },
	      roles: null
	    };
	  },
	
	  watch: {},
	  validations: {},
	  computed: _extends({}, (0, _vuex.mapGetters)(['apps', 'users'])),
	  methods: {
	    changeUser: function changeUser(role, user) {
	      role.user = Object.assign({}, user);
	      role.userId = user.id;
	    },
	    changeApp: function changeApp(role, app) {
	      role.app = Object.assign({}, app);
	      role.appId = app.id;
	    },
	    parseRoles: function parseRoles(roles) {
	      this.tableProps.dataext = roles.map(function (role) {
	        var appName = role.app ? role.app.Name : null;
	        var displayName = role.app ? role.app.Name : null;
	        if (role.app && role.app.environment) {
	          displayName += ' (' + role.app.environment + ')';
	        }
	        var userEmail = role.user ? role.user.email : null;
	        return {
	          id: role.id,
	          app: role.app,
	          appId: role.appId,
	          appName: appName,
	          displayName: displayName,
	          user: role.user,
	          userId: role.userId,
	          userEmail: userEmail,
	          role: role.role
	        };
	      });
	    },
	    getRoles: function getRoles() {
	      var _this = this;
	
	      this.$store.dispatch('getRoles').then(function () {
	        _this.parseRoles(_this.$store.state.roles);
	      }).catch(function (err) {});
	    },
	    openDialog: function openDialog(row) {
	      if (row) {
	        var userEmail = row.userEmail;
	        this.isNew = false;
	        this.selectedUser = this.usersCopy.find(function (user) {
	          return user.email === userEmail;
	        });
	        this.selectedApp = this.appsCopy.find(function (app) {
	          return app.Name === row.appName;
	        });
	        this.role = row;
	      } else {
	        this.isNew = true;
	        this.role = {
	          userId: null,
	          appId: null,
	          role: null
	        };
	      }
	      this.$refs.dialog.open();
	    },
	    closeDialog: function closeDialog(isSaved) {
	      var _this2 = this;
	
	      if (isSaved) {
	        var actionName = this.isNew ? 'createRole' : 'updateRole';
	        var roleForRequest = {
	          appId: this.role.appId,
	          userId: this.role.userId,
	          role: this.role.role
	        };
	        if (this.role.id) {
	          roleForRequest.id = this.role.id;
	        }
	        this.$store.dispatch(actionName, roleForRequest).then(function () {
	          _this2.getRoles();
	        }).catch(function (err) {});
	      }
	      this.$refs.dialog.close();
	      this.role = null;
	      this.selectedUser = null;
	      this.selectedApp = null;
	    },
	    openConfirmDialog: function openConfirmDialog(row) {
	      this.role = row;
	      this.$refs.confirmDialog.open();
	    },
	    closeConfirmDialog: function closeConfirmDialog(isConfirmed) {
	      var _this3 = this;
	
	      if (isConfirmed) {
	        this.$store.dispatch('deleteRole', this.role).then(function () {
	          _this3.getRoles();
	        }).catch(function (err) {});
	      }
	      this.$refs.confirmDialog.close();
	    }
	  },
	  mounted: function mounted() {
	    this.getRoles();
	    this.usersCopy = _underscore2.default.sortBy(this.users, function (user) {
	      return user.email.toLowerCase();
	    });
	    this.appsCopy = _underscore2.default.sortBy(this.apps, function (app) {
	      return app.Name.toLowerCase();
	    }).filter(function (a) {
	      return !a.algorithmId;
	    }).map(function (item) {
	      if (item.environment) {
	        item.displayName = item.Name + ' (' + item.environment + ')';
	      } else {
	        item.displayName = '' + item.Name;
	      }
	      return item;
	    });
	  }
	};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _WBDataTable = __webpack_require__(5);
	
	var _WBDataTable2 = _interopRequireDefault(_WBDataTable);
	
	var _vuex = __webpack_require__(3);
	
	var _vueMultiselect = __webpack_require__(6);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AdminOrganizations',
	  components: {
	    'wb-datatable': _WBDataTable2.default,
	    Multiselect: _vueMultiselect2.default
	  },
	  data: function data() {
	    return {
	      organization: null,
	      newTeam: null,
	      oldParentTeam: null,
	      newParentTeam: [],
	      parentTeamsList: [],
	      isNew: false,
	      tableProps: {
	        dataext: [],
	        columns: null,
	        hasControls: true,
	        allowCreation: true,
	        disableSearch: false,
	        pagination: {
	          size: 50
	        }
	      },
	      tableColumns: [{ name: 'id', displayName: 'ID', visible: true, type: 'number', isEditable: false }, { name: 'name', displayName: 'Team', visible: true, type: 'string', isEditable: false }, { name: 'childTeamsNames', displayName: 'Child Teams', visible: true, type: 'string', isEditable: false }, { name: 'parentTeamsNames', displayName: 'Parent Teams', visible: true, type: 'string', isEditable: false }]
	    };
	  },
	
	  validations: {},
	  computed: _extends({}, (0, _vuex.mapGetters)(['teams', 'teamsAssigned'])),
	  methods: {
	    getTeams: function getTeams() {
	      var _this = this;
	
	      this.$store.dispatch('getTeams').then(function () {
	        _this.tableProps.dataext = [];
	        _this.$nextTick(function () {
	          _this.getAssignedTeams();
	        });
	      });
	    },
	    getAssignedTeams: function getAssignedTeams() {
	      var _this2 = this;
	
	      this.$store.dispatch('getAssignedTeams').then(function () {
	        _this2.setAssignedTeams();
	      });
	    },
	    setAssignedTeams: function setAssignedTeams() {
	      var _this3 = this;
	
	      this.teams.forEach(function (team) {
	
	        team.parentTeams = [];
	        team.childTeams = [];
	        team.parentTeamsNames = [];
	        team.childTeamsNames = [];
	
	        team.childTeams = _this3.teamsAssigned.filter(function (teamAssigned) {
	          return teamAssigned.parentId === team.id;
	        });
	
	        team.childTeams.forEach(function (childTeam) {
	          _this3.teams.forEach(function (team) {
	            if (team.id === childTeam.childId) {
	              childTeam.name = team.name;
	            }
	          });
	          team.childTeamsNames.push(childTeam.name);
	        });
	
	        team.parentTeams = _this3.teamsAssigned.filter(function (teamAssigned) {
	          return teamAssigned.childId === team.id;
	        });
	
	        team.parentTeams.forEach(function (parentTeams) {
	          _this3.teams.forEach(function (team) {
	            if (team.id === parentTeams.parentId) {
	              parentTeams.name = team.name;
	            }
	          });
	          team.parentTeamsNames.push(parentTeams.name);
	        });
	
	        team.parentTeamsNames = team.parentTeamsNames.join(', ');
	        team.childTeamsNames = team.childTeamsNames.join(', ');
	      });
	      this.tableProps.dataext = JSON.parse(JSON.stringify(this.teams));
	    },
	    openDialog: function openDialog(row) {
	      var _this4 = this;
	
	      if (row) {
	        this.organization = row;
	        this.newTeam = null;
	        this.newParentTeam = [];
	        this.teams.forEach(function (adminTeam) {
	          var isTeam = _this4.organization.parentTeams.find(function (parentTeam) {
	            return adminTeam.id === parentTeam.parentId;
	          });
	          if (!isTeam) {
	            _this4.newParentTeam.push(adminTeam);
	          }
	        });
	        this.newParentTeam = this.newParentTeam.filter(function (team) {
	          if (!(team.id === _this4.organization.id)) {
	            return team;
	          }
	        });
	      }
	      this.$refs.dialog.open();
	    },
	    closeDialog: function closeDialog(isSaved) {
	      if (isSaved) {
	        var data = {
	          parentId: this.newTeam.id,
	          childId: this.organization.id
	        };
	        this.$store.dispatch('updateTeamsAssignment', data);
	        this.getTeams();
	      }
	      this.$refs.dialog.close();
	      this.organization = null;
	    },
	    openConfirmDialog: function openConfirmDialog(row) {
	      var _this5 = this;
	
	      this.organization = row;
	      this.oldParentTeam = null;
	      this.parentTeamsList = [];
	      var parentTeams = this.teamsAssigned.filter(function (team) {
	        return team.childId === _this5.organization.id;
	      });
	      parentTeams.forEach(function (parentTeam) {
	        _this5.teams.forEach(function (team) {
	          if (team.id === parentTeam.parentId) {
	            parentTeam.name = team.name;
	          }
	        });
	        _this5.parentTeamsList.push(parentTeam);
	      });
	
	      this.$refs.confirmDialog.open();
	    },
	    closeConfirmDialog: function closeConfirmDialog(isConfirmed) {
	      var _this6 = this;
	
	      console.log('this.oldParentTeam', this.oldParentTeam);
	      if (isConfirmed) {
	        var data = {
	          parentId: this.oldParentTeam.parentId,
	          childId: this.organization.id
	        };
	        this.$store.dispatch('deleteFromParentTeam', data).then(function () {
	          _this6.$store.dispatch('getAssignedTeams');
	        });
	        this.getTeams();
	      }
	      this.$refs.confirmDialog.close();
	    }
	  },
	  mounted: function mounted() {
	    this.tableProps.columns = this.tableColumns;
	    this.getTeams();
	  }
	};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _WBDataTable = __webpack_require__(5);
	
	var _WBDataTable2 = _interopRequireDefault(_WBDataTable);
	
	var _vuex = __webpack_require__(3);
	
	var _validators = __webpack_require__(19);
	
	var _underscore = __webpack_require__(8);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vueMultiselect = __webpack_require__(6);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AdminUsers',
	  components: {
	    'wb-datatable': _WBDataTable2.default,
	    Multiselect: _vueMultiselect2.default
	  },
	  data: function data() {
	    return {
	      user: null,
	      newUser: {
	        user: {
	          name: null,
	          email: null
	        },
	        appId: null,
	        role: null
	      },
	      tableProps: {
	        dataext: [],
	        columns: null,
	        hasControls: true,
	        allowCreation: true,
	        disableSearch: false,
	        pagination: {
	          size: 50
	        }
	      },
	      appsCopy: [],
	      selectedApp: null,
	      tableColumns: [{ name: 'id', displayName: 'ID', visible: true, type: 'number', isEditable: false }, { name: 'name', displayName: 'Name', visible: true, type: 'string', isEditable: false }, { name: 'username', displayName: 'Username', visible: true, type: 'string', isEditable: false }, { name: 'email', displayName: 'Email', visible: true, type: 'string', isEditable: false }, { name: 'status', displayName: 'Status', visible: true, type: 'string', isEditable: false }],
	      errorMessage: ''
	    };
	  },
	
	  validations: {
	    newUser: {
	      user: {
	        name: { required: _validators.required },
	        email: { required: _validators.required }
	      },
	      appId: { required: _validators.required },
	      role: { required: _validators.required }
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)(['userStatuses', 'users', 'apps', 'roles']), {
	    isQuinyx: function isQuinyx() {
	      return _utils2.default.isQuinyx();
	    }
	  }),
	  methods: {
	    selectRoleByAppId: function selectRoleByAppId(app) {
	      var id = app.id;
	      this.$store.dispatch('getRolesById', { id: id });
	      this.newUser.role = null;
	      this.newUser.appId = id;
	    },
	    getUsers: function getUsers() {
	      var _this = this;
	
	      this.$store.dispatch('getUserStatuses').then(function () {
	        return _this.$store.dispatch('getUsers');
	      }).then(function () {
	        _this.$store.commit('START_REQUEST');
	        var clonedUsers = JSON.parse(JSON.stringify(_this.users));
	        _this.tableProps.dataext = [];
	        _this.$nextTick(function () {
	          _this.tableProps.dataext = clonedUsers;
	        });
	        _this.$store.commit('FINISH_REQUEST');
	
	        _this.$store.dispatch('getApps').then(function () {
	          _this.appsCopy = JSON.parse(JSON.stringify(_this.apps)).map(function (e) {
	            if (e.environment) {
	              e.Name = e.Name + ' (' + e.environment + ')';
	            }
	            return e;
	          });
	          _this.appsCopy.sort(function (a, b) {
	            if (a.Name > b.Name) return 1;
	            if (a.Name < b.Name) return -1;
	            return 0;
	          });
	        });
	      });
	    },
	    openCreateDialog: function openCreateDialog() {
	      this.$refs.createDialog.open();
	    },
	    closeCreateDialog: function closeCreateDialog(isSaved) {
	      var _this2 = this;
	
	      var u = this.newUser;
	      if (isSaved) {
	        if (u.user.name !== null && u.user.name.length > 0 && u.user.email !== null && u.user.email.length > 0 && u.appId !== null && u.role !== null) {
	          if (_utils2.default.isQuinyx()) {
	            u.id = u.user.id;
	          }
	          this.$store.dispatch('createUserFromApp', {
	            user: u
	          }).then(function (resp) {
	            if (resp.body.message) {
	              _this2.errorMessage = resp.body.message;
	            } else {
	              _this2.errorMessage = '';
	              _this2.getUsers();
	              _this2.$refs.createDialog.close();
	            }
	          });
	        }
	      } else {
	        this.$refs.createDialog.close();
	      }
	    },
	    openUpdateDialog: function openUpdateDialog(row, columns) {
	      if (row) {
	        this.user = Object.assign({}, row);
	      } else {
	        this.user = null;
	      }
	      this.$refs.updateDialog.open();
	    },
	    closeUpdateDialog: function closeUpdateDialog(isSaved) {
	      var _this3 = this;
	
	      if (isSaved) {
	        this.$store.dispatch('updateUser', this.user).then(function () {
	          _this3.getUsers();
	        });
	      }
	      this.$refs.updateDialog.close();
	      this.user = null;
	    },
	    openConfirmDialog: function openConfirmDialog(row) {
	      this.user = row;
	      this.$refs.confirmDialog.open();
	    },
	    closeConfirmDialog: function closeConfirmDialog(isConfirmed) {
	      var _this4 = this;
	
	      if (isConfirmed) {
	        this.$store.dispatch('deleteUser', this.user).then(function () {
	          _this4.getUsers();
	        });
	      }
	      this.$refs.confirmDialog.close();
	    },
	    resendActivationEmail: function resendActivationEmail(email) {
	      var _this5 = this;
	
	      _managedata2.default.resendKey(email).then(function (res) {
	        _this5.$store.commit('CLEAR_MESSAGE');
	        _this5.$store.commit({
	          type: 'SET_MESSAGE',
	          message: 'Email was successfully sent'
	        });
	      }).catch(function (err) {
	        console.log(err);
	        _this5.$store.commit('CLEAR_MESSAGE');
	        _this5.$store.commit({
	          type: 'SET_MESSAGE',
	          message: 'Something went wrong. Please try again later.'
	        });
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.tableProps.columns = this.tableColumns;
	    this.getUsers();
	  }
	};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _WBDataTable = __webpack_require__(5);
	
	var _WBDataTable2 = _interopRequireDefault(_WBDataTable);
	
	var _vuex = __webpack_require__(3);
	
	var _validators = __webpack_require__(19);
	
	var _underscore = __webpack_require__(8);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vueMultiselect = __webpack_require__(6);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _vuejsDatepicker = __webpack_require__(327);
	
	var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  name: "AdminUsers",
	  components: {
	    "wb-datatable": _WBDataTable2.default,
	    Multiselect: _vueMultiselect2.default,
	    DatePicker: _vuejsDatepicker2.default
	  },
	  data: function data() {
	    return _defineProperty({
	      selectedDate: undefined,
	      selectedTeam: undefined,
	      selectedUser: null,
	      isNew: false,
	      usersCopy: [],
	      oldTeam: null,
	      adminTeams: null,
	      userTeams: [],
	      teamsForAssignments: null,
	      newTeam: null,
	      user: null,
	      userOptions: [],
	      tableProps: {
	        dataext: [],
	        columns: null,
	        hasControls: true,
	        allowCreation: true,
	        disableSearch: false,
	        pagination: {
	          size: 50
	        }
	      },
	      allTeams: false,
	      appsCopy: [],
	      selectedApp: null,
	      errorMessage: ""
	    }, "isNew", false);
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)(["userTeamAssignments", "teams", "users"])),
	  methods: {
	    getTeams: function getTeams() {
	      this.$store.dispatch("getTeams");
	    },
	    getUsers: function getUsers() {
	      var _this = this;
	
	      this.$store.dispatch("getUsers").then(function () {
	        return _this.$store.dispatch("getUserTeamAssignments");
	      }).then(function () {
	        _this.$store.commit("START_REQUEST");
	        var clonedUsers = JSON.parse(JSON.stringify(_this.users));
	        var bucket = [];
	        _this.userTeamAssignments.forEach(function (element) {
	          clonedUsers.forEach(function (userElement) {
	            if (element.userId === userElement.id) {
	              element.userId = userElement.id;
	              element.name = userElement.name;
	              element.username = userElement.username;
	              element.email = userElement.email;
	
	              var teamObj = _this.teams.find(function (value) {
	                return value.id === element.teamId;
	              });
	
	              if (teamObj) {
	                element.team = teamObj.name;
	              }
	
	              if (element.teamId === "*") {
	                element.team = "All Teams";
	              }
	
	              element.expiredDate = _utils2.default.formatDate(element.expiresAt);
	              bucket.push(element);
	            }
	          });
	        });
	        _this.tableProps.dataext = [];
	        _this.$nextTick(function () {
	          _this.tableProps.dataext = bucket;
	          _this.fillColumns();
	        });
	        _this.$store.commit("FINISH_REQUEST");
	
	        _this.$store.dispatch("getUsers").then(function () {
	          _this.usersCopy = JSON.parse(JSON.stringify(_this.users));
	          _this.usersCopy = _underscore2.default.sortBy(_this.usersCopy, function (o) {
	            return o.email.toLowerCase();
	          });
	        });
	
	        _this.$store.dispatch("getTeams").then(function () {
	          _this.userTeams = JSON.parse(JSON.stringify(_this.teams));
	          _this.userTeams = _underscore2.default.sortBy(_this.userTeams, function (o) {
	            return o;
	          });
	        });
	      });
	    },
	    fillColumns: function fillColumns() {
	      var columns = [{
	        name: "id",
	        displayName: "ID",
	        visible: true,
	        type: "number",
	        isEditable: false
	      }, {
	        name: "name",
	        displayName: "Name",
	        visible: true,
	        type: "string",
	        isEditable: false
	      }, {
	        name: "username",
	        displayName: "Username",
	        visible: true,
	        type: "string",
	        isEditable: false
	      }, {
	        name: "email",
	        displayName: "Email",
	        visible: true,
	        type: "string",
	        isEditable: false
	      }, {
	        name: "team",
	        displayName: "Team",
	        visible: true,
	        type: "cellTemplate",
	        isEditable: false,
	        filterByValue: function filterByValue(a) {
	          return a.teamId == "*" ? "All Teams" : a.team;
	        },
	        onClickRow: function onClickRow() {},
	        columnClass: function columnClass(a) {
	          return a.teamId == "*" ? "table-cell-highlighted" : "";
	        },
	        cellTemplate: function cellTemplate(a) {
	          return a.teamId == "*" ? "All Teams" : a.team;
	        }
	      }, {
	        name: "expiredDate",
	        displayName: "Expired Date",
	        visible: true,
	        type: "string",
	        isEditable: false
	      }];
	      this.tableProps.columns = columns;
	    },
	    closeDialog: function closeDialog(isSaved) {
	      if (isSaved) {
	        var data = {
	          expiresAt: this.selectedDate ? new Date(this.selectedDate) : null,
	          userId: this.selectedUser.id
	        };
	        if (this.allTeams) {
	          data["teamId"] = "*";
	        } else {
	          data["teamId"] = this.selectedTeam.id;
	        }
	        this.$store.dispatch("createUserTeamAssignments", data);
	        this.getUsers();
	        this.$forceUpdate();
	      }
	      this.$refs.createDialog.close();
	    },
	    openCreateDialog: function openCreateDialog() {
	      this.isNew = true;
	      this.team = {
	        organization: null,
	        organizationName: null,
	        user: null,
	        userId: null,
	        userEmail: null,
	        organizationId: null
	      };
	      this.$refs.createDialog.open();
	    },
	    openUpdateDialog: function openUpdateDialog(row, columns) {
	      if (row) {
	        this.selectedDate = row.expiresAt;
	        this.user = Object.assign({}, row);
	      } else {
	        this.user = null;
	      }
	      this.$refs.updateDialog.open();
	    },
	    closeUpdateDialog: function closeUpdateDialog(isSaved) {
	      if (isSaved) {
	        var data = {
	          expiresAt: new Date(this.selectedDate),
	          id: this.user.id,
	          userId: this.user.userId,
	          teamId: this.user.teamId
	        };
	
	        if (!this.selectedDate) {
	          data.expiresAt = null;
	        }
	        this.$store.dispatch("updateUserTeamAssignments", data);
	        this.getUsers();
	        this.$forceUpdate();
	      }
	      this.$refs.updateDialog.close();
	      this.user = null;
	    },
	    openConfirmDialog: function openConfirmDialog(row) {
	      this.user = row;
	      if (this.user && this.user.team) {
	        this.$refs.confirmDialog.open();
	      } else {
	        this.$refs.confirmEmptyDialog.open();
	      }
	    },
	    closeConfirmDialog: function closeConfirmDialog(isConfirmed) {
	      var _this2 = this;
	
	      if (isConfirmed) {
	        this.$store.dispatch("deleteUserTeamAssignments", this.user.id).then(function () {
	          _this2.getUsers();
	        });
	      }
	      this.$refs.confirmDialog.close();
	    },
	    closeConfirmEmptyDialog: function closeConfirmEmptyDialog(val) {
	      if (val) {
	        this.openUpdateDialog(this.user);
	      }
	      this.$refs.confirmEmptyDialog.close();
	    }
	  },
	  mounted: function mounted() {
	    this.$store.dispatch("getTeams");
	    this.getUsers();
	  }
	};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WBDataTable = __webpack_require__(5);
	
	var _WBDataTable2 = _interopRequireDefault(_WBDataTable);
	
	var _vuex = __webpack_require__(3);
	
	var _vueMultiselect = __webpack_require__(6);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	var _underscore = __webpack_require__(8);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AdminRoles',
	  components: {
	    'wb-datatable': _WBDataTable2.default,
	    Multiselect: _vueMultiselect2.default
	  },
	  data: function data() {
	    return {
	      role: null,
	      selectedStrategy: null,
	      selectedStrategyType: null,
	      authOptions: null,
	      tagName: null,
	      name: null,
	      isNew: false,
	      currentRow: null,
	      currentId: null,
	      strategyTypeOptions: [],
	      strategyOptions: [],
	      tableProps: {
	        dataext: [],
	        columns: [{ name: 'name', displayName: 'Name', visible: true, type: 'string', isEditable: false }, { name: 'tagName', displayName: 'Tag Name', visible: true, type: 'string', isEditable: false }, { name: 'strategy', displayName: 'Strategy', visible: true, type: 'string', isEditable: false }, { name: 'strategyType', displayName: 'Strategy Type', visible: true, type: 'string', isEditable: false }, { name: 'options', displayName: 'Options', visible: true, type: 'string', isEditable: false }],
	        hasControls: true,
	        allowCreation: true,
	        disableSearch: false,
	        pagination: {
	          size: 50
	        }
	      },
	      roles: null
	    };
	  },
	
	  watch: {},
	  validations: {},
	  computed: {},
	  methods: {
	    parseAuthConfigs: function parseAuthConfigs() {
	      var _this = this;
	
	      this.tableProps.dataext = [];
	      _managedata2.default.getAuthConfigs().then(function (res) {
	        if (res && res.body) {
	          res.body.forEach(function (val) {
	            _this.tableProps.dataext.push({
	              name: val.name,
	              tagName: val.tagName,
	              strategy: val.strategy,
	              strategyType: val.strategyType,
	              options: val.options,
	              isEnabled: val.isEnabled,
	              id: val.id
	            });
	          });
	        }
	        _this.tableProps.dataext;
	      }).catch(function (err) {
	        console.log('Error:', err);
	      });
	    },
	    openDialog: function openDialog(row) {
	      if (row) {
	        console.log(row);
	        this.name = row.name;
	        this.tagName = row.tagName;
	        this.selectedStrategy = row.strategy;
	        this.selectedStrategyType = row.strategyType;
	        this.authOptions = JSON.stringify(row.options);
	        this.isNew = false;
	        this.currentId = row.id;
	      } else {
	        this.name = null;
	        this.tagName = null;
	        this.selectedStrategy = null;
	        this.selectedStrategyType = null;
	        this.authOptions = null;
	        this.isNew = true;
	      }
	      this.$refs.dialog.open();
	    },
	    closeDialog: function closeDialog(isSaved) {
	      var _this2 = this;
	
	      if (isSaved && !this.isNew) {
	        console.log('UPDATE ENDPOINT', this.currentRow);
	        var data = {
	          name: this.name,
	          tagName: this.tagName,
	          strategy: this.selectedStrategy,
	          strategyType: this.selectedStrategyType,
	          id: this.currentId,
	          options: this.authOptions
	        };
	
	        try {
	          data.options = JSON.parse(data.options);
	        } catch (e) {
	          console.log(e.message);
	        }
	        _managedata2.default.updateAuthConfig(data).then(function (res) {
	          console.log(res);
	          _this2.parseAuthConfigs();
	        }).catch(function (err) {
	          console.log('Error:', err);
	        });
	      } else if (isSaved && this.isNew) {
	        var _data = {
	          name: this.name,
	          tagName: this.tagName,
	          strategy: this.selectedStrategy,
	          strategyType: this.selectedStrategyType,
	          options: this.authOptions
	        };
	
	        try {
	          _data.options = JSON.parse(_data.options);
	        } catch (e) {
	          console.log(e.message);
	        }
	        _managedata2.default.saveAuthConfig(_data).then(function (res) {
	          console.log(res);
	          _this2.parseAuthConfigs();
	        }).catch(function (err) {
	          console.log('Error:', err);
	        });
	        console.log('SAVE ENDPOINT', this.name);
	      }
	      this.$refs.dialog.close();
	      this.name = null;
	      this.tagName = null;
	      this.selectedStrategy = null;
	      this.selectedStrategyType = null;
	      this.authOptions = null;
	    },
	    openConfirmDialog: function openConfirmDialog(row) {
	      this.currentRow = row;
	      this.$refs.confirmDialog.open();
	    },
	    closeConfirmDialog: function closeConfirmDialog(isConfirmed) {
	      var _this3 = this;
	
	      if (isConfirmed) {
	        console.log('DELETE ENDPOINT', this.currentRow.id);
	        _managedata2.default.deleteAuthConfig(this.currentRow.id).then(function (res) {
	          console.log(res);
	          _this3.parseAuthConfigs();
	        }).catch(function (err) {
	          console.log('Error:', err);
	        });
	      }
	      this.$refs.confirmDialog.close();
	    }
	  },
	  mounted: function mounted() {
	    this.parseAuthConfigs();
	    this.strategyOptions = ['passport-azure-ad', 'passport-saml', 'passport-openidconnect'];
	    this.strategyTypeOptions = ['Strategy', 'OIDCStrategy'];
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	
	exports.default = {
	  name: 'Auth',
	  data: function data() {
	    return {
	      token: localStorage.getItem('WBToken'),
	      userId: localStorage.getItem('userId')
	    };
	  },
	  created: function created() {
	    window.addEventListener('message', this.logout);
	
	    if (!this.token) {
	      window.parent.postMessage({ message: 'login' }, '*');
	    } else {
	      window.parent.postMessage({ message: 'loaded' }, '*');
	
	      // Set event listener for 'update-token' message request
	      window.addEventListener('message', this.sendToken);
	    }
	  },
	
	  methods: {
	    sendToken: function sendToken(event) {
	      if (event.data && event.data.message === 'update-token') {
	        var message = {
	          message: 'token-to-update',
	          token: this.token,
	          userId: this.userId,
	          remember: true
	        };
	
	        window.parent.postMessage(message, '*');
	      }
	    },
	    logout: function logout(event) {
	      if (event.data && event.data.message === 'logout') {
	        localStorage.removeItem('WBToken');
	        localStorage.removeItem('userId');
	
	        this.$store.dispatch('logout');
	
	        window.parent.postMessage({ message: 'loggedOut' }, '*');
	      }
	    }
	  }
	};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _config = __webpack_require__(13);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	var _params = __webpack_require__(10);
	
	var _params2 = _interopRequireDefault(_params);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _vuex = __webpack_require__(3);
	
	var _auth0Js = __webpack_require__(165);
	
	var _auth0Js2 = _interopRequireDefault(_auth0Js);
	
	var _quinyxGreen = __webpack_require__(161);
	
	var _quinyxGreen2 = _interopRequireDefault(_quinyxGreen);
	
	var _vueMultiselect = __webpack_require__(6);
	
	var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Login",
	  components: {
	    Multiselect: _vueMultiselect2.default
	  },
	  data: function data() {
	    return {
	      selectedSso: null,
	      ssoOptions: [],
	      logoUrl: _quinyxGreen2.default,
	      isExternal: false,
	      loginAppId: null,
	      appId: _params2.default.getParameterValue("APP_ID"),
	      apiUrl: _params2.default.getParameterValue("API_URL"),
	      user: {
	        username: null,
	        password: null
	      },
	      remember: true,
	      rememberAll: true,
	      forgottenEmail: null,
	      faqUrl: _config2.default.faqUrl,
	      faqUrlLoginAnchor: _config2.default.faqUrlLoginAnchor,
	      systemStatusUrl: _config2.default.systemStatusUrl,
	      widgetBrainSupportEmail: _config2.default.widgetBrainSupportEmail,
	      imagesUrls: ["../../static/factory.svg", "../../static/screen.png", "../../static/arm.png"],
	      imageNum: 0,
	      auth0Config: _extends({}, _config2.default.auth0Config, {
	        redirectUri: _params2.default.getParameterValue("UI_URL") + "/#/login",
	        audience: "https://" + _config2.default.auth0Config.domain + "/userinfo",
	        scope: "openid profile email",
	        responseType: "code",
	        responseMode: "query"
	      })
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)(["WBToken", "userId", "dialogErrorMessage", "dialogErrorMessageRandom", "dialogErrorCode"]), {
	    alfaDesign: function alfaDesign() {
	      return !!this.$route.query.alfaDesign;
	    },
	    customApiUrl: function customApiUrl() {
	      return this.$route.query.apiUrl;
	    },
	    neoUrl: function neoUrl() {
	      return _params2.default.getParameterValue("NEO_URL");
	    }
	  }),
	  watch: {
	    dialogErrorMessageRandom: function dialogErrorMessageRandom(newValue, oldValue) {
	      this.$refs.errorDialog.open();
	    }
	  },
	  created: function created() {
	    this.getSsoOptions();
	
	    this.loginAppId = this.$route.query.loginAppId ? this.$route.query.loginAppId : this.appId;
	
	    this.auth0Config.redirectUri = window.location.origin + "/#" + this.$route.path;
	
	    this.auth0 = new _auth0Js2.default.WebAuth(_extends({}, this.auth0Config, {
	      state: this.$route.path + "|" + this.loginAppId
	    }));
	  },
	
	  methods: {
	    getSsoOptions: function getSsoOptions() {
	      var _this = this;
	
	      _managedata2.default.getSsoOptions().then(function (res) {
	        _this.ssoOptions = res.body;
	
	        //ssoOptions filtering - okta&azure:
	        _this.ssoOptions = _this.ssoOptions.filter(function (option) {
	          return option.name === "Okta" || option.name === "Azure";
	        });
	        if (_utils2.default.isQuinyx()) {
	          _this.ssoOptions.push({
	            name: "Quinyx",
	            tagName: "quinyxNeo"
	          });
	        }
	      }).catch(function (err) {
	        console.log("Error:", err);
	      });
	    },
	    login: function login() {
	      var _this2 = this;
	
	      // Make email input data case insensitive
	      this.user.username = this.user.username.toLowerCase();
	      if (this.checkEmail(this.user.username)) {
	        this.user.email = this.user.username;
	        delete this.user.username;
	      }
	
	      this.$store.dispatch("login", {
	        user: this.user,
	        remember: this.remember,
	        rememberAll: this.rememberAll,
	        isExternal: this.isExternal
	      }).then(function (res) {
	        if (_this2.isExternal) {
	          var message = {
	            message: "loggedIn",
	            token: _this2.WBToken,
	            userId: _this2.userId,
	            remember: _this2.rememberAll || _this2.remember
	          };
	
	          window.parent.postMessage(message, "*");
	          // window.parent.location.reload();
	        }
	      }).catch(function (err) {
	        console.log("Error: ", err);
	        if (_this2.isExternal) {
	          window.parent.postMessage({ message: "loggedOut" }, "*");
	        }
	      });
	    },
	    loginWithAuth0: function loginWithAuth0(authorizationCode, callbackUrl, appId) {
	      var _this3 = this;
	
	      fetch(this.apiUrl + "/api/WBUsers/authorizeByAuth0Code", {
	        method: "POST",
	        headers: { "Content-Type": "application/json" },
	        body: JSON.stringify({ authorizationCode: authorizationCode, callbackUrl: callbackUrl, appId: appId })
	      }).then(function (res) {
	        return res.json();
	      }).then(function (body) {
	        return _this3.$store.dispatch("setupToken", {
	          body: body,
	          remember: _this3.remember,
	          rememberAll: _this3.rememberAll,
	          isExternal: _this3.isExternal
	        });
	      }).then(function () {
	        if (!_this3.isExternal) {
	          return;
	        }
	
	        var message = {
	          message: "loggedIn",
	          token: _this3.WBToken,
	          userId: _this3.userId,
	          remember: _this3.rememberAll || _this3.remember
	        };
	
	        window.parent.postMessage(message, "*");
	        window.parent.location.reload();
	      }).catch(function (err) {
	        console.error(err.message);
	      });
	    },
	    checkEmail: function checkEmail(email) {
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
	      return re.test(email);
	    },
	    openDialog: function openDialog(ref) {
	      this.$refs.errorDialog.close();
	      this.$refs[ref].open();
	    },
	    closeDialog: function closeDialog(ref, isConfirmed) {
	      if (isConfirmed) {
	        this.$store.dispatch("forgotPassword", this.forgottenEmail);
	      }
	      this.$refs[ref].close();
	    },
	    checkToken: function checkToken() {
	      var _this4 = this;
	
	      return new Promise(function (resolve) {
	        var token = _this4.WBToken || localStorage.getItem("WBToken");
	        var userId = _this4.userId || localStorage.getItem("userId");
	
	        if (!(token && userId)) {
	          resolve(false);
	          return;
	        }
	
	        if (_this4.$route.query.logout === "true") {
	          _this4.$store.commit("LOGOUT");
	          resolve(false);
	        } else {
	          _this4.$store.dispatch("getUser").then(function (res) {
	            var message = {
	              message: "loggedIn",
	              token: token,
	              userId: userId,
	              remember: true
	            };
	            window.parent.postMessage(message, "*");
	
	            resolve(true);
	          }).catch(function (err) {
	            resolve(false);
	          });
	        }
	      });
	    },
	    closeErrorDialog: function closeErrorDialog() {
	      this.$refs.errorDialog.close();
	    },
	    auth0Login: function auth0Login() {
	      this.auth0.authorize();
	    },
	    SSOLogin: function SSOLogin() {
	      var _this5 = this;
	
	      if (this.selectedSso.tagName === "quinyxNeo") {
	        window.parent.postMessage("quinyxLogin", "*");
	        setTimeout(function () {
	          window.open(_this5.neoUrl, "_blank");
	        }, 1000);
	      } else {
	        window.location.href = this.apiUrl + "/auth/openid/login?config=" + this.selectedSso.tagName + "&appId=" + this.loginAppId;
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    var self = this;
	    var currentUrl = new URL(window.location.href);
	
	    if (self.alfaDesign) {
	      setInterval(function () {
	        if (self.imageNum === 2) {
	          self.imageNum = 0;
	        } else {
	          self.imageNum++;
	        }
	      }, 3000);
	    }
	
	    if (this.customApiUrl) {
	      this.$store.dispatch("setCustomApiUrl", this.customApiUrl);
	    }
	
	    window.addEventListener("message", function (event) {
	      var _event$data = event.data,
	          _event$data$authoriza = _event$data.authorizationCode,
	          authorizationCode = _event$data$authoriza === undefined ? null : _event$data$authoriza,
	          _event$data$appId = _event$data.appId,
	          appId = _event$data$appId === undefined ? null : _event$data$appId,
	          _event$data$callbackU = _event$data.callbackUrl,
	          callbackUrl = _event$data$callbackU === undefined ? null : _event$data$callbackU,
	          _event$data$id = _event$data.id,
	          id = _event$data$id === undefined ? null : _event$data$id,
	          _event$data$userId = _event$data.userId,
	          userId = _event$data$userId === undefined ? null : _event$data$userId;
	
	
	      var redirectUrl = callbackUrl || self.auth0Config.redirectUri;
	
	      if (authorizationCode && appId && !self.WBToken && !self.userId) {
	        self.loginWithAuth0(authorizationCode, redirectUrl, appId);
	      }
	
	      if (id && userId) {
	        self.$store.dispatch("setupToken", {
	          body: { id: id, userId: userId },
	          remember: true
	        });
	      }
	    });
	
	    var state = currentUrl.searchParams.get("state") || "|";
	
	    var _state$split = state.split("|"),
	        _state$split2 = _slicedToArray(_state$split, 2),
	        _state$split2$ = _state$split2[0],
	        externalState = _state$split2$ === undefined ? "" : _state$split2$,
	        _state$split2$2 = _state$split2[1],
	        appId = _state$split2$2 === undefined ? this.appId : _state$split2$2;
	
	    var access_token = currentUrl.searchParams.get("access_token");
	    Promise.resolve(access_token).then(function (access_token) {
	      if (!access_token) {
	        return;
	      }
	
	      var body = {
	        id: access_token,
	        userId: currentUrl.searchParams.get("userId")
	      };
	
	      return self.$store.dispatch("setupToken", {
	        body: body,
	        remember: self.remember,
	        rememberAll: self.rememberAll,
	        isExternal: self.isExternal
	      }).then(function () {
	        var message = {
	          token: body.id,
	          userId: body.userId,
	          remember: true
	        };
	        window.parent.postMessage(message, "*");
	      });
	    }).then(function () {
	      return _this6.$route.path === "/externallogin" || externalState === "/externallogin";
	    }).then(function (isExternal) {
	      if (isExternal) {
	        self.isExternal = true;
	        return self.checkToken();
	      }
	
	      return false;
	    }).then(function (isLoggedId) {
	      if (isLoggedId) {
	        return;
	      }
	
	      var authorizationCode = currentUrl.searchParams.get("code");
	      var callbackUrl = self.auth0Config.redirectUri;
	
	      if (authorizationCode && appId && !self.WBToken && !self.userId) {
	        self.loginWithAuth0(authorizationCode, callbackUrl, appId);
	      }
	    }).catch(function (err) {
	      console.log(err.message);
	    });
	  }
	};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _vuex = __webpack_require__(3);
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	var _timeAgo = __webpack_require__(262);
	
	var _timeAgo2 = _interopRequireDefault(_timeAgo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'MyAccount',
	    methods: {
	        // Basic Info methods
	        toggleBasicInfoEditableMode: function toggleBasicInfoEditableMode() {
	            if (!this.isBasicInfoEditable) {
	                this.newName = this.user.name;
	            }
	
	            this.isBasicInfoEditable = !this.isBasicInfoEditable;
	        },
	        validateFullName: function validateFullName() {
	            var _this = this;
	
	            if (this.newName === '') {
	                this.isNewNameValid = false;
	                this.validationMessageOfNewName = 'Full name should not be empty';
	                return;
	            }
	            _managedata2.default.validateFullName(this.newName).then(function (res) {
	                var result = res.body.result;
	                _this.isNewNameValid = result.valid;
	                _this.validationMessageOfNewName = result.valid ? '' : 'Full name is not valid';
	            }).catch(function (err) {
	                _this.isNewNameValid = false;
	                console.log(err);
	            });
	        },
	        saveBasicInfo: function saveBasicInfo() {
	            var _this2 = this;
	
	            this.isBasicInfoEditable = false;
	            if (this.newName === this.user.name) return;
	            this.isSaving = true;
	            this.$store.dispatch("updateUser", { id: this.user.id, name: this.newName.trim() }).finally(function () {
	                _this2.isSaving = false;
	            });
	        },
	        cancelBasicInfoEditing: function cancelBasicInfoEditing() {
	            this.isBasicInfoEditable = false;
	        },
	
	        // Security Info methods
	        togglePasswordChangeMode: function togglePasswordChangeMode() {
	            this.oldPassword = '';
	            this.newPassword = '';
	            this.confirmPassword = '';
	            this.validationMessageOfNewPassword = '';
	            this.validationMessageOfConfirmePassword = '';
	            this.isNewPasswordValid = true;
	            this.arePasswordsSame = true;
	            this.isSecurityInfoEditable = !this.isSecurityInfoEditable;
	        },
	        validateNewPassword: function validateNewPassword() {
	            var _this3 = this;
	
	            if (this.newPassword === this.oldPassword) {
	                this.isNewPasswordValid = false;
	                this.validationMessageOfNewPassword = 'The new and old passwords should be different';
	                return;
	            }
	            _managedata2.default.validatePassword(this.newPassword).then(function (res) {
	                var result = res.body.result;
	                _this3.isNewPasswordValid = result.valid;
	                _this3.validationMessageOfNewPassword = result.requirements[0] || '';
	                _this3.confirmNewPassword();
	            }).catch(function (err) {
	                _this3.isNewPasswordValid = false;
	                console.log(err);
	            });
	        },
	        confirmNewPassword: function confirmNewPassword() {
	            if (this.confirmPassword === '') return;
	            if (this.newPassword === this.confirmPassword) {
	                this.arePasswordsSame = true;
	                this.validationMessageOfConfirmePassword = '';
	            } else {
	                this.arePasswordsSame = false;
	                this.validationMessageOfConfirmePassword = 'Passwords do not match';
	            }
	        },
	        saveNewPassword: function saveNewPassword() {
	            var _this4 = this;
	
	            this.isSecurityInfoEditable = false;
	            this.isSaving = true;
	            this.$store.dispatch("changePassword", { userId: this.user.id,
	                oldPassword: this.oldPassword,
	                newPassword: this.newPassword
	            }).catch(function (err) {
	                if (err.body && err.body.error && err.body.error.message) {
	                    _this4.$store.commit({
	                        type: 'SET_MESSAGE',
	                        message: err.body.error.message
	                    });
	                }
	            }).finally(function () {
	                _this4.isSaving = false;
	            });
	        },
	        resetCredentials: function resetCredentials() {
	            var _this5 = this;
	
	            this.$store.dispatch('resetAuth0Credentials').then(function (res) {
	                _this5.$refs.credentialsDialog.open();
	                _this5.clientId = res.body.clientId;
	                _this5.clientSecret = res.body.clientSecret;
	            }).catch(function (err) {
	                console.log(err);
	            });
	        },
	        closeCredentialsDialog: function closeCredentialsDialog() {
	            this.$refs.credentialsDialog.close();
	            this.clientId = '';
	            this.clientSecret = '';
	        }
	    },
	    mounted: function mounted() {
	        var _this6 = this;
	
	        _managedata2.default.getUserLogs().then(function (res) {
	            var logs = res.body;
	            // if there is no login/logout logs then consider we have nothing to show
	            _this6.noLogsFound = !logs.some(function (log) {
	                return ~log.route.toLowerCase().indexOf('login') || ~log.route.toLowerCase().indexOf('logout');
	            });
	            _this6.logs = logs;
	        }).catch(function (err) {
	            _this6.noLogsFound = true;
	            console.log(err);
	        });
	    },
	    computed: _extends({}, (0, _vuex.mapGetters)(['user']), {
	        isReadyToSaveNewPassword: function isReadyToSaveNewPassword() {
	            return this.oldPassword && this.newPassword && this.confirmPassword && this.isNewPasswordValid && this.arePasswordsSame;
	        },
	        sortedLogs: function sortedLogs() {
	            return this.logs.filter(function (log) {
	                // exclude everything except login/logout attempts
	                return ~log.route.toLowerCase().indexOf('login') || ~log.route.toLowerCase().indexOf('logout');
	            }).map(function (log) {
	                var action = void 0;
	                if (~log.route.toLowerCase().indexOf('login')) {
	                    action = 'Login';
	                }
	                if (~log.route.toLowerCase().indexOf('logout')) {
	                    action = 'Logout';
	                }
	
	                var logDate = new Date(log.logTime);
	
	                var newLog = {
	                    id: log.id,
	                    success: log.httpstatus.toString()[0] === '2', // 2xx http statuses are successful
	                    action: action,
	                    IP: log.ipAddress,
	                    ago: _timeAgo2.default.ago(logDate),
	                    date: logDate
	                };
	
	                return newLog;
	            }).sort(function (a, b) {
	                return b.date - a.date;
	            });
	        }
	    }),
	    data: function data() {
	        return {
	            isSaving: false,
	            logs: [],
	
	            // Basic Info data
	            isBasicInfoEditable: false,
	            isNewNameValid: true,
	            newName: '',
	            validationMessageOfNewName: '',
	
	            // Security Info data
	            isSecurityInfoEditable: false,
	            isNewPasswordValid: true,
	            arePasswordsSame: true,
	
	            oldPassword: '',
	            newPassword: '',
	            confirmPassword: '',
	
	            validationMessageOfOldPassword: '',
	            validationMessageOfNewPassword: '',
	            validationMessageOfConfirmePassword: '',
	
	            noLogsFound: false,
	
	            clientId: '',
	            clientSecret: ''
	        };
	    },
	
	    watch: {
	        oldPassword: function oldPassword(val) {
	            var _this7 = this;
	
	            _managedata2.default.validateOldPassword(val).then(function (resp) {
	                _this7.validationMessageOfOldPassword = resp.body.message;
	            });
	        }
	    }
	
	    /*
	    logsMock:
	    [ {
	        "logType": "INFO",
	        "methodType": "GET",
	        "httpstatus": 200,
	        "logTime": "2018-05-03T07:23:45.659Z",
	        "route": "/api/WBUsers/login",
	        "ipAddress": "52.58.29.20",
	        "userId": 488,
	        "appId": 10,
	        "token": "orAvZFXTix8Nm3I356R7mTPIzPfjQDYGpaQsquXJHLaIfFdtX82RExImudzk2lnJ",
	        "id": "5aeab903cc43417d12c2b21a",
	        "environment": "test"
	      },
	      {
	        "logType": "INFO",
	        "methodType": "GET",
	        "httpstatus": 200,
	        "logTime": "2018-05-03T07:24:45.659Z",
	        "route": "/api/WBUsers/logout",
	        "ipAddress": "52.58.29.20",
	        "userId": 488,
	        "appId": 10,
	        "token": "orAvZFXTix8Nm3I356R7mTPIzPfjQDYGpaQsquXJHLaIfFdtX82RExImudzk2lnJ",
	        "id": "5aeab903ca43417d12c2e21a",
	        "environment": "test"
	      },
	      {
	        "logType": "INFO",
	        "methodType": "GET",
	        "httpstatus": 200,
	        "logTime": "2018-05-04T07:25:45.659Z",
	        "route": "/api/WBUsers/login",
	        "ipAddress": "52.58.29.20",
	        "userId": 488,
	        "appId": 10,
	        "token": "orAvZFXTix8Nm3I356R7mTPIzPfjQDYGpaQsquXJHLaIfFdtX82RExImudzk2lnJ",
	        "id": "5aecb903cc43417d12c2e21a",
	        "environment": "test"
	      },
	      {
	        "logType": "ERROR",
	        "methodType": "GET",
	        "httpstatus": 500,
	        "logTime": "2018-05-03T07:39:45.659Z",
	        "route": "/api/WBUsers/login",
	        "ipAddress": "52.58.29.20",
	        "userId": 488,
	        "appId": 10,
	        "id": "3aeab903cc43417d12c2e21a",
	        "environment": "test"
	      },
	      {
	        "logType": "ERROR",
	        "methodType": "GET",
	        "httpstatus": 500,
	        "logTime": "2018-05-04T09:44:45.659Z",
	        "route": "/api/WBUsers/login",
	        "ipAddress": "52.58.29.20",
	        "userId": 488,
	        "appId": 10,
	        "id": "1aeab903cc43417d12c2e21a",
	        "environment": "test"
	      }
	    ]
	    */
	
	};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	var _logo = __webpack_require__(264);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  name: 'PasswordChange',
	  data: function data() {
	    return {
	      logoUrl: _logo2.default,
	      password: '',
	      passwordRepeat: '',
	      requirements: []
	    };
	  },
	
	  methods: {
	    checkPassword: function checkPassword() {
	      var _this = this;
	
	      _managedata2.default.validatePassword(this.password).then(function (res) {
	        if (res.body.result.requirements && res.body.result.requirements.length > 0) {
	          _this.requirements = res.body.result.requirements;
	        } else {
	          _this.requirements = [];
	        }
	
	        if (_this.password !== _this.passwordRepeat) {
	          _this.requirements.push('Passwords should match');
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    },
	    resetPassword: function resetPassword() {
	      console.log('reset', this.requirements, this.password !== this.passwordRepeat);
	      if (this.password !== this.passwordRepeat) return;
	      this.$store.dispatch('resetPassword', { pw: this.password, token: this.$route.query.access_token });
	    }
	  },
	  watch: {
	    password: function password() {
	      this.checkPassword();
	    },
	    passwordRepeat: function passwordRepeat() {
	      this.checkPassword();
	    }
	  }
	};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	var _config = __webpack_require__(13);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'Portal',
	    computed: _extends({}, (0, _vuex.mapGetters)(['groupedApps', 'selectedCategories', 'categories', 'assignments', 'WBToken', 'userId']), {
	        filteredApps: function filteredApps() {
	            var _this = this;
	
	            return this.searchText ? this.sortedApps.filter(function (el) {
	                return el.Name.toLowerCase().includes(_this.searchText.toLowerCase());
	            }) : this.sortedApps;
	        },
	        sortedApps: function sortedApps() {
	            return this.groupedApps && this.groupedApps.slice().sort(function (a, b) {
	                var catA = a.Name && a.Name.toUpperCase();
	                var catB = b.Name && b.Name.toUpperCase();
	
	                if (catA < catB) {
	                    return -1;
	                }
	                if (catA > catB) {
	                    return 1;
	                }
	                return 0;
	            });
	        }
	    }),
	    data: function data() {
	        return {
	            localSelectedCategories: null,
	            showSidebar: false,
	            searchText: ''
	        };
	    },
	
	    methods: {
	        hasCategory: function hasCategory(category) {
	            return this.localSelectedCategories && this.localSelectedCategories.findIndex(function (cat) {
	                return cat === category;
	            }) !== -1;
	        },
	        enabled: function enabled(app) {
	            return this.assignments && app && this.assignments.findIndex(function (assignment) {
	                return assignment.appId == app.id;
	            }) !== -1;
	        },
	        forward: function forward(app) {
	            if (this.enabled(app)) {
	                var url = app.url;
	                var token = this.WBToken || localStorage.getItem('WBToken');
	                var userId = this.userId || localStorage.getItem('userId');
	                window.location.href = url + "?wbtoken=" + token + '&user=' + userId;
	            }
	        },
	        getImageSrc: function getImageSrc(src) {
	            var result = '';
	            if (src && src.indexOf('http') !== -1) {
	                result = src;
	            } else {
	                result = '/static/' + src;
	            }
	            return result;
	        },
	        isEnvActive: function isEnvActive(env, apps) {
	            return !!apps.find(function (e) {
	                return e.environment === env;
	            });
	        },
	        getAppByEnv: function getAppByEnv(env, apps) {
	            return apps.find(function (e) {
	                return e.environment === env;
	            });
	        }
	    },
	    mounted: function mounted() {
	        var _this2 = this;
	
	        this.$store.dispatch('getGroupedApps').then(function () {
	            var userApps = _this2.groupedApps.filter(function (app) {
	                return app.id !== _config2.default.appId;
	            });
	            // if (userApps.length > 1 || (userApps.length === 1 && userApps[0].url === null)) {
	            //     return this.$store.dispatch('getAssignments');
	            // }
	            if (userApps.length > 0 || userApps.length === 1 && userApps[0].url === null) {
	                return _this2.$store.dispatch('getAssignments');
	            }
	            /*else if(userApps.length === 1 && !this.$store.state.isAdmin) {
	                     window.location.href = userApps[0].url;
	                   }*/
	        }).then(function () {
	            _this2.localSelectedCategories = _this2.selectedCategories;
	        });
	    }
	};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _params = __webpack_require__(10);
	
	var _params2 = _interopRequireDefault(_params);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "QuinyxLogInRedirect",
	  data: function data() {
	    return {};
	  },
	  computed: {
	    url: function url() {
	      return _params2.default.getParameterValue("NEO_URL");
	    }
	  },
	  methods: {
	    update: function update() {
	      window.addEventListener("focus", function () {
	        window.location.reload(false);
	      });
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var _managedata = __webpack_require__(4);
	
	var _managedata2 = _interopRequireDefault(_managedata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = __webpack_require__(1);
	
	exports.default = {
	    name: 'sidebar',
	    components: {},
	    props: ['title', 'type', // application, service or notifications
	    'data', 'errors'],
	    data: function data() {
	        return {
	            headerColors: ['#0098FF', '#4a90e2'],
	            chartOptions: {},
	            chartData: {},
	            dataChartKey: null,
	            showStatus: true
	        };
	    },
	    created: function created() {
	        this.setChartOptions();
	    },
	    mounted: function mounted() {
	        if (this.type === 'service') this.setChartData(this.data.id);
	    },
	    updated: function updated() {},
	
	    watch: {
	        type: function type(val, oldVal) {
	            if (val === 'service' && oldVal === 'application') {
	                this.setChartData(this.data.id);
	            }
	        }
	    },
	    methods: {
	        toggleMessage: function toggleMessage(message) {
	            message.show = !message.show;
	            this.$forceUpdate();
	        },
	        clickOnMessage: function clickOnMessage(message) {
	            var self = this;
	            /*this.data.forEach(err => {
	              if (err.message === message.message &&
	                err.serviceId && message.serviceId &&
	                err.time && message.time &&
	                err.serviceName && message.serviceName &&
	                err.topic && message.topic
	              ) {
	                err.isRead = true;
	              }
	            });*/
	            _managedata2.default.markAlarmMessageAsRead(message).then(function () {
	                message.isRead = true;
	            }).catch(function () {});
	        },
	        goToService: function goToService(id) {
	            this.$router.push({ name: 'serviceManagement:id', params: { id: id } });
	        },
	        closeSidebar: function closeSidebar() {
	            this.$emit('closeSidebar', this.type);
	        },
	        getChartsData: function getChartsData(id, dataKey, cb) {
	            var _this = this;
	
	            var hrdData = [];
	            if (id) {
	                var from = moment().subtract(1, 'months').startOf('day').toDate();
	                var to = new Date();
	                var demarcate = false;
	                var aggregator = dataKey === 'calls' ? 'count' : 'mean';
	                var group = 'time(1d)';
	                _managedata2.default.getDetailsOfService(id, from, to, function (response) {
	                    _this.data.uptime = response.body.responseTime;
	                    if (response.body.callsInInterval) {
	                        hrdData = response.body.callsInInterval.map(function (item) {
	                            return {
	                                time: item.time,
	                                responseTime: Math.round(item.mean_responseTime),
	                                algorithmValue: '13',
	                                actualValue: '17',
	                                error: false,
	                                accuracy: item.mean_accuracy,
	                                serviceState: item.mean_uptime,
	                                calls: item.mean_quantity
	                            };
	                        });
	                    }
	                    cb(hrdData);
	                }, function (err) {
	                    _this.$parent.openSnackbarError(err);
	                    cb(err);
	                });
	            }
	        },
	        setChartData: function setChartData(id, dataKey) {
	            var self = this;
	            var background = 'rgba(128,198,255,0.35)';
	            var borderBg = 'rgba(128,198,255,1)';
	            var data = [];
	            var labels = [];
	            if (!id) {
	                id = 0;
	            }
	            if (!dataKey) {
	                dataKey = 'accuracy';
	            }
	            this.dataChartKey = dataKey;
	            this.getChartsData(id, dataKey, function (detailedData) {
	                var promises = detailedData.map(function (item) {
	                    var value = void 0;
	                    if (typeof item[dataKey] === 'boolean') {
	                        value = item[dataKey] ? 1 : 0;
	                    } else {
	                        if (item[dataKey]) {
	                            value = Math.round(item[dataKey]);
	                        } else {
	                            value = 0;
	                        }
	                    }
	                    data.push(value);
	                    labels.push(moment(item.time).format('DD-MM-YY HH:mm'));
	                    return value;
	                });
	                Promise.all(promises).then(function () {
	                    self.chartData = {
	                        datasets: [{
	                            label: '',
	                            backgroundColor: background,
	                            borderColor: borderBg,
	                            cubicInterpolationMode: 'linear',
	                            lineTension: 0,
	                            borderWidth: 2,
	                            data: data
	                        }],
	                        labels: labels
	                    };
	                    self.$forceUpdate();
	                });
	            });
	        },
	        setChartOptions: function setChartOptions() {
	            this.chartOptions = {
	                elements: {
	                    point: {
	                        radius: 0
	                    },
	                    line: { stepped: true }
	                },
	                legend: {
	                    display: false
	                },
	                layout: {
	                    padding: 0
	                },
	                scales: {
	                    xAxes: [{
	                        gridLines: {
	                            display: true,
	                            color: 'rgba(132, 200, 205, 0.8)'
	                        },
	                        display: true,
	                        type: 'time',
	                        scaleLabel: {
	                            display: false
	                        },
	                        time: {
	                            parser: function parser(value) {
	                                return moment(value, 'DD-MM-YY HH:mm');
	                            },
	                            unit: 'day',
	                            displayFormats: {
	                                millisecond: 'DD-MM',
	                                second: 'DD-MM',
	                                minute: 'DD-MM',
	                                hour: 'DD-MM',
	                                day: 'DD-MM',
	                                week: 'DD-MM',
	                                month: 'DD-MM',
	                                quarter: 'DD-MM',
	                                year: 'DD-MM'
	                            }
	                        },
	                        ticks: {
	                            fontSize: 10,
	                            minRotation: 50,
	                            maxRotation: 50,
	                            autoSkip: true,
	                            callback: function callback(value, index, values) {
	                                if (index != 0 && index !== values.length - 1) return value;
	                            }
	                        }
	                    }],
	                    yAxes: [{
	                        gridLines: {
	                            display: true,
	                            color: 'rgba(132, 200, 205, 0.8)'
	                        },
	                        display: true,
	                        fontSize: 8,
	                        position: 'left',
	                        ticks: {
	                            display: false
	                        }
	                    }]
	                }
	            };
	            this.$forceUpdate();
	        },
	        selectService: function selectService(service) {
	            this.$emit('selectService', Object.assign(_extends({}, service), { selected: false }));
	        },
	        checkAll: function checkAll() {
	            var _this2 = this;
	
	            if (!this.isAllChecked) {
	                var promises = [];
	                var size = 500;
	                var count = Math.ceil(this.data.filter(function (e) {
	                    return !e.isRead;
	                }).length / size);
	                for (var i = 0; i < count; i++) {
	                    var data = this.data.filter(function (e) {
	                        return !e.isRead;
	                    }).splice(i * size, size);
	                    data.forEach(function (e) {
	                        if (e.context) {
	                            delete e.context;
	                        }
	                    });
	                    promises.push(_managedata2.default.markAlarmMessageAsRead(data).catch(function (err) {
	                        console.log(err);
	                    }));
	                }
	                Promise.all(promises).then(function () {
	                    _this2.data.forEach(function (e) {
	                        return e.isRead = true;
	                    });
	                });
	            }
	        }
	    },
	    computed: {
	        unwatchedErrorsCount: function unwatchedErrorsCount() {
	            var unwatchedErrors = this.errors.filter(function (error) {
	                return !error.isWatched;
	            });
	            console.log('unwatchedErrorsCount', unwatchedErrors);
	            return unwatchedErrors.length;
	        },
	        isAllChecked: function isAllChecked() {
	            return !this.data.filter(function (e) {
	                return !e.isRead;
	            }).length;
	        }
	    }
	};

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    application: function application(state) {
	        return true;
	    },
	    all: function all() {
	        return true;
	    }
	};

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 26,
		"./af.js": 26,
		"./ar": 33,
		"./ar-dz": 27,
		"./ar-dz.js": 27,
		"./ar-kw": 28,
		"./ar-kw.js": 28,
		"./ar-ly": 29,
		"./ar-ly.js": 29,
		"./ar-ma": 30,
		"./ar-ma.js": 30,
		"./ar-sa": 31,
		"./ar-sa.js": 31,
		"./ar-tn": 32,
		"./ar-tn.js": 32,
		"./ar.js": 33,
		"./az": 34,
		"./az.js": 34,
		"./be": 35,
		"./be.js": 35,
		"./bg": 36,
		"./bg.js": 36,
		"./bm": 37,
		"./bm.js": 37,
		"./bn": 39,
		"./bn-bd": 38,
		"./bn-bd.js": 38,
		"./bn.js": 39,
		"./bo": 40,
		"./bo.js": 40,
		"./br": 41,
		"./br.js": 41,
		"./bs": 42,
		"./bs.js": 42,
		"./ca": 43,
		"./ca.js": 43,
		"./cs": 44,
		"./cs.js": 44,
		"./cv": 45,
		"./cv.js": 45,
		"./cy": 46,
		"./cy.js": 46,
		"./da": 47,
		"./da.js": 47,
		"./de": 50,
		"./de-at": 48,
		"./de-at.js": 48,
		"./de-ch": 49,
		"./de-ch.js": 49,
		"./de.js": 50,
		"./dv": 51,
		"./dv.js": 51,
		"./el": 52,
		"./el.js": 52,
		"./en-au": 53,
		"./en-au.js": 53,
		"./en-ca": 54,
		"./en-ca.js": 54,
		"./en-gb": 55,
		"./en-gb.js": 55,
		"./en-ie": 56,
		"./en-ie.js": 56,
		"./en-il": 57,
		"./en-il.js": 57,
		"./en-in": 58,
		"./en-in.js": 58,
		"./en-nz": 59,
		"./en-nz.js": 59,
		"./en-sg": 60,
		"./en-sg.js": 60,
		"./eo": 61,
		"./eo.js": 61,
		"./es": 65,
		"./es-do": 62,
		"./es-do.js": 62,
		"./es-mx": 63,
		"./es-mx.js": 63,
		"./es-us": 64,
		"./es-us.js": 64,
		"./es.js": 65,
		"./et": 66,
		"./et.js": 66,
		"./eu": 67,
		"./eu.js": 67,
		"./fa": 68,
		"./fa.js": 68,
		"./fi": 69,
		"./fi.js": 69,
		"./fil": 70,
		"./fil.js": 70,
		"./fo": 71,
		"./fo.js": 71,
		"./fr": 74,
		"./fr-ca": 72,
		"./fr-ca.js": 72,
		"./fr-ch": 73,
		"./fr-ch.js": 73,
		"./fr.js": 74,
		"./fy": 75,
		"./fy.js": 75,
		"./ga": 76,
		"./ga.js": 76,
		"./gd": 77,
		"./gd.js": 77,
		"./gl": 78,
		"./gl.js": 78,
		"./gom-deva": 79,
		"./gom-deva.js": 79,
		"./gom-latn": 80,
		"./gom-latn.js": 80,
		"./gu": 81,
		"./gu.js": 81,
		"./he": 82,
		"./he.js": 82,
		"./hi": 83,
		"./hi.js": 83,
		"./hr": 84,
		"./hr.js": 84,
		"./hu": 85,
		"./hu.js": 85,
		"./hy-am": 86,
		"./hy-am.js": 86,
		"./id": 87,
		"./id.js": 87,
		"./is": 88,
		"./is.js": 88,
		"./it": 90,
		"./it-ch": 89,
		"./it-ch.js": 89,
		"./it.js": 90,
		"./ja": 91,
		"./ja.js": 91,
		"./jv": 92,
		"./jv.js": 92,
		"./ka": 93,
		"./ka.js": 93,
		"./kk": 94,
		"./kk.js": 94,
		"./km": 95,
		"./km.js": 95,
		"./kn": 96,
		"./kn.js": 96,
		"./ko": 97,
		"./ko.js": 97,
		"./ku": 98,
		"./ku.js": 98,
		"./ky": 99,
		"./ky.js": 99,
		"./lb": 100,
		"./lb.js": 100,
		"./lo": 101,
		"./lo.js": 101,
		"./lt": 102,
		"./lt.js": 102,
		"./lv": 103,
		"./lv.js": 103,
		"./me": 104,
		"./me.js": 104,
		"./mi": 105,
		"./mi.js": 105,
		"./mk": 106,
		"./mk.js": 106,
		"./ml": 107,
		"./ml.js": 107,
		"./mn": 108,
		"./mn.js": 108,
		"./mr": 109,
		"./mr.js": 109,
		"./ms": 111,
		"./ms-my": 110,
		"./ms-my.js": 110,
		"./ms.js": 111,
		"./mt": 112,
		"./mt.js": 112,
		"./my": 113,
		"./my.js": 113,
		"./nb": 114,
		"./nb.js": 114,
		"./ne": 115,
		"./ne.js": 115,
		"./nl": 117,
		"./nl-be": 116,
		"./nl-be.js": 116,
		"./nl.js": 117,
		"./nn": 118,
		"./nn.js": 118,
		"./oc-lnc": 119,
		"./oc-lnc.js": 119,
		"./pa-in": 120,
		"./pa-in.js": 120,
		"./pl": 121,
		"./pl.js": 121,
		"./pt": 123,
		"./pt-br": 122,
		"./pt-br.js": 122,
		"./pt.js": 123,
		"./ro": 124,
		"./ro.js": 124,
		"./ru": 125,
		"./ru.js": 125,
		"./sd": 126,
		"./sd.js": 126,
		"./se": 127,
		"./se.js": 127,
		"./si": 128,
		"./si.js": 128,
		"./sk": 129,
		"./sk.js": 129,
		"./sl": 130,
		"./sl.js": 130,
		"./sq": 131,
		"./sq.js": 131,
		"./sr": 133,
		"./sr-cyrl": 132,
		"./sr-cyrl.js": 132,
		"./sr.js": 133,
		"./ss": 134,
		"./ss.js": 134,
		"./sv": 135,
		"./sv.js": 135,
		"./sw": 136,
		"./sw.js": 136,
		"./ta": 137,
		"./ta.js": 137,
		"./te": 138,
		"./te.js": 138,
		"./tet": 139,
		"./tet.js": 139,
		"./tg": 140,
		"./tg.js": 140,
		"./th": 141,
		"./th.js": 141,
		"./tk": 142,
		"./tk.js": 142,
		"./tl-ph": 143,
		"./tl-ph.js": 143,
		"./tlh": 144,
		"./tlh.js": 144,
		"./tr": 145,
		"./tr.js": 145,
		"./tzl": 146,
		"./tzl.js": 146,
		"./tzm": 148,
		"./tzm-latn": 147,
		"./tzm-latn.js": 147,
		"./tzm.js": 148,
		"./ug-cn": 149,
		"./ug-cn.js": 149,
		"./uk": 150,
		"./uk.js": 150,
		"./ur": 151,
		"./ur.js": 151,
		"./uz": 153,
		"./uz-latn": 152,
		"./uz-latn.js": 152,
		"./uz.js": 153,
		"./vi": 154,
		"./vi.js": 154,
		"./x-pseudo": 155,
		"./x-pseudo.js": 155,
		"./yo": 156,
		"./yo.js": 156,
		"./zh-cn": 157,
		"./zh-cn.js": 157,
		"./zh-hk": 158,
		"./zh-hk.js": 158,
		"./zh-mo": 159,
		"./zh-mo.js": 159,
		"./zh-tw": 160,
		"./zh-tw.js": 160
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 260;


/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.1feba31.svg";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo-dark2.6d949cb.png";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo-white2.3103cd5.png";

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(227)
	
	/* script */
	__vue_exports__ = __webpack_require__(166)
	
	/* template */
	var __vue_template__ = __webpack_require__(299)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "customTableCell"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-15e241db"
	
	module.exports = __vue_exports__


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(228)
	
	/* script */
	__vue_exports__ = __webpack_require__(169)
	
	/* template */
	var __vue_template__ = __webpack_require__(300)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "filterModal"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-19e525de"
	
	module.exports = __vue_exports__


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(231)
	
	/* script */
	__vue_exports__ = __webpack_require__(171)
	
	/* template */
	var __vue_template__ = __webpack_require__(302)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "wbNav"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-26e84591"
	
	module.exports = __vue_exports__


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(225)
	
	/* script */
	__vue_exports__ = __webpack_require__(172)
	
	/* template */
	var __vue_template__ = __webpack_require__(297)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "App"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(226)
	
	/* script */
	__vue_exports__ = __webpack_require__(173)
	
	/* template */
	var __vue_template__ = __webpack_require__(298)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "Activate"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(236)
	__webpack_require__(237)
	
	/* script */
	__vue_exports__ = __webpack_require__(174)
	
	/* template */
	var __vue_template__ = __webpack_require__(306)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "Admin"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-344a9b58"
	
	module.exports = __vue_exports__


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(257)
	
	/* script */
	__vue_exports__ = __webpack_require__(175)
	
	/* template */
	var __vue_template__ = __webpack_require__(319)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "AdminAppGroups"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e7b90462"
	
	module.exports = __vue_exports__


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(224)
	__webpack_require__(223)
	
	/* script */
	__vue_exports__ = __webpack_require__(176)
	
	/* template */
	var __vue_template__ = __webpack_require__(295)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "AdminApps"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-03296468"
	
	module.exports = __vue_exports__


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(241)
	__webpack_require__(240)
	
	/* script */
	__vue_exports__ = __webpack_require__(177)
	
	/* template */
	var __vue_template__ = __webpack_require__(309)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "AdminDocumentations"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(256)
	__webpack_require__(255)
	
	/* script */
	__vue_exports__ = __webpack_require__(178)
	
	/* template */
	var __vue_template__ = __webpack_require__(318)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "AdminOrganizationAssignments"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(242)
	
	/* script */
	__vue_exports__ = __webpack_require__(179)
	
	/* template */
	var __vue_template__ = __webpack_require__(310)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "AdminOrganizations"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5b7bb59a"
	
	module.exports = __vue_exports__


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(234)
	__webpack_require__(233)
	
	/* script */
	__vue_exports__ = __webpack_require__(180)
	
	/* template */
	var __vue_template__ = __webpack_require__(304)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "AdminRoles"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(249)
	
	/* script */
	__vue_exports__ = __webpack_require__(181)
	
	/* template */
	var __vue_template__ = __webpack_require__(314)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "AdminTeams"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(232)
	
	/* script */
	__vue_exports__ = __webpack_require__(182)
	
	/* template */
	var __vue_template__ = __webpack_require__(303)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "AdminUsers"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-29dccffc"
	
	module.exports = __vue_exports__


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(229)
	__webpack_require__(230)
	
	/* script */
	__vue_exports__ = __webpack_require__(183)
	
	/* template */
	var __vue_template__ = __webpack_require__(301)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "AdminUsersTeam"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1f2b02ff"
	
	module.exports = __vue_exports__


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(254)
	__webpack_require__(253)
	
	/* script */
	__vue_exports__ = __webpack_require__(184)
	
	/* template */
	var __vue_template__ = __webpack_require__(317)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "AuthorizationConfigurations"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(185)
	
	/* template */
	var __vue_template__ = __webpack_require__(296)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "Auth"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(247)
	__webpack_require__(248)
	
	/* script */
	__vue_exports__ = __webpack_require__(186)
	
	/* template */
	var __vue_template__ = __webpack_require__(313)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "Login"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-66fa2b1c"
	
	module.exports = __vue_exports__


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(251)
	__webpack_require__(250)
	
	/* script */
	__vue_exports__ = __webpack_require__(187)
	
	/* template */
	var __vue_template__ = __webpack_require__(315)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "MyAccount"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-674b8d2c"
	
	module.exports = __vue_exports__


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(238)
	
	/* script */
	__vue_exports__ = __webpack_require__(188)
	
	/* template */
	var __vue_template__ = __webpack_require__(307)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "PasswordChange"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-39e4cd1c"
	
	module.exports = __vue_exports__


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(239)
	
	/* script */
	__vue_exports__ = __webpack_require__(189)
	
	/* template */
	var __vue_template__ = __webpack_require__(308)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "Portal"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3eab9e33"
	
	module.exports = __vue_exports__


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(258)
	
	/* script */
	__vue_exports__ = __webpack_require__(190)
	
	/* template */
	var __vue_template__ = __webpack_require__(320)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "QuinyxLogInRedirect"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(235)
	
	/* script */
	__vue_exports__ = __webpack_require__(191)
	
	/* template */
	var __vue_template__ = __webpack_require__(305)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	if(typeof __vue_options__.name === "undefined") {
	  __vue_options__.name = "sidebar"
	}__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2c22b4c5"
	
	module.exports = __vue_exports__


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin-tab"
	  }, [_c('wb-datatable', _vm._b({
	    staticClass: "apps-table",
	    attrs: {
	      "customControls": [{
	          icon: 'add',
	          name: 'Register at baas',
	          handler: function (row) {
	            _vm.openAdditionalDialog(row, 'baas');
	          }
	        },
	        {
	          icon: 'add',
	          name: 'Register audience',
	          handler: function (row) {
	            _vm.registerAudienceVert(row);
	          }
	        },
	        {
	          icon: 'delete',
	          name: 'Delete audience',
	          handler: function (row) {
	            _vm.deleteAudienceVert(row);
	          }
	        } ],
	      "searchKey": 'Name'
	    },
	    on: {
	      "addEmit": _vm.openDialog,
	      "editEmit": _vm.openDialog,
	      "deleteEmit": _vm.openConfirmDialog
	    }
	  }, 'wb-datatable', _vm.tableAppProps, false)), _vm._v(" "), _c('md-dialog', {
	    ref: "algDialog"
	  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create algorithm' : 'Update algorithm'))]), _vm._v(" "), _c('md-dialog-content', [_c('form')])], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "dialog"
	  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create app' : 'Update app'))]), _vm._v(" "), _c('md-dialog-content', [(_vm.app) ? _c('form', [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "disabled": !_vm.createNewAppGroup
	    },
	    model: {
	      value: (_vm.app.Name),
	      callback: function($$v) {
	        _vm.$set(_vm.app, "Name", $$v)
	      },
	      expression: "app.Name"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Category")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "disabled": !_vm.createNewAppGroup
	    },
	    model: {
	      value: (_vm.app.Category),
	      callback: function($$v) {
	        _vm.$set(_vm.app, "Category", $$v)
	      },
	      expression: "app.Category"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Image")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "disabled": !_vm.createNewAppGroup
	    },
	    model: {
	      value: (_vm.app.image),
	      callback: function($$v) {
	        _vm.$set(_vm.app, "image", $$v)
	      },
	      expression: "app.image"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("URL")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.app.url),
	      callback: function($$v) {
	        _vm.$set(_vm.app, "url", $$v)
	      },
	      expression: "app.url"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Environment")]), _vm._v(" "), _c('multiselect', {
	    attrs: {
	      "id": "environments",
	      "options": _vm.environments,
	      "placeholder": "Select environment"
	    },
	    model: {
	      value: (_vm.app.environment),
	      callback: function($$v) {
	        _vm.$set(_vm.app, "environment", $$v)
	      },
	      expression: "app.environment"
	    }
	  })], 1), _vm._v(" "), _c('div', [_c('md-switch', {
	    attrs: {
	      "id": "createNewAppGroup"
	    },
	    model: {
	      value: (_vm.createNewAppGroup),
	      callback: function($$v) {
	        _vm.createNewAppGroup = $$v
	      },
	      expression: "createNewAppGroup"
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "createNewAppGroup"
	    }
	  }, [_vm._v("Create new App Group")])], 1), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "id": "app-groups",
	      "options": _vm.appGroups,
	      "label": 'Name',
	      "disabled": _vm.createNewAppGroup,
	      "placeholder": "Select App Group"
	    },
	    model: {
	      value: (_vm.selectedAppGroup),
	      callback: function($$v) {
	        _vm.selectedAppGroup = $$v
	      },
	      expression: "selectedAppGroup"
	    }
	  })], 1), _vm._v(" "), (!_vm.isNew) ? _c('md-input-container', [_c('label', [_vm._v("Audience ID")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.app.audienceId),
	      callback: function($$v) {
	        _vm.$set(_vm.app, "audienceId", $$v)
	      },
	      expression: "app.audienceId"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('md-input-container', [_c('label', [_vm._v("Audience Parameter")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.app.audienceParameter),
	      callback: function($$v) {
	        _vm.$set(_vm.app, "audienceParameter", $$v)
	      },
	      expression: "app.audienceParameter"
	    }
	  })], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    attrs: {
	      "disabled": _vm.app && _vm.app.registerBaas && _vm.baasValidMessage && Object.keys(_vm.baasValidMessage).length > 0
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isNew ? 'Create' : 'Update') + "\n            ")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "confirmDialog"
	  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this app?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n            App will permanently be removed from the database. "), _c('br'), _vm._v(" "), (_vm.app && _vm.app.audienceId) ? [_vm._v("\n                Would you like to remove an audience?\n                "), _c('md-switch', {
	    attrs: {
	      "id": "delete-audience",
	      "name": "delete-audience"
	    },
	    model: {
	      value: (_vm.deleteAnAudience),
	      callback: function($$v) {
	        _vm.deleteAnAudience = $$v
	      },
	      expression: "deleteAnAudience"
	    }
	  }, [_vm._v("Delete an\n                    audience\n                ")])] : _vm._e()], 2), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(true)
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "baasDialog"
	  }, [_c('md-dialog-title', [_vm._v("Register baas algorithm")]), _vm._v(" "), _c('md-dialog-content', [(_vm.app) ? _c('form', [
	    [_c('md-input-container', [_c('label', [_vm._v("Select algorithm")]), _vm._v(" "), _c('md-select', {
	      on: {
	        "change": _vm.algorithmSelected
	      },
	      model: {
	        value: (_vm.algorithm),
	        callback: function($$v) {
	          _vm.algorithm = $$v
	        },
	        expression: "algorithm"
	      }
	    }, _vm._l((_vm.baasAlgorithms), function(algorithm) {
	      return _c('md-option', {
	        attrs: {
	          "value": algorithm
	        }
	      }, [_vm._v(_vm._s(algorithm.name) + "\n                            ")])
	    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.name) ? _c('p', {
	      staticClass: "validation-error"
	    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.name))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
	      attrs: {
	        "disabled": !!_vm.algorithm
	      },
	      model: {
	        value: (_vm.newAlgData.name),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "name", $$v)
	        },
	        expression: "newAlgData.name"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.category) ? _c('p', {
	      staticClass: "validation-error"
	    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.category))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Select category")]), _vm._v(" "), _c('md-select', {
	      attrs: {
	        "disabled": !!_vm.algorithm && _vm.newAlgData.category
	      },
	      model: {
	        value: (_vm.newAlgData.category),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "category", $$v)
	        },
	        expression: "newAlgData.category"
	      }
	    }, _vm._l((_vm.baasCategories), function(cat) {
	      return _c('md-option', {
	        attrs: {
	          "value": cat
	        }
	      }, [_vm._v(_vm._s(cat.name))])
	    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.service) ? _c('p', {
	      staticClass: "validation-error"
	    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.service))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Select Maas service")]), _vm._v(" "), _c('md-select', {
	      on: {
	        "change": _vm.maasServiceSelect
	      },
	      model: {
	        value: (_vm.newAlgData.service),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "service", $$v)
	        },
	        expression: "newAlgData.service"
	      }
	    }, _vm._l((_vm.services), function(service) {
	      return _c('md-option', {
	        attrs: {
	          "value": service
	        }
	      }, [_vm._v(_vm._s(service.name))])
	    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.environment) ? _c('p', {
	      staticClass: "validation-error"
	    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.environment))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Select environment")]), _vm._v(" "), _c('md-select', {
	      model: {
	        value: (_vm.newAlgData.environment),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "environment", $$v)
	        },
	        expression: "newAlgData.environment"
	      }
	    }, _vm._l((_vm.baasEnvs), function(env) {
	      return _c('md-option', {
	        attrs: {
	          "value": env
	        }
	      }, [_vm._v(_vm._s(env.name))])
	    }), 1)], 1), _vm._v(" "), _c('div', {
	      staticClass: "multiselect-container"
	    }, [(_vm.baasValidMessage && _vm.baasValidMessage.protocol) ? _c('p', {
	      staticClass: "validation-error"
	    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.protocol))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Protocol")]), _vm._v(" "), _c('md-select', {
	      model: {
	        value: (_vm.newAlgData.protocol),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "protocol", $$v)
	        },
	        expression: "newAlgData.protocol"
	      }
	    }, _vm._l((_vm.protocols), function(protocol) {
	      return (_vm.protocols) ? _c('md-option', {
	        attrs: {
	          "value": protocol.tag
	        }
	      }, [_vm._v("\n                                " + _vm._s(protocol.name) + "\n                            ")]) : _vm._e()
	    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.invocationType) ? _c('p', {
	      staticClass: "validation-error"
	    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.invocationType))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Invocation Type")]), _vm._v(" "), _c('md-select', {
	      model: {
	        value: (_vm.newAlgData.invocationType),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "invocationType", $$v)
	        },
	        expression: "newAlgData.invocationType"
	      }
	    }, _vm._l((_vm.invocationTypes), function(invocationType) {
	      return (_vm.invocationTypes) ? _c('md-option', {
	        attrs: {
	          "value": invocationType.tag
	        }
	      }, [_vm._v(_vm._s(invocationType.name) + "\n                            ")]) : _vm._e()
	    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.platform) ? _c('p', {
	      staticClass: "validation-error"
	    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.platform))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Platform")]), _vm._v(" "), _c('md-select', {
	      model: {
	        value: (_vm.newAlgData.platform),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "platform", $$v)
	        },
	        expression: "newAlgData.platform"
	      }
	    }, _vm._l((_vm.platforms), function(platform) {
	      return (_vm.platforms) ? _c('md-option', {
	        attrs: {
	          "value": platform.tag
	        }
	      }, [_vm._v("\n                                " + _vm._s(platform.name) + "\n                            ")]) : _vm._e()
	    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.region) ? _c('p', {
	      staticClass: "validation-error"
	    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.region))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Region")]), _vm._v(" "), _c('md-select', {
	      model: {
	        value: (_vm.newAlgData.region),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "region", $$v)
	        },
	        expression: "newAlgData.region"
	      }
	    }, _vm._l((_vm.regionsForPlatforms), function(regionForPlatform) {
	      return (_vm.regionsForPlatforms) ? _c('md-option', {
	        attrs: {
	          "value": regionForPlatform.tag
	        }
	      }, [_vm._v("\n                                " + _vm._s(regionForPlatform.name) + "\n                            ")]) : _vm._e()
	    }), 1)], 1), _vm._v(" "), _c('md-switch', {
	      attrs: {
	        "id": "report-in-slack",
	        "name": "report-in-slack"
	      },
	      model: {
	        value: (_vm.newAlgData.reportInSlack),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "reportInSlack", $$v)
	        },
	        expression: "newAlgData.reportInSlack"
	      }
	    }, [_vm._v("\n                        Report In Slack\n                    ")]), _vm._v(" "), _c('md-switch', {
	      attrs: {
	        "id": "log-problem",
	        "name": "log-problem"
	      },
	      model: {
	        value: (_vm.newAlgData.logProblem),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "logProblem", $$v)
	        },
	        expression: "newAlgData.logProblem"
	      }
	    }, [_vm._v("\n                        Log Problem\n                    ")]), _vm._v(" "), _c('md-switch', {
	      attrs: {
	        "id": "log-result",
	        "name": "log-result"
	      },
	      model: {
	        value: (_vm.newAlgData.logResult),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "logResult", $$v)
	        },
	        expression: "newAlgData.logResult"
	      }
	    }, [_vm._v("\n                        Log Result\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-switch', {
	      attrs: {
	        "id": "log-to-pythia",
	        "name": "log-to-pythia"
	      },
	      model: {
	        value: (_vm.newAlgData.logToPythia),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "logToPythia", $$v)
	        },
	        expression: "newAlgData.logToPythia"
	      }
	    }, [_vm._v("\n                        Log To Pythia\n                    ")]), _vm._v(" "), _c('md-switch', {
	      attrs: {
	        "id": "watched",
	        "name": "log-problem"
	      },
	      model: {
	        value: (_vm.newAlgData.watched),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "watched", $$v)
	        },
	        expression: "newAlgData.watched"
	      }
	    }, [_vm._v("\n                        Watched\n                    ")]), _vm._v(" "), _c('multiselect', {
	      attrs: {
	        "id": "userAudiences",
	        "options": _vm.customerTags,
	        "multiple": true,
	        "taggable": true,
	        "placeholder": "Customer Tag"
	      },
	      on: {
	        "tag": _vm.addTag,
	        "remove": _vm.removeTag
	      },
	      model: {
	        value: (_vm.newAlgData.customerTag),
	        callback: function($$v) {
	          _vm.$set(_vm.newAlgData, "customerTag", $$v)
	        },
	        expression: "newAlgData.customerTag"
	      }
	    })]
	  ], 2) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeAdditionalDialog(false, 'baas')
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    attrs: {
	      "disabled": _vm.baasValidMessage && Object.keys(_vm.baasValidMessage).length > 0
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeAdditionalDialog(true, 'baas')
	      }
	    }
	  }, [_vm._v("Create\n            ")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "maasDialog"
	  }, [_c('md-dialog-title', [_vm._v("Register at maas service")]), _vm._v(" "), _c('md-dialog-content', [(_vm.app) ? _c('form', [_c('div', [_c('md-switch', {
	    attrs: {
	      "id": "configureManually",
	      "name": "configureManually"
	    },
	    model: {
	      value: (_vm.app.configureManually),
	      callback: function($$v) {
	        _vm.$set(_vm.app, "configureManually", $$v)
	      },
	      expression: "app.configureManually"
	    }
	  }, [_vm._v("\n                        Configure manually\n                    ")])], 1), _vm._v(" "), (_vm.services) ? _c('multiselect', {
	    attrs: {
	      "id": "services",
	      "disabled": _vm.app.configureManually,
	      "options": _vm.services,
	      "label": 'name',
	      "placeholder": "Select service"
	    },
	    model: {
	      value: (_vm.app.selectedService),
	      callback: function($$v) {
	        _vm.$set(_vm.app, "selectedService", $$v)
	      },
	      expression: "app.selectedService"
	    }
	  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeAdditionalDialog(false, 'maas')
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeAdditionalDialog(true, 'maas')
	      }
	    }
	  }, [_vm._v("Create")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    staticClass: "preloader"
	  }, [(_vm.pending) ? _c('md-progress', {
	    staticClass: "md-blue",
	    attrs: {
	      "md-indeterminate": ""
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (
	    _vm.isLoggedIn &&
	    (_vm.$route.path.indexOf('/login') !== 0) &
	    (_vm.$route.path.indexOf('/externallogin') !== 0) &
	    (_vm.$route.path.indexOf('/quinyx-sign-in') !== 0) &
	    (_vm.$route.path.indexOf('/activate') !== 0)
	  ) ? _c('wb-nav', {
	    attrs: {
	      "vuexUsing": true,
	      "navbarItems": _vm.navbarItems,
	      "profileMenuItems": _vm.profileMenuItems,
	      "showItems": _vm.isLoggedIn,
	      "navLogo": _vm.logoPath,
	      "mainColor": '#43B3FF',
	      "backgroundColor": '#0a2052'
	    }
	  }) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), (
	    _vm.isLoggedIn &&
	    (_vm.$route.path.indexOf('/login') !== 0) &
	    (_vm.$route.path.indexOf('/externallogin') !== 0) &
	    (_vm.$route.path.indexOf('/quinyx-sign-in') !== 0) &
	    (_vm.$route.path.indexOf('/activate') !== 0)
	  ) ? _c('md-icon', {
	    class: ['notification-icon', _vm.showSidebar ? 'active' : ''],
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleNotification()
	      }
	    }
	  }, [_vm._v("notifications "), _c('i', [_vm._v(_vm._s(_vm.alarmsCount))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slide-left",
	      "enter-active-class": "slideAppear",
	      "leave-active-class": "slideDisappear"
	    }
	  }, [(_vm.showSidebar) ? _c('sidebar', {
	    staticClass: "sidebar",
	    attrs: {
	      "title": _vm.sideBarTitle,
	      "headerColor": '#0098FF',
	      "type": _vm.sideBarType,
	      "data": _vm.sideBarData
	    },
	    on: {
	      "closeSidebar": _vm.closeSidebar
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('md-snackbar', {
	    ref: "snackbar",
	    attrs: {
	      "md-position": 'bottom left',
	      "md-duration": 2000
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.message))])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "auth-area"
	  }, [_c('div', {
	    staticClass: "auth-window auth-window-activate"
	  }, [_c('div', {
	    staticClass: "auth-logo auth-logo-activate"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.logoUrl,
	      "alt": "Widget Brain logo"
	    }
	  })]), _vm._v(" "), (_vm.correctAccess && !_vm.activationSuccess) ? _c('form', {
	    staticClass: "auth-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.activateUser.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "auth-welcome-text"
	  }, [_vm._v("\n          Hi" + _vm._s(this.firstname ? " " + this.firstname + ", " : ", ") + "Welcome\n          to Widget Brain. We've set up an account for you to access\n          " + _vm._s(_vm.application ? " " + _vm.application : "") + ". You just have to pick a\n          username and a strong password.\n        ")]), _vm._v(" "), _c('md-input-container', {
	    class: {
	      valid: _vm.isUsernameValid
	    }
	  }, [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.username),
	      callback: function($$v) {
	        _vm.username = $$v
	      },
	      expression: "username"
	    }
	  })], 1), _vm._v(" "), (_vm.usernameRequirements.length > 0) ? _c('div', [_c('ul', {
	    staticClass: "errors-list"
	  }, _vm._l((_vm.usernameRequirements), function(requirement, index) {
	    return _c('li', {
	      key: index
	    }, [_vm._v("\n              " + _vm._s(requirement) + "\n            ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('md-input-container', {
	    class: {
	      valid: _vm.isPasswordValid
	    },
	    attrs: {
	      "md-has-password": ""
	    }
	  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  })], 1), _vm._v(" "), (_vm.passwordRequirements.length > 0) ? _c('div', [_c('ul', {
	    staticClass: "errors-list"
	  }, _vm._l((_vm.passwordRequirements), function(requirement, index) {
	    return _c('li', {
	      key: index
	    }, [_vm._v("\n              " + _vm._s(requirement) + "\n            ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('md-input-container', {
	    class: {
	      valid: _vm.isPasswordRepeatValid
	    },
	    attrs: {
	      "md-has-password": ""
	    }
	  }, [_c('label', [_vm._v("Repeat password")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.passwordRepeat),
	      callback: function($$v) {
	        _vm.passwordRepeat = $$v
	      },
	      expression: "passwordRepeat"
	    }
	  })], 1), _vm._v(" "), (
	    _vm.passwordRepeatRequirements &&
	    _vm.passwordRepeatRequirements.length > 0
	  ) ? _c('div', [_c('ul', {
	    staticClass: "errors-list"
	  }, _vm._l((_vm.passwordRepeatRequirements), function(requirement, index) {
	    return _c('li', {
	      key: index
	    }, [_vm._v("\n              " + _vm._s(requirement) + "\n            ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "auth-actions"
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary",
	    attrs: {
	      "disabled": !_vm.isUsernameValid || !_vm.isPasswordValid || !_vm.isPasswordRepeatValid,
	      "type": "submit"
	    },
	    on: {
	      "submit": _vm.activateUser
	    }
	  }, [_vm._v("\n            Activate\n          ")])], 1), _vm._v(" "), _vm._m(0)], 1) : _vm._e(), _vm._v(" "), (!_vm.correctAccess && !_vm.activationSuccess) ? _c('div', {
	    staticClass: "auth-welcome-text auth-text-center"
	  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n          We will redirect you to the Login page in\n          "), _c('span', {
	    staticClass: "highlighted"
	  }, [_vm._v(_vm._s(_vm.countDown))]), _vm._v(" second" + _vm._s(_vm.countDown > 1 ? "s" : "") + ". "), _c('br'), _vm._v("\n          Or click the button bellow to redirect now.\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "auth-actions auth-spaced"
	  }, [_c('md-button', {
	    staticClass: "md-raised md-secondary",
	    on: {
	      "click": _vm.redirectToALFA
	    }
	  }, [_vm._v("\n            Redirect Now\n          ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.correctAccess && _vm.activationSuccess) ? _c('div', {
	    staticClass: "auth-welcome-text auth-text-center"
	  }, [_c('p', [_vm._v("Your account has been activated!")]), _vm._v(" "), _c('p', [_vm._v("\n          You will be forwarded to ALFA in\n          "), _c('span', {
	    staticClass: "highlighted"
	  }, [_vm._v(_vm._s(_vm.countDown))]), _vm._v(" second" + _vm._s(_vm.countDown > 1 ? "s" : "") + ". "), _c('br'), _vm._v("\n          Or click the button bellow to redirect now.\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "auth-actions auth-spaced"
	  }, [_c('md-button', {
	    staticClass: "md-raised md-secondary",
	    on: {
	      "click": _vm.redirectToALFA
	    }
	  }, [_vm._v("\n            Redirect Now\n          ")])], 1)]) : _vm._e()])]), _vm._v(" "), _c('md-dialog', {
	    ref: "credentialsDialog"
	  }, [_c('md-dialog-title', [_vm._v(" Credentials ")]), _vm._v(" "), _c('md-dialog-content', [_c('b', [_vm._v("Client ID:")]), _vm._v(" " + _vm._s(_vm.clientId)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client Secret:")]), _vm._v(" " + _vm._s(_vm.clientSecret)), _c('br')]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    on: {
	      "click": _vm.loginUser
	    }
	  }, [_vm._v("Ok")])], 1)], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "terms-of-use"
	  }, [_c('p', [_vm._v("\n            By creating an account, you agree that your personal data will be\n            used as follows:\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Full Name: application personalisation only;")]), _vm._v(" "), _c('li', [_vm._v("\n              Username and email: system monitoring and event logging within\n              Widget Brain apps.\n            ")])]), _vm._v(" "), _c('p', [_vm._v("\n            Your personal data will not be shared with third parties outside\n            of your organization and Widget Brain. If this invite expires,\n            your account details are removed after 7 days.\n          ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n          Looks like your Email or Activation key is invalid or expired.\n          "), _c('br'), _vm._v("\n          Please contact your Administrator for assistance.\n        ")])
	}]}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.column.visible) ? _c('td', {
	    class: [_vm.columnCellClass, (_vm.isEditableFunction || _vm.isEditableBoolean) ? 'column-editable' : 'column-not-editable', 'md-table-cell'],
	    style: ({
	      width: _vm.column.width,
	      'font-size': _vm.fontSize
	    })
	  }, [_c('div', {
	    staticClass: "md-table-cell-container"
	  }, [(_vm.allowTooltips && _vm.row && _vm.row[_vm.column.name] && _vm.row[_vm.column.name] != '' && _vm.column.customTooltip !== false) ? _c('div', {
	    staticClass: "datatable-tooltip"
	  }, [(_vm.column.customTooltip && typeof(_vm.column.customTooltip) === 'function') ? [_vm._v(_vm._s(_vm.column.customTooltip(_vm.row)))] : (_vm.column.customTooltip && typeof(_vm.column.customTooltip) === 'string') ? [_vm._v(_vm._s(_vm.column.customTooltip))] : [_vm._v(_vm._s(_vm.row[_vm.column.name]))]], 2) : _vm._e(), _vm._v(" "), (_vm.column.visible && _vm.column.slotName) ? _c('div', {
	    class: ("table-cell-slot-" + (_vm.column.slotName))
	  }, [_vm._t("default", function() {
	    return [_vm._v("Where is your slot content?")]
	  })], 2) : (_vm.isSimpleCell && !_vm.isEditableFunction && !_vm.isEditableBoolean) ? _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('div', [_vm._v("\n        " + _vm._s(_vm.row[_vm.column.name]) + "\n      ")])]) : (_vm.isSimpleCell && (_vm.isEditableFunction || _vm.isEditableBoolean)) ? _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('div', [(_vm.column.type === 'textarea') ? _c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.row[_vm.column.name]),
	      expression: "row[column.name]"
	    }],
	    attrs: {
	      "disabled": !_vm.isEditableFunction && !_vm.isEditableBoolean,
	      "name": _vm.column.name + _vm.row.id
	    },
	    domProps: {
	      "value": (_vm.row[_vm.column.name])
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.$emit('setRowBlur', _vm.row, _vm.column)
	      },
	      "focus": function($event) {
	        return _vm.$emit('setFocus', _vm.row, _vm.column)
	      },
	      "change": function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.row, _vm.column.name, $event.target.value)
	      }
	    }
	  })]) : (_vm.column.type === 'checkbox') ? _c('div', [_c('div', {
	    staticClass: "md-input-container md-theme-default"
	  }, [_c('div', {
	    staticClass: "md-checkbox md-theme-default",
	    class: {
	      'md-checked': _vm.row[_vm.column.name]
	    },
	    on: {
	      "click": function($event) {
	        _vm.$refs[_vm.column.name + _vm.row.id].click()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "md-checkbox-container",
	    attrs: {
	      "tabindex": "0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.row[_vm.column.name]),
	      expression: "row[column.name]"
	    }],
	    ref: _vm.column.name + _vm.row.id,
	    attrs: {
	      "type": "checkbox",
	      "name": _vm.column.name + _vm.row.id,
	      "tabindex": "-1"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.row[_vm.column.name]) ? _vm._i(_vm.row[_vm.column.name], null) > -1 : (_vm.row[_vm.column.name])
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.row[_vm.column.name],
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.row, _vm.column.name, $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.row, _vm.column.name, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.row, _vm.column.name, $$c)
	        }
	      }, function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	      }]
	    }
	  })])])])]) : (_vm.inputType === 'text') ? _c('div', [_c('div', {
	    staticClass: "md-input-container md-theme-default md-has-value"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.row[_vm.column.name]),
	      expression: "row[column.name]"
	    }],
	    staticClass: "md-input",
	    attrs: {
	      "type": "text",
	      "name": _vm.column.name + _vm.row.id,
	      "disabled": !_vm.isEditableFunction && !_vm.isEditableBoolean
	    },
	    domProps: {
	      "value": (_vm.row[_vm.column.name])
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.$emit('setRowBlur', _vm.row, _vm.column)
	      },
	      "focus": function($event) {
	        return _vm.$emit('setFocus', _vm.row, _vm.column)
	      },
	      "change": function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.row, _vm.column.name, $event.target.value)
	      }
	    }
	  })])]) : (_vm.inputType === 'number') ? _c('div', [_c('div', {
	    staticClass: "md-input-container md-theme-default"
	  }, [(typeof _vm.column.min !== 'undefined' || typeof _vm.column.max !== 'undefined') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.row[_vm.column.name]),
	      expression: "row[column.name]"
	    }],
	    staticClass: "md-input",
	    attrs: {
	      "type": "number",
	      "name": _vm.column.name + _vm.row.id,
	      "disabled": !_vm.isEditableFunction && !_vm.isEditableBoolean,
	      "min": (typeof _vm.column.min == 'function') ? _vm.column.min(_vm.row) : _vm.column.min,
	      "max": (typeof _vm.column.max == 'function') ? _vm.column.max(_vm.row) : _vm.column.max,
	      "oninput": "validity.valid||(value='');"
	    },
	    domProps: {
	      "value": (_vm.row[_vm.column.name])
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.$emit('setRowBlur', _vm.row, _vm.column)
	      },
	      "focus": function($event) {
	        return _vm.$emit('setFocus', _vm.row, _vm.column)
	      },
	      "change": function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.row, _vm.column.name, $event.target.value)
	      }
	    }
	  }) : _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.row[_vm.column.name]),
	      expression: "row[column.name]"
	    }],
	    staticClass: "md-input",
	    attrs: {
	      "type": "number",
	      "name": _vm.column.name + _vm.row.id,
	      "disabled": !_vm.isEditableFunction && !_vm.isEditableBoolean
	    },
	    domProps: {
	      "value": (_vm.row[_vm.column.name])
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.$emit('setRowBlur', _vm.row, _vm.column)
	      },
	      "focus": function($event) {
	        return _vm.$emit('setFocus', _vm.row, _vm.column)
	      },
	      "change": function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.row, _vm.column.name, $event.target.value)
	      }
	    }
	  })])]) : (_vm.inputType === 'checkbox') ? _c('div', [_c('div', {
	    staticClass: "md-input-container md-theme-default"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.row[_vm.column.name]),
	      expression: "row[column.name]"
	    }],
	    staticClass: "md-input",
	    attrs: {
	      "type": "checkbox",
	      "name": _vm.column.name + _vm.row.id,
	      "disabled": !_vm.isEditableFunction && !_vm.isEditableBoolean
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.row[_vm.column.name]) ? _vm._i(_vm.row[_vm.column.name], null) > -1 : (_vm.row[_vm.column.name])
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.$emit('setRowBlur', _vm.row, _vm.column)
	      },
	      "focus": function($event) {
	        return _vm.$emit('setFocus', _vm.row, _vm.column)
	      },
	      "change": [function($event) {
	        var $$a = _vm.row[_vm.column.name],
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.row, _vm.column.name, $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.row, _vm.column.name, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.row, _vm.column.name, $$c)
	        }
	      }, function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	      }]
	    }
	  })])]) : (_vm.inputType === 'password') ? _c('div', [_c('div', {
	    staticClass: "md-input-container md-theme-default"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.row[_vm.column.name]),
	      expression: "row[column.name]"
	    }],
	    staticClass: "md-input",
	    attrs: {
	      "type": "password",
	      "name": _vm.column.name + _vm.row.id,
	      "disabled": !_vm.isEditableFunction && !_vm.isEditableBoolean
	    },
	    domProps: {
	      "value": (_vm.row[_vm.column.name])
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.$emit('setRowBlur', _vm.row, _vm.column)
	      },
	      "focus": function($event) {
	        return _vm.$emit('setFocus', _vm.row, _vm.column)
	      },
	      "change": function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.row, _vm.column.name, $event.target.value)
	      }
	    }
	  })])]) : _vm._e()]), _vm._v(" "), (_vm.row[_vm.column.tooltip]) ? _c('span', {
	    staticClass: "wb-tooltip"
	  }, [_vm._v(_vm._s(_vm.row[_vm.column.tooltip]))]) : _vm._e()]) : (_vm.column.visible && _vm.column.type !== 'boolean' && _vm.column.type !== 'autocomplete' && (_vm.column.type === 'dateWithTime' || _vm.column.type === 'dateFromTo') && !_vm.column.cellTemplate && !_vm.column.isObjectSelection && !_vm.column.isButtonColumn && !_vm.column.isObjectMultiSelection) ? _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('div', [(_vm.column.type === 'dateWithTime') ? _c('div', [_c('date-picker-wrapper', {
	    ref: "datePickerWrapper",
	    staticClass: "datepicker-custom-wrapper",
	    attrs: {
	      "row": _vm.row,
	      "disabled": !_vm.isEditableFunction && !_vm.isEditableBoolean,
	      "placeholder": _vm.dataTimePlaceholder,
	      "datepickerOptions": _vm.column.datepickerOptions,
	      "format": _vm.column.format,
	      "limit": _vm.column.limit
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column, true)
	      }
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.$emit('setRowBlur', _vm.row, _vm.column)
	      }
	    },
	    model: {
	      value: (_vm.row[_vm.column.name]),
	      callback: function($$v) {
	        _vm.$set(_vm.row, _vm.column.name, $$v)
	      },
	      expression: "row[column.name]"
	    }
	  })], 1) : _vm._e()]), _vm._v(" "), (_vm.row[_vm.column.tooltip]) ? _c('span', {
	    staticClass: "wb-tooltip"
	  }, [_vm._v(_vm._s(_vm.row[_vm.column.tooltip]))]) : _vm._e()]) : (_vm.column.visible && _vm.column.type !== 'boolean' && _vm.column.type !== 'autocomplete' && _vm.column.type === 'time' && !_vm.column.cellTemplate && !_vm.column.isObjectSelection && !_vm.column.isButtonColumn && !_vm.column.isObjectMultiSelection) ? _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.row[_vm.column.name]),
	      expression: "row[column.name]"
	    }],
	    staticClass: "md-input",
	    attrs: {
	      "type": "time",
	      "name": _vm.column.name + _vm.row.id,
	      "disabled": !_vm.isEditableFunction && !_vm.isEditableBoolean,
	      "min": (typeof _vm.column.min == 'function') ? _vm.column.min(_vm.row) : _vm.column.min,
	      "max": (typeof _vm.column.max == 'function') ? _vm.column.max(_vm.row) : _vm.column.max,
	      "oninput": "validity.valid||(value='');"
	    },
	    domProps: {
	      "value": (_vm.row[_vm.column.name])
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.$emit('setRowBlur', _vm.row, _vm.column)
	      },
	      "focus": function($event) {
	        return _vm.$emit('setFocus', _vm.row, _vm.column)
	      },
	      "change": function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.row, _vm.column.name, $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.row[_vm.column.tooltip]) ? _c('span', {
	    staticClass: "wb-tooltip"
	  }, [_vm._v(_vm._s(_vm.row[_vm.column.tooltip]))]) : _vm._e()]) : (_vm.column.visible && _vm.column.type !== 'boolean' && _vm.column.type === 'autocomplete' && !(_vm.column.type === 'dateWithTime' && _vm.column.type === 'dateFromTo') && !_vm.column.cellTemplate && !_vm.column.isObjectSelection && !_vm.column.isButtonColumn && !_vm.column.isObjectMultiSelection) ? _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('div', [_c('md-input-container', [_c('md-autocomplete', {
	    attrs: {
	      "fetch": function (q) { return _vm.column.fetchAutoComplete(q, _vm.row, _vm.column); },
	      "print-attribute": "name",
	      "debounce": 100,
	      "disabled": !_vm.isEditableFunction && !_vm.isEditableBoolean
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	      },
	      "focus": function($event) {
	        return _vm.$emit('setFocus', _vm.row, _vm.column)
	      },
	      "selected": function($event) {
	        return _vm.$emit('setRowSelect', _vm.row, _vm.column)
	      }
	    },
	    model: {
	      value: (_vm.row[_vm.column.name]),
	      callback: function($$v) {
	        _vm.$set(_vm.row, _vm.column.name, $$v)
	      },
	      expression: "row[column.name]"
	    }
	  })], 1)], 1), _vm._v(" "), (_vm.row[_vm.column.tooltip]) ? _c('span', {
	    staticClass: "wb-tooltip"
	  }, [_vm._v(_vm._s(_vm.row[_vm.column.tooltip]))]) : _vm._e()]) : (_vm.column.visible && !_vm.column.cellTemplate && _vm.column.type === 'boolean') ? _c('div', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	      }
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.$emit('setRowBlur', _vm.row, _vm.column)
	      }
	    }
	  }, [(_vm.isEditableFunction || _vm.isEditableBoolean) ? _c('md-switch', {
	    model: {
	      value: (_vm.row[_vm.column.name]),
	      callback: function($$v) {
	        _vm.$set(_vm.row, _vm.column.name, $$v)
	      },
	      expression: "row[column.name]"
	    }
	  }, [(_vm.listOfOptionsForSwitch) ? _c('div', [_vm._v(_vm._s(_vm.row[_vm.column.name] ? _vm.listOfOptionsForSwitch[0] : _vm.listOfOptionsForSwitch[1]))]) : _vm._e()]) : _c('div', [(_vm.listOfOptionsForSwitch && _vm.row[_vm.column.name]) ? _c('div', [_vm._v(_vm._s(_vm.listOfOptionsForSwitch[0]))]) : (_vm.listOfOptionsForSwitch && _vm.row[_vm.column.name]) ? _c('div', [_vm._v(_vm._s(_vm.listOfOptionsForSwitch[1]))]) : _c('div', [_vm._v(_vm._s(_vm.row[_vm.column.name]))])])], 1) : (_vm.column.visible && !_vm.column.cellTemplate && _vm.column.isObjectSelection) ? _c('div', [_c('div', {
	    staticClass: "md-select md-theme-default",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('showSelectWindow', $event, _vm.row, _vm.column, _vm.getObjectList, !_vm.isEditableFunction && !_vm.isEditableBoolean)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "md-menu"
	  }, [_c('span', {
	    staticClass: "md-select-value",
	    attrs: {
	      "md-menu-trigger": ""
	    }
	  }, [_vm._v(_vm._s(_vm.computedSelectValue))])])])]) : (_vm.column.visible && !_vm.column.cellTemplate && _vm.column.isObjectMultiSelection) ? _c('div', [(typeof _vm.row[_vm.column.name] !== 'undefined') ? _c('md-select', {
	    attrs: {
	      "name": _vm.column.name,
	      "id": _vm.column.name,
	      "disabled": !_vm.isEditableFunction && !_vm.isEditableBoolean,
	      "multiple": ""
	    },
	    nativeOn: {
	      "blur": function($event) {
	        return _vm.$emit('setRowBlur', _vm.row, _vm.column)
	      }
	    },
	    model: {
	      value: (_vm.row[_vm.column.name]),
	      callback: function($$v) {
	        _vm.$set(_vm.row, _vm.column.name, $$v)
	      },
	      expression: "row[column.name]"
	    }
	  }, [(_vm.getObjectList) ? _vm._l((_vm.getObjectList), function(element) {
	    return (!(element.isHidden && typeof element.isHidden === 'function' && element.isHidden(_vm.row))) ? _c('md-option', {
	      key: element.id,
	      attrs: {
	        "value": element.id
	      },
	      on: {
	        "selected": function($event) {
	          return _vm.$emit('setRowChanged', _vm.row, _vm.column)
	        }
	      }
	    }, [_vm._v(_vm._s(element.name))]) : _vm._e()
	  }) : _vm._e()], 2) : _vm._e()], 1) : (_vm.column.visible && _vm.column.isButtonColumn && !_vm.column.cellTemplate) ? _c('div', [_c('md-button', {
	    staticClass: "md-icon-button",
	    nativeOn: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.column.clickFunction(_vm.row)
	      }
	    }
	  }, [_c('md-icon', [_vm._v(_vm._s(_vm.column.buttonIcon))])], 1)], 1) : (_vm.column.visible && _vm.column.cellTemplate) ? _c('div', {
	    class: (_vm.column.columnClass && typeof _vm.column.columnClass === 'function') ? _vm.column.columnClass(_vm.row) : '',
	    domProps: {
	      "innerHTML": _vm._s((_vm.column.cellTemplate && typeof _vm.column.cellTemplate === 'function') ? _vm.column.cellTemplate(_vm.row) : _vm.column.cellTemplate)
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.column.onClickRow(_vm.row)
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.adjustableColumnWidth && _vm.rowIndex === 0 && _vm.columnIndex > 0) ? _c('div', {
	    class: [_vm.column.name, 'adjustable-column-width-border'],
	    attrs: {
	      "draggable": false
	    },
	    on: {
	      "mousedown": function($event) {
	        return _vm.onmousedownAdjustableBorder(_vm.row, _vm.column, $event)
	      }
	    }
	  }) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-mask",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('closeModal')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._t("header", function() {
	    return [_c('h2', [_vm._v("Filter")])]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body", function() {
	    return [_c('md-input-container', [_c('label', [_vm._v("Column")]), _vm._v(" "), _c('md-select', {
	      model: {
	        value: (_vm.filter.column),
	        callback: function($$v) {
	          _vm.$set(_vm.filter, "column", $$v)
	        },
	        expression: "filter.column"
	      }
	    }, _vm._l((_vm.columns), function(column) {
	      return _c('md-option', {
	        key: column.name,
	        attrs: {
	          "value": column.name
	        },
	        on: {
	          "selected": function($event) {
	            return _vm.setColumnChanged(column)
	          }
	        }
	      }, [_vm._v("\n                  " + _vm._s(column.displayName) + "\n                ")])
	    }), 1)], 1), _vm._v(" "), (!_vm.filter.filterObjectSelection) ? _c('md-input-container', [_c('label', [_vm._v("Condition")]), _vm._v(" "), _c('md-select', {
	      attrs: {
	        "disabled": _vm.filterConditions.length === 0
	      },
	      model: {
	        value: (_vm.filter.filterCondition),
	        callback: function($$v) {
	          _vm.$set(_vm.filter, "filterCondition", $$v)
	        },
	        expression: "filter.filterCondition"
	      }
	    }, _vm._l((_vm.filterConditions), function(filterCondition) {
	      return _c('md-option', {
	        key: filterCondition,
	        attrs: {
	          "value": filterCondition
	        }
	      }, [_vm._v(_vm._s(filterCondition))])
	    }), 1)], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Value")]), _vm._v(" "), (!_vm.filter.filterObjectSelection) ? _c('md-input', {
	      on: {
	        "change": function($event) {
	          return _vm.checkFilter()
	        }
	      },
	      model: {
	        value: (_vm.filter.filterValue),
	        callback: function($$v) {
	          _vm.$set(_vm.filter, "filterValue", $$v)
	        },
	        expression: "filter.filterValue"
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.filter.filterObjectSelection) ? _c('md-select', {
	      attrs: {
	        "multiple": ""
	      },
	      on: {
	        "selected": function($event) {
	          return _vm.checkFilter()
	        }
	      },
	      model: {
	        value: (_vm.selectedFilterValues),
	        callback: function($$v) {
	          _vm.selectedFilterValues = $$v
	        },
	        expression: "selectedFilterValues"
	      }
	    }, _vm._l((_vm.filterValues), function(filterValue, index) {
	      return _c('md-option', {
	        key: index,
	        attrs: {
	          "value": filterValue + ''
	        }
	      }, [_vm._v(_vm._s(filterValue))])
	    }), 1) : _vm._e()], 1)]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._t("footer", function() {
	    return [_c('md-button', {
	      staticClass: "modal-default-button",
	      attrs: {
	        "disabled": _vm.disableOk
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.$emit('processFilterChange', _vm.filter)
	        }
	      }
	    }, [_vm._v("\n              OK\n            ")]), _vm._v(" "), _c('md-button', {
	      staticClass: "modal-default-button",
	      nativeOn: {
	        "click": function($event) {
	          return _vm.$emit('closeModal')
	        }
	      }
	    }, [_vm._v("\n              Cancel\n            ")])]
	  })], 2)])])])])
	},staticRenderFns: []}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin-tab"
	  }, [_c('wb-datatable', _vm._b({
	    attrs: {
	      "searchKey": 'email'
	    },
	    on: {
	      "addEmit": _vm.openCreateDialog,
	      "editEmit": _vm.openUpdateDialog,
	      "deleteEmit": _vm.openConfirmDialog
	    }
	  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
	    ref: "updateDialog"
	  }, [_c('md-dialog-title', [_vm._v("Update User Teams")]), _vm._v(" "), _c('md-dialog-content', {
	    staticStyle: {
	      "height": "1024px"
	    }
	  }, [(_vm.user) ? _c('div', [_c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("User name")]), _vm._v("\n          " + _vm._s(_vm.user.username) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("Email")]), _vm._v("\n          " + _vm._s(_vm.user.email) + "\n        ")]), _vm._v(" "), (_vm.user.team) ? _c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("Team:")]), _vm._v("\n          " + _vm._s(_vm.user.team) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('md-input-container', {
	    staticClass: "md-has-value"
	  }, [_c('label', [_vm._v("Expired Date")]), _vm._v(" "), _c('date-picker', {
	    attrs: {
	      "name": "uniquename",
	      "clear-button": true
	    },
	    model: {
	      value: (_vm.selectedDate),
	      callback: function($$v) {
	        _vm.selectedDate = $$v
	      },
	      expression: "selectedDate"
	    }
	  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeUpdateDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeUpdateDialog(true)
	      }
	    }
	  }, [_vm._v("Update")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "confirmDialog"
	  }, [_c('md-dialog-title', [_vm._v("Are you sure you want to remove this user from the assigned\n      team?")]), _vm._v(" "), _c('md-dialog-content', [(_vm.user) ? _c('form', [_c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("User name")]), _vm._v("\n          " + _vm._s(_vm.user.username) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("Email")]), _vm._v("\n          " + _vm._s(_vm.user.email) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("Email")]), _vm._v("\n          " + _vm._s(_vm.user.team) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(true)
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "createDialog"
	  }, [_c('md-dialog-title', [_vm._v("Create team assignment")]), _vm._v(" "), _c('md-dialog-content', {
	    staticStyle: {
	      "height": "1024px"
	    }
	  }, [_c('div', [_c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "id": "users",
	      "options": _vm.usersCopy,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "Email",
	      "label": "email"
	    },
	    model: {
	      value: (_vm.selectedUser),
	      callback: function($$v) {
	        _vm.selectedUser = $$v
	      },
	      expression: "selectedUser"
	    }
	  })], 1), _vm._v(" "), _c('md-checkbox', {
	    staticClass: "all-teams-checkbox",
	    model: {
	      value: (_vm.allTeams),
	      callback: function($$v) {
	        _vm.allTeams = $$v
	      },
	      expression: "allTeams"
	    }
	  }, [_vm._v("\n          Assign to all teams\n        ")]), _vm._v(" "), _c('md-input-container', {
	    staticClass: "mt-0 pt-0"
	  }, [_c('multiselect', {
	    attrs: {
	      "disabled": _vm.allTeams,
	      "id": "teamName",
	      "options": _vm.userTeams,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "Team",
	      "label": "name"
	    },
	    model: {
	      value: (_vm.selectedTeam),
	      callback: function($$v) {
	        _vm.selectedTeam = $$v
	      },
	      expression: "selectedTeam"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', {
	    staticClass: "md-has-value"
	  }, [_c('label', [_vm._v("Expired Date")]), _vm._v(" "), _c('date-picker', {
	    attrs: {
	      "name": "uniquename",
	      "clear-button": true
	    },
	    model: {
	      value: (_vm.selectedDate),
	      callback: function($$v) {
	        _vm.selectedDate = $$v
	      },
	      expression: "selectedDate"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isNew ? "Create" : "Update"))])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('link', {
	    attrs: {
	      "rel": "stylesheet",
	      "href": "//fonts.googleapis.com/icon?family=Material+Icons"
	    }
	  }), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-fixed-top",
	    style: ({
	      'border-bottom-color': _vm.mainColor ? _vm.mainColor : '#ff9800',
	      'background-color': _vm.backgroundColor ? _vm.backgroundColor : '#fff',
	      '--text-color': _vm.textColor ? _vm.textColor : '#515151',
	      '--main-color': _vm.mainColor ? _vm.mainColor : '#ff9800',
	      '--text-hover-color': _vm.textHoverColor ? _vm.textHoverColor : '#515151',
	      '--separator-color': _vm.separatorColor ? _vm.separatorColor : '#515151',
	    })
	  }, [_c('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [(_vm.navLogo) ? _c('img', {
	    class: ['navbar-brand-image', 'navbar-brand', _vm.showItems ? 'showed-items' : ''],
	    attrs: {
	      "src": _vm.navLogo
	    }
	  }) : (!_vm.usePinkLogo) ? _c('img', {
	    class: ['navbar-brand-image', 'navbar-brand', _vm.showItems ? 'showed-items' : ''],
	    attrs: {
	      "src": __webpack_require__(266)
	    }
	  }) : _c('img', {
	    class: ['navbar-brand-image-pink', 'navbar-brand', _vm.showItems ? 'showed-items' : ''],
	    attrs: {
	      "src": __webpack_require__(265)
	    }
	  })]), _vm._v(" "), (_vm.title) ? _c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.showItems) ? _c('div', {
	    attrs: {
	      "id": "navbarResponsive"
	    }
	  }, [_c('nav', {
	    staticClass: "navbar-nav nav"
	  }, [_vm._l((_vm.navbarItems), function(item, key) {
	    return _c('a', {
	      key: key,
	      class: ['nav-item', 'nav-link', item.active ? 'active' : ''],
	      attrs: {
	        "href": "#"
	      }
	    }, [(item.active) ? _c('a', {
	      style: ({
	        'border-bottom': _vm.mainColor ? '3px solid ' + _vm.mainColor : '3px solid #ff9800',
	        'color': _vm.textHoverColor ? 'var(--text-hover-color)' : '#ff9800'
	      }),
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.itemOnclick(item)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(item.name) + "\n          ")]) : _c('a', {
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.itemOnclick(item)
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(item.name) + "\n          ")])])
	  }), _vm._v(" "), (_vm.showItems) ? _c('div', {
	    staticClass: "navbar-burger"
	  }, [_c('md-menu', {
	    attrs: {
	      "md-align-trigger": "",
	      "md-size": "5"
	    }
	  }, [_c('div', {
	    attrs: {
	      "md-menu-trigger": ""
	    }
	  }, [_vm._v("\n              menu\n            ")]), _vm._v(" "), _c('md-menu-content', {
	    staticClass: "menu-bar"
	  }, _vm._l((_vm.navbarItems), function(item, key) {
	    return _c('md-menu-item', {
	      key: key,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.itemOnclick(item)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "item-txt"
	    }, [_vm._v(_vm._s(item.name))])])
	  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("afterNav"), _vm._v(" "), (_vm.userName) ? _c('div', {
	    staticClass: "user-name"
	  }, [_c('p', [_vm._v(_vm._s(_vm.userName))])]) : _vm._e(), _vm._v(" "), (_vm.showItems) ? _c('div', {
	    staticClass: "navbar-user"
	  }, [_c('md-menu', {
	    attrs: {
	      "md-align-trigger": "",
	      "md-direction": _vm.userMenuDirection
	    }
	  }, [_c('md-button', {
	    staticClass: "md-mini navbar-user-button float-xs-right",
	    attrs: {
	      "md-menu-trigger": ""
	    }
	  }, [_c('md-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('md-menu-content', {
	    staticClass: "menu-bar"
	  }, _vm._l((_vm.profileMenuItems), function(item, key) {
	    return _c('md-menu-item', {
	      key: key,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.profileMenuItemOnClick(item)
	        }
	      }
	    }, [_c('md-icon', [_vm._v(_vm._s(item.icon))]), _vm._v(" "), _c('span', {
	      staticClass: "item-txt"
	    }, [_vm._v(_vm._s(item.name))])], 1)
	  }), 1)], 1)], 1) : _vm._e()], 2)]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin-tab"
	  }, [_c('wb-datatable', _vm._b({
	    attrs: {
	      "searchKey": 'email'
	    },
	    on: {
	      "addEmit": _vm.openCreateDialog,
	      "editEmit": _vm.openUpdateDialog,
	      "deleteEmit": _vm.openConfirmDialog
	    }
	  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
	    ref: "createDialog"
	  }, [_c('md-dialog-title', [_vm._v("Create user")]), _vm._v(" "), _c('md-dialog-content', [_c('form', [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.newUser.user.name),
	      callback: function($$v) {
	        _vm.$set(_vm.newUser.user, "name", $$v)
	      },
	      expression: "newUser.user.name"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.newUser.user.email),
	      callback: function($$v) {
	        _vm.$set(_vm.newUser.user, "email", $$v)
	      },
	      expression: "newUser.user.email"
	    }
	  }), _vm._v(" "), (_vm.errorMessage) ? _c('span', {
	    staticClass: "md-error"
	  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), (_vm.isQuinyx) ? _c('md-input-container', [_c('label', [_vm._v("User ID")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.newUser.user.id),
	      callback: function($$v) {
	        _vm.$set(_vm.newUser.user, "id", $$v)
	      },
	      expression: "newUser.user.id"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', {
	    attrs: {
	      "for": "selectedApp"
	    }
	  }, [_vm._v("Select an application")]), _vm._v(" "), _c('multiselect', {
	    attrs: {
	      "id": "userEmail",
	      "options": _vm.appsCopy,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "Application Name",
	      "label": "Name"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.selectRoleByAppId(_vm.selectedApp)
	      }
	    },
	    model: {
	      value: (_vm.selectedApp),
	      callback: function($$v) {
	        _vm.selectedApp = $$v
	      },
	      expression: "selectedApp"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
	    attrs: {
	      "for": "role"
	    }
	  }, [_vm._v("Set a role")]), _vm._v(" "), _c('md-select', {
	    attrs: {
	      "disabled": !_vm.newUser.appId,
	      "name": "role",
	      "id": "role"
	    },
	    model: {
	      value: (_vm.newUser.role),
	      callback: function($$v) {
	        _vm.$set(_vm.newUser, "role", $$v)
	      },
	      expression: "newUser.role"
	    }
	  }, _vm._l((_vm.roles), function(role, index) {
	    return (_vm.roles) ? _c('md-option', {
	      key: index,
	      attrs: {
	        "value": role
	      }
	    }, [_vm._v(_vm._s(role))]) : _vm._e()
	  }), 1)], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeCreateDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeCreateDialog(true)
	      }
	    }
	  }, [_vm._v("Create")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "updateDialog"
	  }, [_c('md-dialog-title', [_vm._v("Update User")]), _vm._v(" "), _c('md-dialog-content', [(_vm.user) ? _c('form', [_c('md-input-container', [_c('label', [_vm._v("User name")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.user.username),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "username", $$v)
	      },
	      expression: "user.username"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.user.email),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "email", $$v)
	      },
	      expression: "user.email"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Team ID")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.user.teamId),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "teamId", $$v)
	      },
	      expression: "user.teamId"
	    }
	  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [(_vm.user && _vm.user.status !== 'Activated') ? _c('div', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.resendActivationEmail(_vm.user.email)
	      }
	    }
	  }, [_vm._v("Resend activation email")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeUpdateDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeUpdateDialog(true)
	      }
	    }
	  }, [_vm._v("Update")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "confirmDialog"
	  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this user?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      User will permanently be removed from the database\n    ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(true)
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin-tab"
	  }, [_c('wb-datatable', _vm._b({
	    attrs: {
	      "searchKey": 'userEmail'
	    },
	    on: {
	      "addEmit": _vm.openDialog,
	      "editEmit": _vm.openDialog,
	      "deleteEmit": _vm.openConfirmDialog
	    }
	  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
	    ref: "dialog"
	  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create role' : 'Update role'))]), _vm._v(" "), _c('md-dialog-content', [(_vm.role) ? _c('form', [_c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "id": "userEmail",
	      "options": _vm.usersCopy,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "User Email",
	      "label": "email"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.changeUser(_vm.role, _vm.selectedUser)
	      }
	    },
	    model: {
	      value: (_vm.selectedUser),
	      callback: function($$v) {
	        _vm.selectedUser = $$v
	      },
	      expression: "selectedUser"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "id": "appName",
	      "options": _vm.appsCopy,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "App Name",
	      "label": "displayName"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.changeApp(_vm.role, _vm.selectedApp)
	      }
	    },
	    model: {
	      value: (_vm.selectedApp),
	      callback: function($$v) {
	        _vm.selectedApp = $$v
	      },
	      expression: "selectedApp"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.role.role),
	      callback: function($$v) {
	        _vm.$set(_vm.role, "role", $$v)
	      },
	      expression: "role.role"
	    }
	  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    attrs: {
	      "disabled": !_vm.role || !_vm.role.role || !_vm.selectedUser || !_vm.selectedApp
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isNew ? 'Create' : 'Update'))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "confirmDialog"
	  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this role?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      Role will permanently be removed from the database\n    ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(true)
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "header noselect",
	    style: ({
	      'background': (_vm.type === 'application') ? _vm.headerColors[1] : _vm.headerColors[0]
	    })
	  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        "), (_vm.type === 'service') ? _c('md-icon', {
	    staticClass: "edit-icon",
	    nativeOn: {
	      "click": function($event) {
	        return _vm.goToService(_vm.data.id)
	      }
	    }
	  }, [_vm._v("edit")]) : _vm._e(), _vm._v(" "), _c('md-icon', {
	    nativeOn: {
	      "click": function($event) {
	        return _vm.closeSidebar.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.type === 'application') ? _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "tab-tools"
	  }, [_c('div', {
	    class: [_vm.showStatus ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        _vm.showStatus = true
	      }
	    }
	  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
	    class: [!_vm.showStatus ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        _vm.showStatus = false
	      }
	    }
	  }, [_vm._v("\n                Errors\n                "), (_vm.errors && _vm.errors.length > 0) ? _c('i', [_vm._v(_vm._s(_vm.unwatchedErrorsCount))]) : _vm._e()])]), _vm._v(" "), (_vm.showStatus) ? _c('div', [_c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("Status")]), _vm._v(" "), _c('div', [_c('md-icon', {
	    class: [_vm.data.levelOfFunctioning == 1 ? 'active' : '']
	  }, [_vm._v("fiber_manual_record")]), _vm._v(" "), (_vm.data.levelOfFunctioning == 1) ? _c('span', [_vm._v("ONLINE")]) : _c('span', [_vm._v("OFFLINE")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("developers")]), _vm._v(" "), _c('div', _vm._l((_vm.data.developers), function(developer, index) {
	    return _c('p', [_vm._v(_vm._s(developer.name) + "\n                        (" + _vm._s(developer.contactMail) + ")")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("customers")]), _vm._v(" "), _c('div', _vm._l((_vm.data.customers), function(customer, index) {
	    return _c('p', [_vm._v(_vm._s(customer.name) + " (" + _vm._s(customer.contactName) + ":\n                        " + _vm._s(customer.contactMail) + ")")])
	  }), 0)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("services")]), _vm._v(" "), _c('div', _vm._l((_vm.data.services), function(service, index) {
	    return _c('div', {
	      staticClass: "service-item",
	      on: {
	        "click": function($event) {
	          return _vm.selectService(service)
	        }
	      }
	    }, [_c('md-icon', {
	      class: [service.online ? 'active' : '']
	    }, [_vm._v("fiber_manual_record")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(service.name))])], 1)
	  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.showStatus) ? _c('div', _vm._l((_vm.errors), function(message) {
	    return (message.isRead == false) ? _c('div', {
	      staticClass: "details-block notification-item"
	    }, [_c('div', {
	      on: {
	        "click": function($event) {
	          return _vm.toggleMessage(message)
	        }
	      }
	    }, [_c('md-icon', [_vm._v("fiber_manual_record")]), _vm._v(" "), _c('div', {
	      staticClass: "service-name"
	    }, [_vm._v(_vm._s(message.serviceName))]), _vm._v(" "), (message.show) ? _c('div', [_c('div', {
	      staticClass: "time"
	    }, [_c('span', [_vm._v("[" + _vm._s(_vm._f("dateFormat")(message.time)) + "]")])]), _vm._v(" "), _c('div', {
	      staticClass: "service-message"
	    }, [_c('div', {
	      staticClass: "topic"
	    }, [_vm._v(_vm._s(message.topic))]), _vm._v("\n                            " + _vm._s(message.message) + "\n                        ")])]) : _vm._e()], 1)]) : _vm._e()
	  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'service') ? _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "tab-tools"
	  }, [_c('div', {
	    class: [_vm.showStatus ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        _vm.showStatus = true
	      }
	    }
	  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
	    class: [!_vm.showStatus ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        _vm.showStatus = false
	      }
	    }
	  }, [_vm._v("\n                Errors\n                "), (_vm.errors && _vm.errors.length > 0) ? _c('i', [_vm._v(_vm._s(_vm.errors.length))]) : _vm._e()])]), _vm._v(" "), (_vm.showStatus) ? _c('div', [_c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("Status")]), _vm._v(" "), _c('div', [_c('md-icon', {
	    class: [_vm.data.online ? 'active' : '']
	  }, [_vm._v("fiber_manual_record")]), _vm._v(" "), (_vm.data.online) ? _c('span', [_vm._v("ONLINE")]) : _c('span', [_vm._v("OFFLINE")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("since")]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("dateFormat")(_vm.data.startOnline)) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("latest resp.")]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("dateFormat")(_vm.data.latestResponse)) + "\n                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("class")]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.data.class) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("location")]), _vm._v(" "), _c('div', _vm._l((_vm.data.urls), function(url) {
	    return _c('a', {
	      attrs: {
	        "href": url
	      }
	    }, [_vm._v(_vm._s(url) + " ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("version")]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.data.version || '0.0') + "\n                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("developers")]), _vm._v(" "), _c('div', _vm._l((_vm.data.developers), function(developer, index) {
	    return _c('p', [_vm._v(_vm._s(developer.name) + "\n                        (" + _vm._s(developer.contactMail) + ")")])
	  }), 0)]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.data.accuracy) ? _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("accuracy")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("\n                        " + _vm._s(parseFloat(_vm.data.accuracy * 100).toFixed(2) || 0) + "%\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("calls")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("\n                        " + _vm._s(_vm.data.callsCount || 0) + " last 24 hrs\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("Uptime")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("\n                        " + _vm._s(parseInt(_vm.data.uptime) || 0) + "ms\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "details-block"
	  }, [_c('div', {
	    staticClass: "key"
	  }, [_vm._v("response time")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("\n                        " + _vm._s(parseInt(_vm.data.responseTime) || 0) + "ms\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "chart-container"
	  }, [_c('div', {
	    staticClass: "header noselect"
	  }, [_vm._v("\n                    Historical performance\n                    "), _c('md-icon', {
	    nativeOn: {
	      "click": function($event) {
	        return _vm.$emit('showDetailed')
	      }
	    }
	  }, [_vm._v("call_made")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "chart-switcher"
	  }, [_c('div', {
	    class: [_vm.dataChartKey === 'accuracy' ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        return _vm.setChartData(_vm.data.id, 'accuracy')
	      }
	    }
	  }, [_vm._v("Accuracy\n                    ")]), _vm._v(" "), _c('div', {
	    class: [_vm.dataChartKey === 'responseTime' ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        return _vm.setChartData(_vm.data.id, 'responseTime')
	      }
	    }
	  }, [_vm._v("Response Time\n                    ")]), _vm._v(" "), _c('div', {
	    class: [_vm.dataChartKey === 'serviceState' ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        return _vm.setChartData(_vm.data.id, 'serviceState')
	      }
	    }
	  }, [_vm._v("Online/Offline\n                    ")]), _vm._v(" "), _c('div', {
	    class: [_vm.dataChartKey === 'calls' ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        return _vm.setChartData(_vm.data.id, 'calls')
	      }
	    }
	  }, [_vm._v("\n                        Calls\n                    ")])]), _vm._v(" "), _c('line-chart', {
	    staticClass: "line-chart",
	    attrs: {
	      "chart-data": _vm.chartData,
	      "options": _vm.chartOptions,
	      "height": 240
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.showStatus) ? _c('div', _vm._l((_vm.errors), function(message) {
	    return (message.isRead == false) ? _c('div', {
	      staticClass: "details-block notification-item"
	    }, [_c('div', {
	      on: {
	        "click": function($event) {
	          return _vm.toggleMessage(message)
	        }
	      }
	    }, [_c('md-icon', [_vm._v("fiber_manual_record")]), _vm._v(" "), _c('div', {
	      staticClass: "service-name"
	    }, [_vm._v(_vm._s(message.serviceName))]), _vm._v(" "), (message.show) ? _c('div', [_c('div', {
	      staticClass: "time"
	    }, [_c('span', [_vm._v("[" + _vm._s(_vm._f("dateFormat")(message.time)) + "]")])]), _vm._v(" "), _c('div', {
	      staticClass: "service-message"
	    }, [_c('div', {
	      staticClass: "topic"
	    }, [_vm._v(_vm._s(message.topic))]), _vm._v("\n                            " + _vm._s(message.message) + "\n                        ")])]) : _vm._e()], 1)]) : _vm._e()
	  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'notifications') ? _c('div', {
	    staticClass: "content"
	  }, _vm._l((_vm.data), function(message) {
	    return _c('div', {
	      class: ['details-block', 'notification-item', (message.isRead) ? 'isread' : 'unread']
	    }, [_c('div', [_c('md-icon', {
	      staticClass: "check",
	      nativeOn: {
	        "click": function($event) {
	          return _vm.clickOnMessage(message)
	        }
	      }
	    }, [_vm._v("check")]), _vm._v(" "), _c('div', {
	      staticClass: "service-name"
	    }, [_vm._v(_vm._s(message.serviceName))]), _vm._v(" "), _c('div', {
	      staticClass: "time"
	    }, [_c('span', [_vm._v("[" + _vm._s(_vm._f("dateFormat")(message.time)) + "]")])]), _vm._v(" "), _c('div', {
	      staticClass: "service-message"
	    }, [_c('div', {
	      staticClass: "topic"
	    }, [_vm._v(_vm._s(message.topic))]), _vm._v("\n                    " + _vm._s(message.message) + "\n                ")])], 1)])
	  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "notification-bar"
	  }, [_c('md-icon', {
	    staticClass: "check-all",
	    class: {
	      checked: _vm.isAllChecked
	    },
	    nativeOn: {
	      "click": function($event) {
	        return _vm.checkAll.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("check")]), _vm._v(" Mark all as read\n    ")], 1)])
	},staticRenderFns: []}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin"
	  }, [_c('div', {
	    staticClass: "admin-area"
	  }, [_c('div', {
	    staticClass: "admin-triggers"
	  }, [_c('router-link', {
	    staticClass: "admin-trigger",
	    attrs: {
	      "tag": "div",
	      "active-class": "admin-trigger_active",
	      "to": "/admin/users"
	    }
	  }, [_vm._v("Users")]), _vm._v(" "), _c('router-link', {
	    staticClass: "admin-trigger",
	    attrs: {
	      "tag": "div",
	      "active-class": "admin-trigger_active",
	      "to": "/admin/apps"
	    }
	  }, [_vm._v("Apps")]), _vm._v(" "), _c('router-link', {
	    staticClass: "admin-trigger",
	    attrs: {
	      "tag": "div",
	      "active-class": "admin-trigger_active",
	      "to": "/admin/app-groups"
	    }
	  }, [_vm._v("App Groups")]), _vm._v(" "), _c('router-link', {
	    staticClass: "admin-trigger",
	    attrs: {
	      "tag": "div",
	      "active-class": "admin-trigger_active",
	      "to": "/admin/roles"
	    }
	  }, [_vm._v("Roles")]), _vm._v(" "), _c('router-link', {
	    staticClass: "admin-trigger",
	    attrs: {
	      "tag": "div",
	      "active-class": "admin-trigger_active",
	      "to": "/admin/organizations"
	    }
	  }, [_vm._v("Organizations")]), _vm._v(" "), _c('router-link', {
	    staticClass: "admin-trigger",
	    attrs: {
	      "tag": "div",
	      "active-class": "admin-trigger_active",
	      "to": "/admin/organizations-assignments"
	    }
	  }, [_vm._v("Organization Assignments")]), _vm._v(" "), _c('router-link', {
	    staticClass: "admin-trigger",
	    attrs: {
	      "tag": "div",
	      "active-class": "admin-trigger_active",
	      "to": "/admin/team-assignments"
	    }
	  }, [_vm._v("Team Assignments")]), _vm._v(" "), _c('router-link', {
	    staticClass: "admin-trigger",
	    attrs: {
	      "tag": "div",
	      "active-class": "admin-trigger_active",
	      "to": "/admin/teams"
	    }
	  }, [_vm._v("Teams")]), _vm._v(" "), _c('router-link', {
	    staticClass: "admin-trigger",
	    attrs: {
	      "tag": "div",
	      "active-class": "admin-trigger_active",
	      "to": "/admin/auth-configs"
	    }
	  }, [_vm._v("Authorization Configurations")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "admin-tabs"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('router-view')], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "auth-area"
	  }, [_c('div', {
	    staticClass: "auth-window"
	  }, [_c('div', {
	    staticClass: "auth-logo"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.logoUrl,
	      "alt": "Widget Brain logo"
	    }
	  })]), _vm._v(" "), _c('form', {
	    staticClass: "auth-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.resetPassword.apply(null, arguments)
	      }
	    }
	  }, [_c('md-input-container', {
	    attrs: {
	      "md-has-password": ""
	    }
	  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', {
	    attrs: {
	      "md-has-password": ""
	    }
	  }, [_c('label', [_vm._v("Repeat password")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.passwordRepeat),
	      callback: function($$v) {
	        _vm.passwordRepeat = $$v
	      },
	      expression: "passwordRepeat"
	    }
	  })], 1), _vm._v(" "), (_vm.requirements && _vm.requirements.length > 0) ? _c('div', [_c('ul', {
	    staticClass: "errors-list"
	  }, _vm._l((_vm.requirements), function(requirement) {
	    return _c('li', [_vm._v("\n              " + _vm._s(requirement) + "\n            ")])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "auth-actions"
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.password || !!_vm.requirements.length
	    },
	    on: {
	      "submit": _vm.resetPassword
	    }
	  }, [_vm._v("Reset pw")])], 1)], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portal"
	  }, [_c('div', {
	    staticClass: "sub-header container-fluid"
	  }, [_c('div', {
	    staticClass: "title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "tools"
	  }, [_c('div', {
	    staticClass: "search-container"
	  }, [_c('md-input-container', [_c('md-icon', [_vm._v("search")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.searchText),
	      callback: function($$v) {
	        _vm.searchText = $$v
	      },
	      expression: "searchText"
	    }
	  })], 1)], 1), _vm._v(" "), _c('md-icon', {
	    class: {
	      'active': _vm.showSidebar
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.showSidebar = !_vm.showSidebar
	      }
	    }
	  }, [_vm._v("category")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "portal-apps-container"
	  }, [_c('div', {
	    staticClass: "portal-apps",
	    class: {
	      'sidebarShown': _vm.showSidebar
	    }
	  }, _vm._l((_vm.filteredApps), function(app, index) {
	    return (_vm.groupedApps && _vm.hasCategory(app.Category) && app.Category !== 'Admin') ? _c('div', {
	      key: index,
	      staticClass: "portal-app flip-container",
	      attrs: {
	        "ontouchstart": "this.classList.toggle('hover');"
	      }
	    }, [_c('div', {
	      staticClass: "flipper"
	    }, [_c('div', {
	      staticClass: "front"
	    }, [_c('div', {
	      staticClass: "portal-app"
	    }, [_c('div', {
	      staticClass: "portal-app__image"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.getImageSrc(app.image),
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "portal-app__image-placeholder"
	    }, [_vm._v("WB")])]), _vm._v(" "), _c('div', {
	      staticClass: "portal-app__name"
	    }, [_vm._v(_vm._s(app.Name))])])]), _vm._v(" "), _c('div', {
	      staticClass: "back"
	    }, [_c('div', {
	      staticClass: "portal-app"
	    }, [(app.apps) ? _c('div', {
	      staticClass: "portal-app__envs"
	    }, [_c('div', {
	      staticClass: "app__env",
	      class: {
	        disabled: !_vm.isEnvActive('Develop', app.apps)
	      },
	      on: {
	        "click": function($event) {
	          _vm.forward(_vm.getAppByEnv('Develop', app.apps))
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": __webpack_require__(268),
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('br'), _vm._v("\n                                    Dev\n                                ")]), _vm._v(" "), _c('div', {
	      staticClass: "app__env",
	      class: {
	        disabled: !_vm.isEnvActive('Test', app.apps)
	      },
	      on: {
	        "click": function($event) {
	          _vm.forward(_vm.getAppByEnv('Test', app.apps))
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": __webpack_require__(271),
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('br'), _vm._v("\n                                    Test\n                                ")]), _vm._v(" "), _c('div', {
	      staticClass: "app__env",
	      class: {
	        disabled: !_vm.isEnvActive('Acceptance', app.apps)
	      },
	      on: {
	        "click": function($event) {
	          _vm.forward(_vm.getAppByEnv('Acceptance', app.apps))
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": __webpack_require__(267),
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('br'), _vm._v("\n                                    Acc\n                                ")]), _vm._v(" "), _c('div', {
	      staticClass: "app__env",
	      class: {
	        disabled: !_vm.isEnvActive('Production', app.apps)
	      },
	      on: {
	        "click": function($event) {
	          _vm.forward(_vm.getAppByEnv('Production', app.apps))
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": __webpack_require__(269),
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('br'), _vm._v("\n                                    Live\n                                ")])]) : _c('div', {
	      staticClass: "portal-app__no-envs",
	      on: {
	        "click": function($event) {
	          return _vm.forward(app)
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": __webpack_require__(270),
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('br'), _vm._v("\n                                Open app\n                            ")]), _vm._v(" "), _c('div', {
	      staticClass: "portal-app__name"
	    }, [_vm._v(_vm._s(app.Name))])])])])]) : _vm._e()
	  }), 0), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slide-left",
	      "enter-active-class": "slideAppear",
	      "leave-active-class": "slideDisappear"
	    }
	  }, [(_vm.showSidebar) ? _c('div', {
	    staticClass: "portal-apps-sidebar"
	  }, [_c('div', {
	    staticClass: "categories-title"
	  }, [_vm._v("\n                    Categories\n                    "), _c('md-icon', {
	    staticClass: "close-categories",
	    nativeOn: {
	      "click": function($event) {
	        _vm.showSidebar = false
	      }
	    }
	  }, [_vm._v("close")])], 1), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
	    return _c('div', {
	      staticClass: "category"
	    }, [_c('div', {
	      staticClass: "md-checkbox md-theme-default",
	      class: {
	        'md-checked': _vm.localSelectedCategories.includes(cat)
	      },
	      attrs: {
	        "value": cat
	      }
	    }, [_c('div', {
	      staticClass: "md-checkbox-container",
	      attrs: {
	        "tabindex": "0"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.localSelectedCategories),
	        expression: "localSelectedCategories"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "tabindex": "-1",
	        "id": (cat + "-" + index)
	      },
	      domProps: {
	        "value": cat,
	        "checked": Array.isArray(_vm.localSelectedCategories) ? _vm._i(_vm.localSelectedCategories, cat) > -1 : (_vm.localSelectedCategories)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.localSelectedCategories,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = cat,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.localSelectedCategories = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.localSelectedCategories = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.localSelectedCategories = $$c
	          }
	        }
	      }
	    })]), _vm._v(" "), _c('label', {
	      staticClass: "md-checkbox-label",
	      attrs: {
	        "for": (cat + "-" + index)
	      }
	    }, [_vm._v(_vm._s(cat))])])])
	  })], 2) : _vm._e()])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin-tab"
	  }, [_c('wb-datatable', _vm._b({
	    attrs: {
	      "searchKey": 'name'
	    },
	    on: {
	      "addEmit": _vm.openDialog,
	      "editEmit": _vm.openDialog,
	      "deleteEmit": _vm.openConfirmDialog
	    }
	  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
	    ref: "dialog"
	  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create documentation' : 'Update documentation'))]), _vm._v(" "), _c('md-dialog-content', [(_vm.documentation) ? _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.closeDialog(true)
	      }
	    }
	  }, [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.documentation.name),
	      callback: function($$v) {
	        _vm.$set(_vm.documentation, "name", $$v)
	      },
	      expression: "documentation.name"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Collection")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.documentation.collection),
	      callback: function($$v) {
	        _vm.$set(_vm.documentation, "collection", $$v)
	      },
	      expression: "documentation.collection"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "id": "docKey",
	      "options": _vm.keys,
	      "multiple": false,
	      "close-on-select": true,
	      "placeholder": "Key",
	      "label": "Key"
	    },
	    model: {
	      value: (_vm.selectedKey),
	      callback: function($$v) {
	        _vm.selectedKey = $$v
	      },
	      expression: "selectedKey"
	    }
	  })], 1), _vm._v(" "), (_vm.isNew) ? _c('md-input-container', [_c('label', [_vm._v("Position")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "number"
	    },
	    model: {
	      value: (_vm.documentation.position),
	      callback: function($$v) {
	        _vm.$set(_vm.documentation, "position", $$v)
	      },
	      expression: "documentation.position"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('md-switch', {
	    attrs: {
	      "id": "docSecured"
	    },
	    model: {
	      value: (_vm.documentation.secured),
	      callback: function($$v) {
	        _vm.$set(_vm.documentation, "secured", $$v)
	      },
	      expression: "documentation.secured"
	    }
	  }, [_vm._v("Secured")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isNew ? 'Create' : 'Update'))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "confirmDialog"
	  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this documentation?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n            Documentation will permanently be removed from the database\n        ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(true)
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin-tab"
	  }, [_c('wb-datatable', _vm._b({
	    attrs: {
	      "searchKey": 'name'
	    },
	    on: {
	      "addEmit": _vm.openDialog,
	      "editEmit": _vm.openDialog,
	      "deleteEmit": _vm.openConfirmDialog
	    }
	  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
	    ref: "dialog"
	  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create organization' : 'Update organization'))]), _vm._v(" "), _c('md-dialog-content', [(_vm.organization) ? _c('form', [_c('md-input-container', [_c('label', [_vm._v("Organization name")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.organization.name),
	      callback: function($$v) {
	        _vm.$set(_vm.organization, "name", $$v)
	      },
	      expression: "organization.name"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Category")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.organization.category),
	      callback: function($$v) {
	        _vm.$set(_vm.organization, "category", $$v)
	      },
	      expression: "organization.category"
	    }
	  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isNew ? 'Create' : 'Update'))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "confirmDialog"
	  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this organization?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      Organization will permanently be removed from the database\n    ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(true)
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "datepicker"
	  }, [_c('div', {
	    staticClass: "datepicker-visible-temp-date",
	    on: {
	      "click": _vm.clickOnTempDate
	    }
	  }, [_vm._v(_vm._s(_vm.visibleTempDate))]), _vm._v(" "), _c('datepicker', {
	    ref: "datepicker",
	    attrs: {
	      "date": _vm.visibleData,
	      "option": _vm.option,
	      "disabled": _vm.disabled,
	      "limit": _vm.actualLimit
	    },
	    on: {
	      "change": _vm.visibleDataChange
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container-fluid no-padding"
	  }, [_c('md-table-card', [_c('div', {
	    staticClass: "custome-header"
	  }, [(!_vm.isTitleHtml) ? _c('div', {
	    staticClass: "title"
	  }, [_c('p', [_vm._v(_vm._s(_vm.tableName))]), _vm._v(" "), _c('i', {
	    staticClass: "separator"
	  }), _vm._v(" "), (_vm.showVisibleFilteredDataextCounter) ? _c('span', {
	    staticClass: "table-row-counter"
	  }, [_vm._v(_vm._s(_vm.paginatedDataext.length))]) : _vm._e(), _vm._v(" "), (_vm.countTitle) ? _c('span', {
	    staticClass: "counter-title"
	  }, [_vm._v(_vm._s(_vm.countTitle))]) : _vm._e()]) : (_vm.isTitleHtml) ? _c('div', {
	    staticClass: "title title-html",
	    domProps: {
	      "innerHTML": _vm._s(_vm.htmlTitle)
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "tools"
	  }, [(_vm.quickFilter && _vm.quickFilter.title && _vm.quickFilter.property) ? _c('div', {
	    staticClass: "quick-filter"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.quickFilter.value),
	      expression: "quickFilter.value"
	    }],
	    attrs: {
	      "id": "quickFilter",
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.quickFilter.value) ? _vm._i(_vm.quickFilter.value, null) > -1 : (_vm.quickFilter.value)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.quickFilter.value,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.quickFilter, "value", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.quickFilter, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.quickFilter, "value", $$c)
	        }
	      }, _vm.quickFilterChange]
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "quickFilter"
	    }
	  }, [_vm._v(_vm._s(_vm.quickFilter.title))])]) : _vm._e(), _vm._v(" "), (!_vm.disableSearch) ? _c('div', {
	    staticClass: "search-container"
	  }, [_c('md-input-container', [_c('md-icon', [_vm._v("search")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.searchTerm),
	      callback: function($$v) {
	        _vm.searchTerm = $$v
	      },
	      expression: "searchTerm"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasControls && _vm.customHeaderTools) ? _c('div', [_vm._l((_vm.customHeaderTools), function(customHeaderTool, index) {
	    return [(customHeaderTool.type === 'dropdown') ? _c('md-menu', {
	      key: index + 'dropdown',
	      class: [customHeaderTool.className ? customHeaderTool.className : ''],
	      attrs: {
	        "md-align-trigger": ""
	      }
	    }, [_c('md-icon', {
	      attrs: {
	        "md-menu-trigger": ""
	      }
	    }, [_vm._v(_vm._s(customHeaderTool.icon))]), _vm._v(" "), _c('md-menu-content', _vm._l((customHeaderTool.list), function(item, key) {
	      return _c('md-menu-item', {
	        key: key,
	        on: {
	          "click": item.handler
	        }
	      }, [_vm._v(_vm._s(item.name))])
	    }), 1)], 1) : _c('md-button', {
	      key: index + 'icon-button',
	      staticClass: "md-icon-button",
	      class: [customHeaderTool.className ? customHeaderTool.className : ''],
	      on: {
	        "click": customHeaderTool.handler
	      }
	    }, [_c('md-icon', [_vm._v(_vm._s(customHeaderTool.icon))])], 1), _vm._v(" "), (customHeaderTool.tooltip) ? _c('span', {
	      key: index + 'tooltip',
	      staticClass: "wb-tooltip"
	    }, [_vm._v(_vm._s(customHeaderTool.tooltip))]) : _vm._e()]
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasControls && _vm.allowCreation) ? _c('md-button', {
	    staticClass: "md-icon-button",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('addEmit', false)
	      }
	    }
	  }, [_c('md-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasFilter) ? _c('md-button', {
	    staticClass: "md-icon-button show-columns-icon",
	    attrs: {
	      "tabindex": "-1"
	    }
	  }, [_c('md-icon', {
	    nativeOn: {
	      "click": function($event) {
	        return _vm.addFilterCondition()
	      }
	    }
	  }, [_vm._v("filter_list")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
	    staticClass: "md-icon-button show-columns-icon"
	  }, [_c('md-icon', {
	    nativeOn: {
	      "click": function($event) {
	        return _vm.toggleColumnSettings(null)
	      }
	    }
	  }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "component-fade",
	      "mode": "in-out"
	    }
	  }, [(_vm.showColumnSettings) ? _c('div', {
	    staticClass: "select-container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', [(_vm.selectOrUnselectAllColumnsOptionVisible) ? _c('div', [_c('div', {
	    staticClass: "select-container-select-all",
	    on: {
	      "click": function($event) {
	        return _vm.toggleColumnSettings('show all')
	      }
	    }
	  }, [_vm._v("Select all")])]) : _vm._e(), _vm._v(" "), (_vm.selectOrUnselectAllColumnsOptionVisible) ? _c('div', [_c('div', {
	    staticClass: "select-container-unselect-all",
	    on: {
	      "click": function($event) {
	        return _vm.toggleColumnSettings('hide all')
	      }
	    }
	  }, [_vm._v("Unselect all")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.visibleColumns), function(column) {
	    return _c('div', {
	      key: column.name
	    }, [_c('md-checkbox', {
	      on: {
	        "change": function($event) {
	          return _vm.toggleColumnSettings([column.name, column.visible])
	        }
	      },
	      model: {
	        value: (column.visible),
	        callback: function($$v) {
	          _vm.$set(column, "visible", $$v)
	        },
	        expression: "column.visible"
	      }
	    }, [_vm._v(_vm._s(column.displayName))])], 1)
	  })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.filterBy.length > 0) ? _c('div', {
	    staticClass: "filter-container"
	  }, [_vm._l((_vm.filterBy), function(filter, index) {
	    return (!filter.filterObjectSelection) ? _c('md-chip', {
	      key: filter.columnDisplayName,
	      staticClass: "md-chip-filter",
	      attrs: {
	        "md-deletable": ""
	      },
	      on: {
	        "delete": function($event) {
	          return _vm.deleteFilterCondition(filter)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(filter.columnDisplayName) + " " + _vm._s(filter.filterCondition) + " " + _vm._s(filter.filterValue) + "\n            "), _c('md-button', {
	      staticClass: "md-icon-button md-chip-icon-button md-dense",
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editFilterCondition(filter, index)
	        }
	      }
	    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.filterBy), function(filter, index) {
	    return (filter.filterObjectSelection) ? _c('md-chip', {
	      key: filter.columnDisplayName,
	      staticClass: "md-chip-filter",
	      attrs: {
	        "md-deletable": ""
	      },
	      on: {
	        "delete": function($event) {
	          return _vm.deleteFilterCondition(filter)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(filter.columnDisplayName) + " (" + _vm._s(filter.filterValues.length) + ")\n            "), _c('md-button', {
	      staticClass: "md-icon-button md-chip-icon-button md-dense",
	      attrs: {
	        "tabindex": "-1"
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editFilterCondition(filter, index)
	        }
	      }
	    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1) : _vm._e()
	  })], 2) : _vm._e()], 1)]), _vm._v(" "), _c('md-table', {
	    staticClass: "datatable",
	    class: [_vm.height ? 'full-height' : '', _vm.adjustableColumnWidth ? 'adjustable-column-width-table' : ''],
	    style: ({
	      height: _vm.height
	    }),
	    attrs: {
	      "md-sort": _vm.sort.name,
	      "md-sort-type": _vm.sort.type
	    },
	    on: {
	      "sort": _vm.onSort
	    }
	  }, [_c('md-table-header', [_c('md-table-row', [(_vm.hasSelection) ? _c('md-table-head', {
	    staticClass: "select-all",
	    style: ({
	      width: '60px'
	    })
	  }, [(!_vm.disableMultiSelect) ? _c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    on: {
	      "change": _vm.selectAll
	    }
	  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.visibleColumns), function(column) {
	    return (column.visible) ? _c('md-table-head', {
	      key: column.name,
	      class: [(column && column.type && column.type == 'number') ? 'text-align-right' : '', column.name],
	      style: ({
	        'font-size': _vm.fontSize,
	        width: column.width
	      }),
	      attrs: {
	        "md-sort-by": column.name,
	        "data-title": column.displayName
	      }
	    }, [_vm._v("\n            " + _vm._s(column.displayName) + "\n          ")]) : _vm._e()
	  }), _vm._v(" "), (_vm.hasControls && !_vm.disableRowControlls) ? _c('md-table-head', {
	    staticClass: "table-edit-header",
	    attrs: {
	      "md-numeric": ""
	    }
	  }, [_vm._v("\n            Edit\n          ")]) : _vm._e()], 2)], 1), _vm._v(" "), _c('md-table-body', [
	    [_vm._l((_vm.paginatedDataext), function(row, rowIndex) {
	      return [_c('tr', {
	        key: row.id,
	        ref: 'rowItem',
	        refInFor: true,
	        class: ['item-' + row.id, (row && row.customClassName) ? row.customClassName : '', 'md-table-row'],
	        attrs: {
	          "md-item": _vm.paginatedDataext[rowIndex],
	          "draggable": row.draggable,
	          "md-selection": false,
	          "md-auto-select": false,
	          "data-target": row.id
	        },
	        on: {
	          "click": function($event) {
	            return _vm.clickOnRow($event, row.id)
	          },
	          "mouseover": function($event) {
	            return _vm.$emit('mouseOverRow', $event, row)
	          },
	          "mouseleave": function($event) {
	            return _vm.$emit('mouseLeaveRow', $event, row)
	          }
	        },
	        nativeOn: {
	          "dragend": function($event) {
	            return _vm.dragEnd(row, $event)
	          },
	          "dragstart": function($event) {
	            return _vm.dragStart(row, $event)
	          },
	          "dragover": function($event) {
	            return _vm.allowDrop($event)
	          },
	          "drop": function($event) {
	            return _vm.drop()
	          }
	        }
	      }, [(_vm.hasSelection) ? _c('td', {
	        staticClass: "md-table-cell select-column",
	        staticStyle: {
	          "width": "60px"
	        }
	      }, [_c('div', {
	        staticClass: "md-table-cell-container"
	      }, [_c('input', {
	        attrs: {
	          "type": "checkbox",
	          "data-target": row.id
	        },
	        on: {
	          "change": _vm.onSelect
	        }
	      })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column, columnIndex) {
	        return _c('custom-table-cell', {
	          key: column.name,
	          ref: "customTableCell",
	          refInFor: true,
	          attrs: {
	            "hasSelection": _vm.hasSelection,
	            "row": row,
	            "allowTooltips": _vm.allowTooltips,
	            "fontSize": _vm.fontSize,
	            "column": column,
	            "columnIndex": columnIndex,
	            "columnCellClass": _vm.columnCellClasses[column.name],
	            "isSimpleCell": _vm.isSimpleCell[column.name],
	            "isEditableBoolean": _vm.isEditableBoolean[column.name],
	            "dataList0": _vm.dataList0,
	            "dataList1": _vm.dataList1,
	            "dataList2": _vm.dataList2,
	            "dataList3": _vm.dataList3,
	            "objectList": _vm.objectList,
	            "rowIndex": rowIndex,
	            "adjustableColumnWidth": _vm.adjustableColumnWidth,
	            "dataTimePlaceholder": _vm.dataTimePlaceholder,
	            "columns": _vm.visibleColumns
	          },
	          on: {
	            "setRowBlur": _vm.setRowBlur,
	            "setFocus": _vm.setFocus,
	            "setRowChanged": _vm.setRowChanged,
	            "setRowSelect": _vm.setRowSelect,
	            "ondragAdjustableBorder": _vm.ondragAdjustableBorder,
	            "showSelectWindow": _vm.showSelectWindow
	          }
	        }, [(column.slotName) ? _vm._t(column.slotName, function() {
	          return [_vm._v("Where is your slot content?")]
	        }, {
	          "row": row
	        }) : _vm._e()], 2)
	      }), _vm._v(" "), (_vm.hasControls && !_vm.disableRowControlls) ? _c('td', {
	        staticClass: "md-table-cell table-edit-column"
	      }, [_c('div', {
	        staticClass: "md-table-cell-container"
	      }, [_c('md-menu', {
	        staticClass: "tree__item-dropdown",
	        attrs: {
	          "md-align-trigger": "",
	          "md-direction": "bottom left"
	        }
	      }, [_c('md-button', {
	        attrs: {
	          "md-menu-trigger": ""
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            $event.preventDefault();
	          }
	        }
	      }, [_c('md-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('md-menu-content', {
	        staticClass: "data-table-more-vert"
	      }, [_vm._l((_vm.customControls), function(control, key) {
	        return (_vm.customControls && ((typeof control.hide !== 'function' && !control.hide) || (typeof control.hide === 'function' && !control.hide(row)))) ? _c('md-menu-item', {
	          key: key,
	          class: [(control && control.customClassName) ? control.customClassName : '', (row && row.customClassName) ? row.customClassName : ''],
	          on: {
	            "click": function($event) {
	              return control.handler(row, _vm.columns)
	            }
	          }
	        }, [_c('md-icon', {
	          staticClass: "save-button"
	        }, [_vm._v(_vm._s(control.icon))]), _vm._v("\n                        " + _vm._s(control.name) + "\n                      ")], 1) : _vm._e()
	      }), _vm._v(" "), (!_vm.disallowEditing) ? _c('md-menu-item', {
	        staticClass: "editControlButton",
	        class: (row && row.customClassName) ? row.customClassName : '',
	        on: {
	          "click": function($event) {
	            return _vm.$emit('editEmit', row, _vm.columns, false)
	          }
	        }
	      }, [_c('md-icon', {
	        staticClass: "save-button"
	      }, [_vm._v("edit")]), _vm._v("Edit")], 1) : _vm._e(), _vm._v(" "), (!_vm.disallowDeleting) ? _c('md-menu-item', {
	        staticClass: "deleteControlButton",
	        class: (row && row.customClassName) ? row.customClassName : '',
	        on: {
	          "click": function($event) {
	            return _vm.$emit('deleteEmit', row)
	          }
	        }
	      }, [_c('md-icon', {
	        staticClass: "delete-button"
	      }, [_vm._v("delete")]), _vm._v("Delete")], 1) : _vm._e()], 2)], 1)], 1)]) : _vm._e()], 2), _vm._v(" "), _vm._t("sub-row", null, {
	        "row": row
	      })]
	    })], _vm._v(" "), (_vm.selectToOpenObj && _vm.selectToOpenObj.show) ? _c('div', {
	      staticClass: "select-modal",
	      style: ({
	        top: _vm.selectToOpenObj.top,
	        left: _vm.selectToOpenObj.left
	      })
	    }, _vm._l((_vm.selectToOpenObj.objectList), function(item) {
	      return (!(item.isHidden && typeof item.isHidden === 'function' && item.isHidden(_vm.selectToOpenObj.row))) ? _c('div', {
	        key: item.id,
	        on: {
	          "click": function($event) {
	            return _vm.selectValue(item, _vm.selectToOpenObj.row, _vm.selectToOpenObj.column)
	          }
	        }
	      }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]) : _vm._e()
	    }), 0) : _vm._e(), _vm._v(" "), (_vm.selectToOpenObj && _vm.selectToOpenObj.show) ? _c('div', {
	      staticClass: "select-modal-backdrop",
	      on: {
	        "click": _vm.hideSelectWindow
	      }
	    }) : _vm._e()
	  ], 2)], 1), _vm._v(" "), (_vm.pagination) ? _c('md-table-pagination', {
	    attrs: {
	      "md-size": _vm.pagination.size,
	      "md-page": _vm.page,
	      "md-label": "Rows",
	      "md-total": _vm.totalSize,
	      "md-separator": "of",
	      "md-page-options": _vm.pagination.options ? _vm.pagination.options : [_vm.pagination.size]
	    },
	    on: {
	      "pagination": _vm.onPagination
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.showFilterModal) ? _c('filter-modal', {
	    attrs: {
	      "columns": _vm.columns,
	      "data": _vm.dataext,
	      "filter": _vm.selectedFilter,
	      "customFilterOptions": _vm.customFilterOptions
	    },
	    on: {
	      "closeModal": function($event) {
	        return _vm.closeModal()
	      },
	      "processFilterChange": function($event) {
	        return _vm.processFilterChange(arguments[0])
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'alfa-design': _vm.alfaDesign, 'default-design': !_vm.alfaDesign
	    }
	  }, [_c('md-dialog', {
	    ref: "forgotPassword",
	    attrs: {
	      "md-open-from": "#forgotPassword",
	      "md-close-to": "#forgotPassword"
	    }
	  }, [_c('md-dialog-title', [_vm._v("Password reset")]), _vm._v(" "), _c('md-dialog-content', [_c('div', [_vm._v("Please enter your email address.")]), _vm._v(" "), _c('form', {
	    staticClass: "forgot-password-form",
	    class: {
	      'default-forgot-password-dialog-content': !_vm.alfaDesign
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.closeDialog('forgotPassword', true)
	      }
	    }
	  }, [_c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "email",
	      "name": "email"
	    },
	    model: {
	      value: (_vm.forgottenEmail),
	      callback: function($$v) {
	        _vm.forgottenEmail = $$v
	      },
	      expression: "forgottenEmail"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', {
	    staticClass: "forgot-password-actions",
	    class: {
	      'default-forgot-password-actions': !_vm.alfaDesign
	    }
	  }, [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog('forgotPassword', false)
	      }
	    }
	  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog('forgotPassword', true)
	      }
	    }
	  }, [_vm._v("\n        Ok\n      ")])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "auth-area"
	  }, [(_vm.alfaDesign) ? _c('div', {
	    staticClass: "alfa-auth-window"
	  }, [_c('div', {
	    staticClass: "alfa-auth-info"
	  }, [_c('h1', [_vm._v("The algorithm factory")]), _vm._v(" "), _c('h2', [_vm._v("Let's get started")]), _vm._v(" "), _c('div', {
	    staticClass: "line"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "alfa-logo-holder"
	  }, [_c('span', [_c('transition-group', {
	    attrs: {
	      "name": "list-complete"
	    }
	  }, _vm._l((_vm.imagesUrls), function(url, index) {
	    return (index === _vm.imageNum) ? _c('img', {
	      key: index + url,
	      staticClass: "temp-image",
	      attrs: {
	        "src": url,
	        "alt": "Quinyx logo"
	      }
	    }) : _vm._e()
	  }), 0)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "alfa-auth-form"
	  }, [_c('h2', [_vm._v("Enter your credentials")]), _vm._v(" "), _c('form', {
	    staticClass: "auth-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.login.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "custom-input-block"
	  }, [_c('md-input-container', [_c('label', [_vm._v("Email or Username")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "name": "email",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.user.username),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "username", $$v)
	      },
	      expression: "user.username"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "custom-input-block"
	  }, [_c('md-input-container', {
	    attrs: {
	      "md-has-password": ""
	    }
	  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "name": "password",
	      "type": "password"
	    },
	    model: {
	      value: (_vm.user.password),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "password", $$v)
	      },
	      expression: "user.password"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "auth-helpers"
	  }, [_c('div', {
	    staticClass: "auth-helpers-part"
	  }, [(!_vm.isExternal) ? _c('md-checkbox', {
	    model: {
	      value: (_vm.remember),
	      callback: function($$v) {
	        _vm.remember = $$v
	      },
	      expression: "remember"
	    }
	  }, [_vm._v("\n                Remember me\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isExternal) ? _c('md-checkbox', {
	    model: {
	      value: (_vm.rememberAll),
	      callback: function($$v) {
	        _vm.rememberAll = $$v
	      },
	      expression: "rememberAll"
	    }
	  }, [_vm._v("\n                Remember me\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "auth-helpers-part"
	  }, [_c('div', {
	    attrs: {
	      "id": "forgotPassword"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openDialog('forgotPassword')
	      }
	    }
	  }, [_vm._v("\n                Forgot your password\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "auth-actions"
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "submit": _vm.login
	    }
	  }, [_vm._v("\n              Log in\n            ")])], 1), _vm._v(" "), _vm._m(0)])])]) : _c('div', {
	    staticClass: "auth-window"
	  }, [_c('div', {
	    staticClass: "auth-logo"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.logoUrl,
	      "alt": "Quinyx logo"
	    }
	  })]), _vm._v(" "), _c('form', {
	    staticClass: "auth-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.login.apply(null, arguments)
	      }
	    }
	  }, [_c('md-input-container', [_c('label', [_vm._v("Email or Username")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "name": "email",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.user.username),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "username", $$v)
	      },
	      expression: "user.username"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', {
	    attrs: {
	      "md-has-password": ""
	    }
	  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "name": "password",
	      "type": "password"
	    },
	    model: {
	      value: (_vm.user.password),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "password", $$v)
	      },
	      expression: "user.password"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "auth-helpers"
	  }, [_c('div', {
	    staticClass: "auth-helpers-part"
	  }, [(!_vm.isExternal) ? _c('md-checkbox', {
	    model: {
	      value: (_vm.remember),
	      callback: function($$v) {
	        _vm.remember = $$v
	      },
	      expression: "remember"
	    }
	  }, [_vm._v("\n              Remember me\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isExternal) ? _c('md-checkbox', {
	    model: {
	      value: (_vm.rememberAll),
	      callback: function($$v) {
	        _vm.rememberAll = $$v
	      },
	      expression: "rememberAll"
	    }
	  }, [_vm._v("\n              Remember me\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "auth-helpers-part"
	  }, [_c('div', {
	    attrs: {
	      "id": "forgotPassword"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openDialog('forgotPassword')
	      }
	    }
	  }, [_vm._v("\n              Forgot your password\n            ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "auth-actions"
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "submit": _vm.login
	    }
	  }, [_vm._v("\n            Log in\n          ")]), _vm._v(" "), _c('multiselect', {
	    staticClass: "sso-button",
	    attrs: {
	      "options": _vm.ssoOptions,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "Log in With SSO",
	      "selectLabel": "",
	      "label": "name",
	      "deselectLabel": "remove"
	    },
	    model: {
	      value: (_vm.selectedSso),
	      callback: function($$v) {
	        _vm.selectedSso = $$v
	      },
	      expression: "selectedSso"
	    }
	  }), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-primary sso-submit-button",
	    class: {
	      'sso-submit-button-disabled': !_vm.selectedSso
	    },
	    on: {
	      "click": function($event) {
	        return _vm.SSOLogin()
	      }
	    }
	  }, [_c('md-icon', [_vm._v("keyboard_tab")])], 1)], 1), _vm._v(" "), _vm._m(1)], 1)])]), _vm._v(" "), _c('md-dialog', {
	    ref: "errorDialog",
	    class: 'error-dialog'
	  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.dialogErrorMessage))]), _vm._v(" "), _c('md-dialog-content', {
	    staticClass: "error-dialog-content",
	    class: {
	      'default-error-dialog-content': !_vm.alfaDesign
	    }
	  }, [(_vm.dialogErrorCode === 500) ? _c('div', [_c('p', [_vm._v("Please try the following:")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": _vm.systemStatusUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Check system status\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": _vm.faqUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Check FAQ: Why I cannot access my application?\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": 'mailto:' + _vm.widgetBrainSupportEmail
	    }
	  }, [_vm._v("\n              Contact Widget Brain Support\n            ")])])])]) : (_vm.dialogErrorCode === 403) ? _c('div', [_c('p', [_vm._v("Please try the following:")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": _vm.faqUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Check FAQ: Why I cannot access my application?\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": 'mailto:' + _vm.widgetBrainSupportEmail
	    }
	  }, [_vm._v("\n              Contact Widget Brain Support\n            ")])])])]) : (_vm.dialogErrorCode === 401) ? _c('div', [_c('ul', [_c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openDialog('forgotPassword')
	      }
	    }
	  }, [_vm._v("Forgot your password")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": _vm.faqUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v("Check Login FAQ")])])])]) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', {
	    staticClass: "error-dialog-actions",
	    class: {
	      'default-error-dialog-actions': !_vm.alfaDesign
	    }
	  }, [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": _vm.closeErrorDialog
	    }
	  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-demo"
	  }, [_c('h2', [_vm._v("No account yet?")]), _vm._v(" "), _c('a', {
	    staticClass: "request-demo-link",
	    attrs: {
	      "href": "https://widgetbrain.com/demo/",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Request a demo\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "request-demo"
	  }, [_c('a', {
	    staticClass: "request-demo-link",
	    attrs: {
	      "href": "https://widgetbrain.com/demo/",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n            Or request a demo\n          ")])])
	}]}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin-tab teams"
	  }, [_c('wb-datatable', _vm._b({
	    attrs: {
	      "disallowDeleting": true,
	      "disallowEditing": true,
	      "allowCreation": false,
	      "searchKey": 'name',
	      "customControls": [{
	          icon: 'add',
	          name: 'Add parent team',
	          handler: function (row) {
	            _vm.openDialog(row);
	          }
	        },
	        {
	          icon: 'delete',
	          name: 'Remove parent team',
	          handler: function (row) {
	            _vm.openConfirmDialog(row);
	          }
	        } ]
	    }
	  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
	    ref: "dialog"
	  }, [_c('md-dialog-title', [_vm._v("Edit team assignment")]), _vm._v(" "), _c('md-dialog-content', [(_vm.organization) ? _c('form', [_c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("Team name")]), _vm._v("\n          " + _vm._s(_vm.organization.name) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("Team id")]), _vm._v("\n          " + _vm._s(_vm.organization.id) + "\n        ")]), _vm._v(" "), (_vm.organization && _vm.organization.parentTeams && _vm.organization.parentTeams.length > 0) ? _c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("Parent teams")]), _vm._v("\n          " + _vm._s(_vm.organization.parentTeamsNames) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.organization && _vm.organization.childTeams && _vm.organization.childTeams.length > 0) ? _c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("Child teams")]), _vm._v("\n          " + _vm._s(_vm.organization.childTeamsNames) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "options": _vm.newParentTeam,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "label": 'name',
	      "placeholder": "Assign to another parent team",
	      "selectLabel": ""
	    },
	    model: {
	      value: (_vm.newTeam),
	      callback: function($$v) {
	        _vm.newTeam = $$v
	      },
	      expression: "newTeam"
	    }
	  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(true)
	      }
	    }
	  }, [_vm._v("Add")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "confirmDialog"
	  }, [_c('md-dialog-title', [_vm._v("Are you sure you want to remove this team from the selected parent team?")]), _vm._v(" "), _c('md-dialog-content', [(_vm.organization) ? _c('form', [_c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("Team name")]), _vm._v("\n          " + _vm._s(_vm.organization.name) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "teams-list"
	  }, [_c('p', [_vm._v("Team id")]), _vm._v("\n          " + _vm._s(_vm.organization.id) + "\n        ")]), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "options": _vm.parentTeamsList,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "label": 'name',
	      "placeholder": "Remove from parent team",
	      "selectLabel": ""
	    },
	    model: {
	      value: (_vm.oldParentTeam),
	      callback: function($$v) {
	        _vm.oldParentTeam = $$v
	      },
	      expression: "oldParentTeam"
	    }
	  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(true)
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.user) ? _c('div', {
	    staticClass: "my-account-component"
	  }, [_c('h2', {
	    staticClass: "my-account-head-caption"
	  }, [_vm._v("My Account")]), _vm._v(" "), _c('div', {
	    staticClass: "my-account-wrapper"
	  }, [_c('form', {
	    class: ['basic-info-form', {
	      'basic-info-editable': _vm.isBasicInfoEditable
	    }],
	    attrs: {
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.saveBasicInfo.apply(null, arguments)
	      },
	      "reset": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.cancelBasicInfoEditing.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "basic-info-header"
	  }, [_c('h3', [_vm._v("Basic info")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-icon-button",
	    attrs: {
	      "disabled": _vm.isSaving || _vm.isSecurityInfoEditable
	    },
	    on: {
	      "click": _vm.toggleBasicInfoEditableMode
	    }
	  }, [_c('md-icon', [_vm._v("edit")]), _vm._v(" "), _c('md-tooltip', {
	    attrs: {
	      "md-direction": "right",
	      "md-delay": "400"
	    }
	  }, [_vm._v("Edit")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
	    staticClass: "basic-info-input-readonly"
	  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "disabled": _vm.isBasicInfoEditable,
	      "readonly": ""
	    },
	    model: {
	      value: (_vm.user.email),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "email", $$v)
	      },
	      expression: "user.email"
	    }
	  })], 1), _vm._v(" "), (_vm.isBasicInfoEditable) ? _c('p', {
	    staticClass: "basic-info-email-message"
	  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.isBasicInfoEditable) ? _c('md-input-container', {
	    staticClass: "basic-info-input-readonly"
	  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "readonly": ""
	    },
	    model: {
	      value: (_vm.user.name),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "name", $$v)
	      },
	      expression: "user.name"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isBasicInfoEditable) ? _c('md-input-container', {
	    class: {
	      'md-input-invalid': !_vm.isNewNameValid
	    }
	  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "debounce": 500
	    },
	    on: {
	      "input": _vm.validateFullName
	    },
	    nativeOn: {
	      "input": function($event) {
	        _vm.isNewNameValid = false
	      }
	    },
	    model: {
	      value: (_vm.newName),
	      callback: function($$v) {
	        _vm.newName = $$v
	      },
	      expression: "newName"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "md-error"
	  }, [_vm._v(_vm._s(_vm.validationMessageOfNewName))])], 1) : _vm._e(), _vm._v(" "), (_vm.isBasicInfoEditable) ? _c('div', {
	    staticClass: "basic-info-controls"
	  }, [_c('md-button', {
	    staticClass: "md-primary md-raised",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.isNewNameValid
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-default",
	    attrs: {
	      "type": "reset"
	    }
	  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1), _vm._v(" "), _c('form', {
	    staticClass: "security-info-form",
	    attrs: {
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.saveNewPassword.apply(null, arguments)
	      },
	      "reset": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.isSecurityInfoEditable = false
	      }
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', [(!_vm.isSecurityInfoEditable) ? _c('md-button', {
	    staticClass: "md-primary security-info-reset-password-btn",
	    attrs: {
	      "disabled": _vm.isBasicInfoEditable || _vm.isSaving
	    },
	    on: {
	      "click": _vm.togglePasswordChangeMode
	    }
	  }, [_vm._v("\n          Reset password\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isSecurityInfoEditable) ? _c('div', {
	    staticClass: "security-info-passwords-wrapper"
	  }, [_c('md-input-container', {
	    class: {
	      'md-input-invalid': !!_vm.validationMessageOfOldPassword
	    }
	  }, [_c('label', [_vm._v("Old password")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "password",
	      "required": ""
	    },
	    model: {
	      value: (_vm.oldPassword),
	      callback: function($$v) {
	        _vm.oldPassword = $$v
	      },
	      expression: "oldPassword"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "md-error"
	  }, [_vm._v(_vm._s(_vm.validationMessageOfOldPassword))])], 1), _vm._v(" "), _c('md-input-container', {
	    class: {
	      'md-input-invalid': !_vm.isNewPasswordValid
	    }
	  }, [_c('label', [_vm._v("New password")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "debounce": 600,
	      "type": "password",
	      "required": ""
	    },
	    on: {
	      "input": _vm.validateNewPassword
	    },
	    nativeOn: {
	      "input": function($event) {
	        _vm.isNewPasswordValid = false
	      }
	    },
	    model: {
	      value: (_vm.newPassword),
	      callback: function($$v) {
	        _vm.newPassword = $$v
	      },
	      expression: "newPassword"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "md-error"
	  }, [_vm._v(_vm._s(_vm.validationMessageOfNewPassword))])], 1), _vm._v(" "), _c('md-input-container', {
	    class: {
	      'md-input-invalid': !_vm.arePasswordsSame
	    }
	  }, [_c('label', [_vm._v("Confirm new password")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "debounce": 600,
	      "type": "password",
	      "required": ""
	    },
	    on: {
	      "input": _vm.confirmNewPassword
	    },
	    nativeOn: {
	      "input": function($event) {
	        _vm.arePasswordsSame = false
	      }
	    },
	    model: {
	      value: (_vm.confirmPassword),
	      callback: function($$v) {
	        _vm.confirmPassword = $$v
	      },
	      expression: "confirmPassword"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "md-error"
	  }, [_vm._v(_vm._s(_vm.validationMessageOfConfirmePassword))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSecurityInfoEditable) ? _c('div', {
	    staticClass: "security-info-controls"
	  }, [_c('md-button', {
	    staticClass: "md-primary md-raised",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.isReadyToSaveNewPassword
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-default",
	    attrs: {
	      "type": "reset"
	    }
	  }, [_vm._v("Cancel")])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('md-button', {
	    staticClass: "md-primary security-info-reset-password-btn",
	    on: {
	      "click": _vm.resetCredentials
	    }
	  }, [_vm._v("\n                Reset auth0 credentials\n            ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "login-history-wrapper"
	  }, [_c('h3', {
	    staticClass: "login-history-header"
	  }, [_vm._v("Login history")]), _vm._v(" "), (_vm.sortedLogs.length) ? _c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', {
	    staticClass: "login-history-log-success"
	  }, [_vm._v("Success")]), _vm._v(" "), _c('md-table-head', {
	    staticClass: "login-history-log-action"
	  }, [_vm._v("Action")]), _vm._v(" "), _c('md-table-head', {
	    staticClass: "login-history-log-ip"
	  }, [_vm._v("IP")]), _vm._v(" "), _c('md-table-head', {
	    staticClass: "login-history-log-date"
	  }, [_vm._v("When")])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.sortedLogs), function(log) {
	    return _c('md-table-row', {
	      key: log.id
	    }, [_c('md-table-cell', {
	      staticClass: "login-history-log-success"
	    }, [(log.success) ? _c('md-icon', {
	      staticClass: "login-history-success-icon"
	    }, [_vm._v("check")]) : _c('md-icon', {
	      staticClass: "login-history-failure-icon"
	    }, [_vm._v("warning")]), _vm._v(" "), _c('md-tooltip', {
	      attrs: {
	        "md-direction": "left"
	      }
	    }, [_vm._v(_vm._s(log.success ? 'Success' : 'Failure'))])], 1), _vm._v(" "), _c('md-table-cell', {
	      staticClass: "login-history-log-action"
	    }, [_vm._v(_vm._s(log.action))]), _vm._v(" "), _c('md-table-cell', {
	      staticClass: "login-history-log-ip"
	    }, [_vm._v(_vm._s(log.IP))]), _vm._v(" "), _c('md-table-cell', {
	      staticClass: "login-history-log-date"
	    }, [_vm._v("\n              " + _vm._s(log.ago) + "\n              "), _c('md-tooltip', {
	      attrs: {
	        "md-direction": "right"
	      }
	    }, [_vm._v(_vm._s(log.date.toLocaleString()))])], 1)], 1)
	  }), 1)], 1) : _c('div', {
	    staticClass: "login-history-stub"
	  }, [(!_vm.noLogsFound) ? _c('md-spinner', {
	    attrs: {
	      "md-indeterminate": ""
	    }
	  }) : _c('p', {
	    staticClass: "login-history-nothing-to-show"
	  }, [_vm._v("Nothing to show yet...")])], 1)], 1)]), _vm._v(" "), _c('md-dialog', {
	    ref: "credentialsDialog"
	  }, [_c('md-dialog-title', [_vm._v("\n      Your new credentials\n    ")]), _vm._v(" "), _c('md-dialog-content', [_c('b', [_vm._v("Client ID:")]), _vm._v(" " + _vm._s(_vm.clientId)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client Secret:")]), _vm._v(" " + _vm._s(_vm.clientSecret)), _c('br')]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    on: {
	      "click": _vm.closeCredentialsDialog
	    }
	  }, [_vm._v("Ok")])], 1)], 1)], 1) : _c('div', {
	    staticClass: "my-account-loading"
	  }, [_c('md-spinner', {
	    attrs: {
	      "md-size": 150,
	      "md-indeterminate": ""
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('small', [_vm._v("Contact "), _c('a', {
	    attrs: {
	      "href": "mailto:support@widgetbrain.com"
	    }
	  }, [_vm._v("Widget Brain Support")]), _vm._v(" to update your email address.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "security-info-header"
	  }, [_c('h3', [_vm._v("Security")])])
	}]}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cov-vue-date"
	  }, [_c('div', {
	    staticClass: "datepickbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.date.time),
	      expression: "date.time"
	    }],
	    staticClass: "cov-datepicker",
	    style: (_vm.option.inputStyle ? _vm.option.inputStyle : {}),
	    attrs: {
	      "type": "text",
	      "title": "input date",
	      "readonly": "readonly",
	      "placeholder": _vm.option.placeholder,
	      "required": _vm.required
	    },
	    domProps: {
	      "value": (_vm.date.time)
	    },
	    on: {
	      "click": _vm.showCheck,
	      "foucus": _vm.showCheck,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.date, "time", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.showInfo.check) ? _c('div', {
	    staticClass: "datepicker-overlay",
	    style: ({
	      'background': _vm.option.overlayOpacity ? 'rgba(0,0,0,' + _vm.option.overlayOpacity + ')' : 'rgba(0,0,0,0.5)'
	    }),
	    on: {
	      "click": function($event) {
	        return _vm.dismiss($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "cov-date-body",
	    style: ({
	      'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'
	    })
	  }, [_c('div', {
	    staticClass: "cov-date-monthly"
	  }, [_c('div', {
	    staticClass: "cov-date-previous",
	    on: {
	      "click": function($event) {
	        return _vm.nextMonth('pre')
	      }
	    }
	  }, [_vm._v("«")]), _vm._v(" "), _c('div', {
	    staticClass: "cov-date-caption",
	    style: ({
	      'color': _vm.option.color ? _vm.option.color.headerText : '#fff'
	    })
	  }, [_c('span', {
	    on: {
	      "click": _vm.showYear
	    }
	  }, [_c('small', [_vm._v(_vm._s(_vm.checked.year))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    on: {
	      "click": _vm.showMonth
	    }
	  }, [_vm._v(_vm._s(_vm.displayInfo.month))])]), _vm._v(" "), _c('div', {
	    staticClass: "cov-date-next",
	    on: {
	      "click": function($event) {
	        return _vm.nextMonth('next')
	      }
	    }
	  }, [_vm._v("»")])]), _vm._v(" "), (_vm.showInfo.day) ? _c('div', {
	    staticClass: "cov-date-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box"
	  }, [_c('div', {
	    staticClass: "week"
	  }, [_c('ul', _vm._l((_vm.library.week), function(weekie) {
	    return _c('li', [_vm._v(_vm._s(weekie))])
	  }), 0)]), _vm._v(" "), _vm._l((_vm.dayList), function(day) {
	    return _c('div', {
	      staticClass: "day",
	      class: {
	        'checked': day.checked, 'unavailable': day.unavailable, 'passive-day': !(day.inMonth)
	      },
	      style: (day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? {
	        background: _vm.option.color.checkedDay
	      } : {
	        background: '#F50057'
	      }) : {}),
	      attrs: {
	        "track-by": "$index"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.checkDay(day)
	        }
	      }
	    }, [_vm._v(_vm._s(day.value))])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.year) ? _c('div', {
	    staticClass: "cov-date-box list-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box date-list",
	    attrs: {
	      "id": "yearList"
	    }
	  }, _vm._l((_vm.library.year), function(yearItem) {
	    return _c('div', {
	      staticClass: "date-item",
	      attrs: {
	        "track-by": "$index"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setYear(yearItem)
	        }
	      }
	    }, [_vm._v(_vm._s(yearItem))])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.month) ? _c('div', {
	    staticClass: "cov-date-box list-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box date-list"
	  }, _vm._l((_vm.library.month), function(monthItem) {
	    return _c('div', {
	      staticClass: "date-item",
	      attrs: {
	        "track-by": "$index"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setMonth(monthItem)
	        }
	      }
	    }, [_vm._v(_vm._s(monthItem))])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.hour) ? _c('div', {
	    staticClass: "cov-date-box list-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box date-list"
	  }, [_c('div', {
	    staticClass: "watch-box"
	  }, [_c('div', {
	    staticClass: "hour-box"
	  }, [_c('div', {
	    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
	  }), _vm._v(" "), _c('ul', _vm._l((_vm.hours), function(hitem) {
	    return _c('li', {
	      staticClass: "hour-item",
	      class: {
	        'active': hitem.checked
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTime('hour', hitem, _vm.hours)
	        }
	      }
	    }, [_vm._v(_vm._s(hitem.value))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "min-box"
	  }, [_c('div', {
	    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
	  }), _vm._v(" "), _vm._l((_vm.mins), function(mitem) {
	    return _c('div', {
	      staticClass: "min-item",
	      class: {
	        'active': mitem.checked
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTime('min', mitem, _vm.mins)
	        }
	      }
	    }, [_vm._v(_vm._s(mitem.value))])
	  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "button-box"
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        _vm.showInfo.check = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.cancel : 'Cancel'))]), _vm._v(" "), _c('span', {
	    on: {
	      "click": _vm.picked
	    }
	  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.ok : 'Ok'))])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin-tab"
	  }, [_c('wb-datatable', _vm._b({
	    attrs: {
	      "searchKey": 'tagName'
	    },
	    on: {
	      "addEmit": _vm.openDialog,
	      "editEmit": _vm.openDialog,
	      "deleteEmit": _vm.openConfirmDialog
	    }
	  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
	    ref: "dialog"
	  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create authorization config' : 'Update authorization config'))]), _vm._v(" "), _c('md-dialog-content', [_c('form', [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.name),
	      callback: function($$v) {
	        _vm.name = $$v
	      },
	      expression: "name"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Tag Name")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.tagName),
	      callback: function($$v) {
	        _vm.tagName = $$v
	      },
	      expression: "tagName"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "id": "strategy",
	      "options": _vm.strategyOptions,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "Strategy"
	    },
	    model: {
	      value: (_vm.selectedStrategy),
	      callback: function($$v) {
	        _vm.selectedStrategy = $$v
	      },
	      expression: "selectedStrategy"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "id": "strategyType",
	      "options": _vm.strategyTypeOptions,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "Strategy Type"
	    },
	    model: {
	      value: (_vm.selectedStrategyType),
	      callback: function($$v) {
	        _vm.selectedStrategyType = $$v
	      },
	      expression: "selectedStrategyType"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Options JSON")]), _vm._v(" "), _c('md-textarea', {
	    model: {
	      value: (_vm.authOptions),
	      callback: function($$v) {
	        _vm.authOptions = $$v
	      },
	      expression: "authOptions"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    attrs: {
	      "disabled": _vm.name === '' || _vm.tagName === '' || !_vm.selectedStrategy || !_vm.selectedStrategyType || !_vm.authOptions
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isNew ? 'Create' : 'Update'))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "confirmDialog"
	  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this configuration?")]), _vm._v(" "), _c('md-dialog-content', [_c('b', [_vm._v("Name")]), _vm._v(": " + _vm._s(_vm.currentRow ? _vm.currentRow.name : '')), _c('br'), _vm._v(" "), _c('b', [_vm._v("Tag Name")]), _vm._v(": " + _vm._s(_vm.currentRow ? _vm.currentRow.tagName : '')), _c('br'), _vm._v(" "), _c('b', [_vm._v("Strategy")]), _vm._v(": " + _vm._s(_vm.currentRow ? _vm.currentRow.strategy : '')), _c('br'), _vm._v(" "), _c('b', [_vm._v("Strategy Type")]), _vm._v(": " + _vm._s(_vm.currentRow ? _vm.currentRow.strategyType : '')), _c('br'), _vm._v(" "), _c('b', [_vm._v("Options")]), _vm._v(": " + _vm._s(_vm.currentRow ? _vm.currentRow.options : '')), _c('br')]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(true)
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin-tab"
	  }, [_c('wb-datatable', _vm._b({
	    attrs: {
	      "searchKey": 'userEmail'
	    },
	    on: {
	      "addEmit": _vm.openDialog,
	      "editEmit": _vm.openDialog,
	      "deleteEmit": _vm.openConfirmDialog
	    }
	  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
	    ref: "dialog"
	  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create organization assignment' : 'Update organization assignment'))]), _vm._v(" "), _c('md-dialog-content', [(_vm.organizationAssignment) ? _c('form', [_c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "id": "userEmail",
	      "options": _vm.usersCopy,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "User email",
	      "label": "email"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.changeUser(_vm.organizationAssignment, _vm.selectedUser)
	      }
	    },
	    model: {
	      value: (_vm.selectedUser),
	      callback: function($$v) {
	        _vm.selectedUser = $$v
	      },
	      expression: "selectedUser"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
	    attrs: {
	      "id": "organizationName",
	      "options": _vm.organizationsCopy,
	      "multiple": false,
	      "close-on-select": true,
	      "clear-on-select": false,
	      "placeholder": "Organization",
	      "label": "name"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.changeOrganization(_vm.organizationAssignment, _vm.selectedOrganization)
	      }
	    },
	    model: {
	      value: (_vm.selectedOrganization),
	      callback: function($$v) {
	        _vm.selectedOrganization = $$v
	      },
	      expression: "selectedOrganization"
	    }
	  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isNew ? 'Create' : 'Update'))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "confirmDialog"
	  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this organization assignment?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      Organization assignment will permanently be removed from the database\n    ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(true)
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin-tab"
	  }, [_c('wb-datatable', _vm._b({
	    staticClass: "apps-table",
	    attrs: {
	      "searchKey": 'Name'
	    },
	    on: {
	      "addEmit": _vm.openDialog,
	      "editEmit": _vm.openDialog,
	      "deleteEmit": _vm.openConfirmDialog
	    }
	  }, 'wb-datatable', _vm.tableAppProps, false)), _vm._v(" "), _c('md-dialog', {
	    ref: "dialog"
	  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create app group' : 'Update app group'))]), _vm._v(" "), _c('md-dialog-content', [(_vm.appGroup) ? _c('form', [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.appGroup.Name),
	      callback: function($$v) {
	        _vm.$set(_vm.appGroup, "Name", $$v)
	      },
	      expression: "appGroup.Name"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Category")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.appGroup.Category),
	      callback: function($$v) {
	        _vm.$set(_vm.appGroup, "Category", $$v)
	      },
	      expression: "appGroup.Category"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Image")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.appGroup.image),
	      callback: function($$v) {
	        _vm.$set(_vm.appGroup, "image", $$v)
	      },
	      expression: "appGroup.image"
	    }
	  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeDialog(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isNew ? 'Create' : 'Update'))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "confirmDialog"
	  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this app group?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n            App group will permanently be removed from the database. "), _c('br')]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.closeConfirmDialog(true)
	      }
	    }
	  }, [_vm._v("Delete")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('iframe', {
	    staticClass: "neo-login-container",
	    attrs: {
	      "src": _vm.url
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.4b0814fe35b2ce54ce15.js